/* global $, jQuery, kWidget, DocumentTouch, jcf, Hammer, define */

// Moved this to in-page include to prevent JS errors
require('./jquery-accessibleMegaMenu')

function setCarouselActive () {
  const carouselItems = document.querySelectorAll('.carousel-inner .item')
  if (carouselItems.length > 0) {
    carouselItems[0].classList.add('active')
  }
  const carouselIndicators = document.querySelectorAll('.carousel-indicators li')
  if (carouselIndicators.length > 0) {
    carouselIndicators[0].classList.add('active')
  }
}

// From: http://alistapart.com/article/alternate/

function setActiveStyleSheet (title) {
  let i, a
  for (i = 0; (a = document.getElementsByTagName('link')[i]); i++) {
    if (a.getAttribute('rel').indexOf('style') !== -1 && a.getAttribute('title')) {
      a.disabled = a.getAttribute('title') !== title
    }
  }
}

function getActiveStyleSheet () {
  let i, a
  for (i = 0; (a = document.getElementsByTagName('link')[i]); i++) {
    if (a.getAttribute('rel').indexOf('style') !== -1 && a.getAttribute('title') && !a.disabled) return a.getAttribute('title')
  }
  return null
}

function getPreferredStyleSheet () {
  let i, a
  for (i = 0; (a = document.getElementsByTagName('link')[i]); i++) {
    if (a.getAttribute('rel').indexOf('style') !== -1 && a.getAttribute('rel').indexOf('alt') === -1 && a.getAttribute('title')) return a.getAttribute('title')
  }
  return null
}

function createCookie (name, value, days) {
  let expires
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = '; expires=' + date.toUTCString()
  } else {
    expires = ''
  }
  document.cookie = name + '=' + value + expires + '; SameSite=Strict; Secure; Domain=esc.edu; path=/;'
}

function insertModal () {
  const modal = '<div class="modal fade" id="cookieModal" tabindex="-1" role="dialog" aria-labelledby="cookieModalLabel">\n' +
    '    <div class="modal-dialog" role="document">\n' +
    '        <div class="modal-content">\n' +
    '            <div class="modal-header">\n' +
    '                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n' +
    '                <h4 class="modal-title" id="cookieModalLabel">Smart Cookies</h4>\n' +
    '            </div>\n' +
    '            <div class="modal-body">\n' +
    '                <p>They\'re not just in our classes – they help power our website. Cookies and similar tools allow us to better understand the experience of our visitors. By continuing to use this website, you consent to SUNY Empire State College\'s usage of cookies and similar technologies in accordance with the college\'s <a href="https://www.esc.edu/policies/?search=cid%3D35661">Privacy Notice and Cookies Policy</a>.</p>\n' +
    '            </div>\n' +
    '            <div class="modal-footer">\n' +
    '                <button type="button" class="btn btn-primary" onclick="setCookiePermissions(true);">Accept</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div'
  const footer = document.getElementsByTagName('footer')[0]
  let divWrapper
  let modalInsert = false
  if (document.getElementById('wrapper') !== null) {
    divWrapper = document.getElementById('wrapper')
    if (divWrapper.querySelector('footer') !== null) {
      divWrapper.insertAdjacentHTML('beforeend', modal)
      modalInsert = true
    }
  }
  if (modalInsert === false) {
    footer.insertAdjacentHTML('beforeend', modal)
  }
}

function readCookie (name) {
  const nameEQ = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

const setCookiePermissions = function (permission) {
  if (permission) {
    createCookie('cookiePermissions', true, 365)
    $('#cookieModal').modal('hide')
  } else {
    createCookie('cookiePermissions', false, 365)
    $('#cookieModal').modal('hide')
  }
}
window.setCookiePermissions = setCookiePermissions

jQuery(function () {
  insertModal()
  const cookie = readCookie('cookiePermissions')
  const cookiePermissionsSet = !!cookie
  if (!cookiePermissionsSet) {
    $('#cookieModal').modal({ show: true, backdrop: false })
    const cookieDoc = document.getElementById('#cookieModal')
    if (cookieDoc !== null) {
      cookieDoc.focus()
    }
  }
})

jQuery(function () {
  const cookie = readCookie('style')
  const title = cookie || getPreferredStyleSheet()
  setActiveStyleSheet(title)
})

window.addEventListener('pagehide', function () {
  const title = getActiveStyleSheet()
  if (title !== null) {
    createCookie('style', title, 365)
  }
})

/* 2019 Menu Style for /online/ & academic departments
/* https://medium.com/@heyoka/responsive-pure-css-off-canvas-hamburger-menu-aebc8d11d793 */
function toggleContent (e) {
  const type = e.type
  const button = this
  const content = document.querySelector(this.getAttribute('href'))

  // Return if key pressed was not Space Bar or Enter
  if (type === 'keydown' && (e.keyCode !== 13 && e.keyCode !== 32)) {
    return true
  }

  e.preventDefault()

  if (content.getAttribute('aria-hidden') === 'false') {
    content.setAttribute('aria-hidden', 'true')
    button.setAttribute('aria-expanded', 'false')
  } else {
    content.setAttribute('aria-hidden', 'false')
    button.setAttribute('aria-expanded', 'true')
  }
}

function initToggleMenu () {
  const menuToggle = document.querySelector('.menu-toggle')
  if (typeof menuToggle !== 'undefined' && menuToggle !== null) {
    menuToggle.addEventListener('click', toggleContent)
  }
  const menuClose = document.querySelector('.menu-close')
  if (typeof menuClose !== 'undefined' && menuClose !== null) {
    menuClose.addEventListener('click', toggleContent)
  }
}

// Page init functions moved to end

var delay = (function () {
  var timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()

const addBreadcrumbSchema = function () {
  const listElements = []
  let position = 0
  const breadcrumbRoot = document.getElementsByClassName('breadcrumb')[0]
  if (typeof breadcrumbRoot !== 'undefined') {
    Array.prototype.forEach.call(breadcrumbRoot.children, function (li) {
      const element = li.children[0]
      const listElement = {}
      position += 1
      listElement['@type'] = 'ListItem'
      listElement.position = position
      if (typeof element !== 'undefined') {
        listElement.name = element.textContent
        listElement.item = element.href
      } else {
        listElement.name = li.textContent
        listElement.item = document.URL
      }

      listElements.push(listElement)
    })
    if (listElements.length > 0) {
      const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: listElements
      }
      const scriptTag = document.createElement('script')
      scriptTag.type = 'application/ld+json'
      scriptTag.text = JSON.stringify(jsonLd)
      document.head.appendChild(scriptTag)
    }
  }
}

const setInfoBlockImageHeight = function() {
  if (document.querySelector('.information-block') !== null) {
    const infoBlockImage = document.querySelector('.information-block:first-child .information-block-inner div img')
    const imgHeight = infoBlockImage.height


      const otherInfoBlockImages = document.querySelectorAll('.information-block:not(:first-child) .information-block-inner div img')
    if (imgHeight > 0 && otherInfoBlockImages.length > 0) {
      otherInfoBlockImages.forEach(image => { image.style.height = imgHeight + 'px' })
    }
  }
}

const headerResize = function () {
  /* Adjust for breadcrumb and other header height changes */
  let dynamicStyles
  const $header = $('#header')
  const headerHeight = $header.height()
  if ($('#main').length && !($('#hero').length)) {
    $('#main').css('padding-top', headerHeight + 'px')
    /* Create new style header to add dynamic CSS to avoid security error. */
    dynamicStyles = document.createElement('style')
    document.head.appendChild(dynamicStyles)
    dynamicStyles.sheet.insertRule(':target:before { height: ' + $header.height() + 'px; margin: -' + $header.height() + 'px 0 0; content: ""; display: block;}', 0)
  } else if ($('#main').length && $('#hero').length) {
    $('#main').css('padding-top', '0')
    /* Create new style header to add dynamic CSS to avoid security error. */
    dynamicStyles = document.createElement('style')
    document.head.appendChild(dynamicStyles)
    dynamicStyles.sheet.insertRule(':target:before { height: ' + $header.height() + 'px; margin: -' + $header.height() + 'px 0 0; content: ""; display: block;}', 0)
  }

  if ($('#hero').length) {
    const heroHeight = headerHeight
    const $hero = $('#hero')
    /*    if ($('#header .logo').length) {
      heroHeight = $('#header .logo').height()
    } */
    $hero.css('margin-top', heroHeight + 'px')
  }
}

var initMegaMenu = function () {
  // initialize the megamenu

  $('.megamenu').accessibleMegaMenu()

  var siteoptions =
    {
      uuidPrefix: 'sitemenu', // unique ID's are required to indicate aria-owns, aria-controls and aria-labelledby
      menuClass: 'sitemenu', // default css class used to define the megamenu styling
      topNavItemClass: 'sitemenu-top-nav-item', // default css class for a top-level navigation item in the megamenu
      panelClass: 'sitemenu-panel', // default css class for a megamenu panel
      panelGroupClass: 'sitemenu-panel-group', // default css class for a group of items within a megamenu panel
      hoverClass: 'hover', // default css class for the hover state
      focusClass: 'focus', // default css class for the focus state
      openClass: 'open', // default css class for the open state
      openDelay: 500, // default open delay when opening menu via mouseover
      closeDelay: 250 // default open delay when opening menu via mouseover
    }

  $('#nav').accessibleMegaMenu(siteoptions)

  // hack so that the megamenu doesn't show flash of css animation after the page loads.
  setTimeout(function () {
    $('body').removeClass('init')
  }, 500)
}

const addDataSubmenu = function () {
  $('.multilevel-linkul-0').prev().attr('data-submenu', 'true')
}

var initSkipNavigation = function () {
  $('#skiptocontent a').click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = '#' + this.href.split('#')[1]

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
      // when focus leaves this element,
      // remove the tabindex attribute
      $(this).removeAttr('tabindex')
    }).focus() // focus on the content container
  })
}

const setCaptions = function () {
  const picwidth = []
  const containerDiv = document.getElementById('main')
  if (containerDiv !== null) {
    const dvs = containerDiv.getElementsByTagName('div')
    for (let c = 0; c < dvs.length; c++) {
      if (dvs[c].className === 'image-area right' || dvs[c].className === 'image-area left') {
        picwidth[c] = dvs[c].getElementsByTagName('img')[0].clientWidth
        dvs[c].style.width = picwidth[c] + 'px'
      }
    }
  }
}

// fades in video (to avoid flash of poster image)
setTimeout(function () {
  $('.intro-video').addClass('on')
}, 2000)

// ensures that search comes into focus on click in Windows
$('.search-opener').click(function () {
  setTimeout(function () {
    $('.search-close').addClass('active')
    $('.search-form .input-wrap > input').focus()
  }, 500)
})

$('.search-close').click(function () {
  $(this).removeClass('active')
})

const kaltura = function (id, videoUrl, playerControls, autoPlay, playList, playButton, videoPlayer, thumbnail) {
  let button
  const controls = typeof playerControls !== 'undefined' && playerControls === 'true'
  button = typeof playButton !== 'undefined' && playButton === 'true'
  const auto = typeof autoPlay !== 'undefined' && autoPlay === 'true'
  const playlist = typeof playList !== 'undefined' && playList === 'true'
  const enableThumbnail = thumbnail && thumbnail.length > 0
  if (playlist) button = true

  const playerId = 'kaltura_player_' + id
  const kWidgetEmbedSettings = {
    targetId: playerId,
    wid: '_1838561',
    uiconf_id: videoPlayer,
    flashvars: {
      'loadingSpinner.plugin': false,
      controlBarContainer: {
        plugin: controls,
        hover: true
      },
      'ControllerScreenHolder.visible': false,
      'ControllerScreenHolder.includeInLayout': false,
      'largePlayBtn.plugin': button,
      IframeCustomPluginCss1: '/media/css/kaltura-home.css',
      captureClickEventForiOS: true,
      externalInterfaceDisabled: false,
      autoPlay: auto
    },
    params: {
      wmode: 'transparent'
    },
    readyCallback: function (playerId) {
      console.log('kWidget player ready: ' + playerId)
      const kdp = $('#' + playerId).get(0)
      kdp.kBind('doPlay', function () {
        console.log('doPlay called on  ' + playerId)
      })
    }
  }

  if (playlist) {
    kWidgetEmbedSettings.flashvars.playlistAPI = {
      containerPosition: 'bottom',
      layout: 'vertical',
      autoContinue: 'true',
      autoPlay: auto,
      includeInLayout: playlist,
      onPage: 'false',
      kpl0Id: videoUrl
    }
  } else {
    kWidgetEmbedSettings.entry_id = videoUrl
  }

  if (enableThumbnail) {
    kWidgetEmbedSettings.flashvars.thumbnailUrl = thumbnail
  }

  //    console.log(kWidgetEmbedSettings);
  if (typeof kWidget !== 'undefined') {
    kWidget.embed(playerId, kWidgetEmbedSettings)
  }
}

function loadPlayer ($this) {
  const videoUrl = $this.find('.bg-stretch').attr('data-video-src')
  const playerControls = $this.find('.bg-stretch').attr('data-video-controls') || 'true'
  const playButton = $this.find('.bg-stretch').attr('data-video-button') || 'false'
  const autoPlay = $this.find('.bg-stretch').attr('data-video-autoplay') || 'false'
  const playList = $this.find('.bg-stretch').attr('data-video-playlist') || 'false'
  const videoPlayer = $this.find('.bg-stretch').attr('data-video-player') || '40353681'
  const thumbnail = $this.find('.bg-stretch').attr('data-video-thumbnail') || ''

  const $id = $this[0].id
  kaltura($id, videoUrl, playerControls, autoPlay, playList, playButton, videoPlayer, thumbnail)
}

function loadVideo () {
  $('.video-onload').each(function () {
    loadPlayer($(this))
  })
}

// grabs video source when user clicks play and initializes the video
$('.slideshow .video-modal-inline').click(function (e) {
  e.preventDefault()

  const $this = $(this)
  $this.closest('.slide').addClass('video-playing')
  $this.closest('.slideshow').addClass('active')

  loadPlayer($this)
  $this.find('.icon-stop').attr('tabindex', '0')
  $this.find('video').focus()
  $this.find('video').trigger('play')
  setTimeout(function () {
    $this.closest('.slideshow').addClass('visibility-hidden')
  }, 500)
})

$('.slideshow .icon-stop').on('click keypress', function (e) {
  if (e.type === 'click' || e.which === 13) {
    e.preventDefault()
    e.stopPropagation()
    $(this).closest('.video-modal-inline').find('video').trigger('pause')
    const ifrId = $('.slideshow .active iframe')[0].id
    const ifr = document.getElementById(ifrId)
    ifr.parentNode.removeChild(ifr)
    $(this).closest('.slide').removeClass('video-playing')
    $(this).closest('.slideshow').removeClass('active')
    $(this).closest('.icon-stop').removeAttr('tabindex')

    setTimeout(function () {
      $(this).closest('.switcher .active a').focus()
    }, 500)
  }
})

$('.full-width-video .video-modal-inline').on('click keypress', function (e) {
  if (e.type === 'click' || e.which === 13) {
    e.preventDefault()
    const $this = $(this)
    const videoPlaying = $this.closest('.full-width-video').hasClass('video-playing')
    $this.closest('.full-width-video').addClass('video-playing')
    $this.closest('.full-width-video').addClass('active')

    if (!videoPlaying) {
      loadPlayer($this)
    }

    $this.find('.icon-stop').attr('tabindex', '0')
    $this.find('video').focus()
    $this.find('video').trigger('play')
  }
})

$('.full-width-video .icon-stop').on('click keypress', function (e) {
  if (e.type === 'click' || e.which === 13) {
    e.preventDefault()
    e.stopPropagation()
    $(this).closest('.video-modal-inline').find('video').trigger('pause')
    const ifrId = $('.full-width-video.active iframe')[0].id
    const ifr = document.getElementById(ifrId)
    ifr.parentNode.removeChild(ifr)
    $(this).closest('.full-width-video').removeClass('video-playing')
    $(this).closest('.full-width-video').removeClass('active')
    $(this).closest('.icon-stop').removeAttr('tabindex')
  }
})

$('.overlay-top').click(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $(this).closest('.information-blocks').find('.tablet-overlay-inner').append($(this).closest('.information-block').clone())

  $(this).closest('.information-blocks').find('.information-block').removeClass('on')
  $(this).closest('.information-block').addClass('on')
  $(this).closest('.information-blocks').find('.tablet-overlay').addClass('on')

  if ($(window).width() <= 941) {
    var el = $(this).closest('.information-blocks').find('.tablet-overlay')
    var elOffset = el.offset().top
    var elHeight = el.height()
    var windowHeight = $(window).height()
    var offset
    var headerHeight = $('header').height() / 2

    if (elHeight < windowHeight) {
      offset = elOffset - ((windowHeight / 2) - (elHeight / 2))
    } else {
      offset = elOffset
    }
    var speed = 700
    $('html, body').animate({ scrollTop: offset - headerHeight }, speed)
  }
})

$('.overlay-top').click(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $('.information-block').removeClass('active-state')
  $(this).closest('.information-block').addClass('active-state')
})

// tablet functionality on picture blocks with text (found on Admissions page)
$('.tablet-overlay').click(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $(this).removeClass('on')
  $(this).closest('.information-blocks').find('.tablet-overlay-inner .information-block').remove()
  $('.information-block').removeClass('active-state on')
})

var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch

function initAnimTopBar () {
  var win = jQuery(window)
  var header = jQuery('#header')
  var hideBarClass = 'hide-bar'

  var lastScrollTop = 0
  // var timer

  var onState = function () {
    var st = win.scrollTop()

    if (lastScrollTop <= 0) {
      lastScrollTop = 0
    }

    if (st > lastScrollTop) {
      header.addClass(hideBarClass)
    } else {
      header.removeClass(hideBarClass)
    }

    lastScrollTop = st
  }

  onState()
  win.on('scroll resize orientationchange', onState)
}

function initScrollOpacity () {
  var win = jQuery(window)
  // var gapBox = jQuery('#header')
  var main = jQuery('#main')

  jQuery('.scroll-section').each(function () {
    var box = jQuery(this)

    var setState = function () {
      var headerHeight = Math.max(parseFloat(main.css('padding-top')), box.height())

      var boxOffset = box.offset().top + box.height() - headerHeight

      var ratio = 100 / boxOffset
      var percent = ratio * (boxOffset - win.scrollTop())
      var opacityVal = (100 - percent) / 100

      box.css({
        opacity: 1 - opacityVal
      })
    }

    setState()

    win.on('scroll resize orientationchange', setState)
  })
}

// responsive layout handling
function initScrollLayout () {
  var win = jQuery(window)
  var gapBox = jQuery('#header')

  jQuery('.moving-box').each(function () {
    var box = jQuery(this)
    var parent = box.parent()
    var holder = jQuery(box.data('holder'))
    var timer

    box.clone().appendTo(holder)
    $('body').addClass('no-alt-header')

    // handle layout resize
    ResponsiveHelper.addRange({
      '641..': {
        on: function () {
          clearTimeout(timer)
          timer = setTimeout(function () {
            var onScroll = function () {
              var winScrollOffset = win.scrollTop() + gapBox.height()
              var boxOffset = parent.offset().top + parent.height()

              if (winScrollOffset > boxOffset) {
                // box.appendTo(holder);
                $('#header').addClass('hide-breadcrumb')
                $('body').addClass('moving-box-attached')
              } else {
                // box.appendTo(parent);
                $('#header').removeClass('hide-breadcrumb')
                $('body').removeClass('moving-box-attached')
              }
            }

            onScroll()
            win.on('scroll.movedBox resize.movedBox orientationchange.movedBox', onScroll)
          }, 100)
        },
        off: function () {
          clearTimeout(timer)
          timer = setTimeout(function () {
            win.off('scroll.movedBox resize.movedBox orientationchange.movedBox')
            // box.appendTo(parent);
          }, 100)
        }
      }
    })
  })
}

// fade gallery init
function initSlideShow () {
  jQuery('.slideshow').fadeGallery({
    slides: '.slide',
    btnPrev: '.btn-prev',
    btnNext: '.btn-next',
    currentNumber: '.current-num',
    totalNumber: '.total-num',
    pagerLinks: '.switcher li',
    event: 'click',
    useSwipe: true,
    autoRotation: false,
    autoHeight: true,
    switchTime: 500,
    threshold: 20,
    animSpeed: 300,
    handleTouch: true,
    onInit: function (self) {
      initModalGallery(self)

      var pagerLinks = self.pagerLinks
      // pagerLinks.hide();
      pagerLinks.eq(self.currentIndex).show()
    },
    onBeforeChange: function (self) {
      var pagerLinks = self.pagerLinks

      var prevLink = pagerLinks.eq(self.prevIndex)
      var activeLink = pagerLinks.eq(self.currentIndex)

      prevLink.stop().fadeOut({
        duration: self.options.animSpeed / 2,
        complete: function () {
          activeLink.stop().fadeIn({
            duration: self.options.animSpeed / 2,
            complete: function () {
              activeLink.show()
            }
          })
        }
      })
    }
  })

  function initModalGallery (galleryApi) {
    galleryApi.slides.each(function () {
      var slide = jQuery(this)
      var videoTags = slide.find('data-video')
      var btnPlay = slide.find('.video-modal')

      var date = new Date()

      if (videoTags.length !== 0 && btnPlay.length !== 0) {
        var id = date.getTime()
        var popupHolder = jQuery('<div class="popup-holder" />')
        var videoModal = jQuery('<div class="lightbox-video" id="' + id + '">' +
          '<video width="' + videoTags.attr('width') + '" height="' + videoTags.attr('height') + '" controls poster="' + videoTags.attr('poster') + '">' + videoTags.html() + '</video></div>')

        btnPlay.attr('href', '#' + id)

        videoModal.appendTo(popupHolder)
        popupHolder.appendTo(slide)
      }
    })

    initVideoModal()
  }

  function initVideoModal () {
    jQuery('.video-modal').each(function () {
      var link = jQuery(this)
      var id = link.attr('href')
      var video = jQuery(id).find('video')

      link.on('click', function (e) {
        e.preventDefault()

        jQuery.fancybox({
          helpers: {
            overlay: {
              css: {
                background: 'rgba(255, 255, 255, 1)'
              }
            }
          },
          afterShow: function () {
            video[0].play()
          },
          beforeClose: function () {
            video[0].pause()
          },
          href: id
        })
      })
    })
  }
}

/* UNUSED functions
function initShowDescription () {
  var animSpeed = 1500
  jQuery('.video-section .description-box').each(function () {
    jQuery(this).hide().stop().fadeIn(animSpeed)
  })
}

function initVideoStretch () {
  jQuery('.intro-video-holder').videoStretcher({
    video: 'video',
    posterOnTouchDevice: true,
    activeVideoClass: 'active-intro-video',
    loop: false,
    stretch: true,
    onInit: function (self) {
      //            initModalVideo(self);
      initShowDescription()
    }
  })

  function initModalVideo (videoApi) {
    var video = videoApi.video
    var introHolder = videoApi.holder

    jQuery('.modal-opener').each(function () {
      var btnPlay = jQuery(this)
      var date = new Date()

      if (video.length !== 0 && btnPlay.length !== 0) {
        var id = date.getTime()
        btnPlay.attr('href', '#' + id)

        var popupHolder = jQuery('<div class="popup-holder" />')
        var videoHold = jQuery('<div class="lightbox-video" id="' + id + '">')
        var videoModal = jQuery('<video width="' + video.attr('width') + '" height="' + video.attr('height') + '" controls poster="' + video.attr('poster') + '">' + video.html() + '</video>')

        videoModal.appendTo(videoHold)
        videoHold.appendTo(popupHolder)
        popupHolder.appendTo(introHolder)

        btnPlay.on('click', function (e) {
          e.preventDefault()

          jQuery.fancybox({
            helpers: {
              overlay: {
                css: {
                  background: 'rgba(255, 255, 255, 1)'
                }
              }
            },
            afterLoad: function (current, previous) {
              // handle custom close button in inline modal
              if (current.href.indexOf('#') === 0) {
                jQuery(current.href).find('a.close').off('click.fb').on('click.fb', function (e) {
                  e.preventDefault()
                  jQuery.fancybox.close()
                })
              }

              setTimeout(function () {
                if (!isTouchDevice) {
                  video[0].pause()
                }
                videoModal[0].play()
              }, 100)
            },
            beforeClose: function () {
              videoModal[0].pause()
              if (!isTouchDevice) {
                video[0].play()
              }
            },
            href: '#' + id
          })
        })
      }
    })
  }
}
*/

// initialize custom form elements
/*function initCustomForms () {
  jcf.replaceAll()
}*/

// cycle scroll gallery init
function initCycleCarousel () {
  jQuery('.cycle-gallery').scrollAbsoluteGallery({
    mask: '.mask',
    slider: '.slideset',
    slides: '.slide',
    btnPrev: '.btn-prev',
    btnNext: '.btn-next',
    pagerLinks: '.pagination li',
    stretchSlideToMask: true,
    pauseOnHover: true,
    maskAutoSize: true,
    autoRotation: true,
    switchTime: $('.cycle-gallery').data('switchTime') || 5000,
    animSpeed: 300,
    threshold: 800,
    onInit: function (self) {
      $('.btn-next, .btn-prev').hide()

      setTimeout(function () {
        var imgHeight = $('.cycle-gallery').find('img').height() / 2
        $('.btn-next, .btn-prev').css('top', imgHeight)

        $(window).on('orientationchange', function () {
          var imgHeight = $('.cycle-gallery').find('img').height() / 2
          $('.btn-next, .btn-prev').css('top', imgHeight)
        })

        $(window).on('resize', function () {
          var imgHeight = $('.cycle-gallery').find('img').height() / 2
          $('.btn-next, .btn-prev').css('top', imgHeight)
        })

        $('.btn-next, .btn-prev').fadeIn()
      }, 1000)
    }
  })
}

// cycle scroll gallery init
function initPartnershipCarousel () {
  jQuery('.partnerships-gallery').scrollAbsoluteGallery({
    mask: '.mask',
    slider: '.slideset',
    slides: '.slide',
    pagerLinks: '.pagination li',
    stretchSlideToMask: true,
    pauseOnHover: true,
    maskAutoSize: true,
    autoRotation: true,
    switchTime: 5000,
    animSpeed: 300,
    threshold: 800,
    generatePagination: '.pagination'

  })
}

// open-close init
function initOpenClose () {
  jQuery('.open-close').openClose({
    activeClass: 'active',
    opener: '.opener',
    slider: '.slide',
    animSpeed: 400,
    effect: 'slide'
  })
  jQuery('.sub-open-close').openClose({
    activeClass: 'active',
    opener: '.plus-minus',
    slider: '.sub-slide',
    animSpeed: 400,
    effect: 'slide'
  })
}

// accordion menu init
function initAccordion () {
  jQuery('.nav-accordion').customSlideAccordion({
    item: ' > li',
    activeClass: 'ac-active',
    opener: '.ac-opener',
    slider: '.ac-slide',
    animSpeed: 300,
    onShow: function (slide, self) {
    }
  })
}

// fancybox modal popup init
function initLightbox () {
  jQuery('a.lightbox, a[rel*="lightbox"]').fancybox({
    helpers: {
      overlay: {
        css: {
          background: 'rgba(0, 0, 0, 0.65)'
        }
      }
    },
    afterLoad: function (current, previous) {
      // handle custom close button in inline modal
      if (current.href.indexOf('#') === 0) {
        jQuery(current.href).find('a.close').off('click.fb').on('click.fb', function (e) {
          e.preventDefault()
          jQuery.fancybox.close()
        })
      }
    }
  })
}

// mobile menu init
function initMobileNav () {
  jQuery('body').mobileNav({
    hideOnClickOutside: true,
    menuActiveClass: 'nav-active',
    menuOpener: '.nav-opener, .nav-close',
    menuDrop: '.nav-drop',
    onHide: function (self) {
      var drop = self.drop
      var accordion = drop.find('.nav-accordion')
      var accApi = accordion.data('CustomSlideAccordion')

      if (typeof accApi !== 'undefined') {
        accApi.hideAll()
      }
    }
  })
  jQuery('body').mobileNav({
    hideOnClickOutside: true,
    menuActiveClass: 'search-active',
    menuOpener: '.search-opener, .search-close',
    menuDrop: '.search-drop',
    onShow: function (self) {
      if (!isTouchDevice) {
        var drop = self.drop
        var input = drop.find('#search')

        setTimeout(function () {
          input[0].focus()
        }, 50)
      }
    }
  })
}

/* UNUSED function
// initialize fixed blocks on scroll
function initFixedScrollBlock () {
  jQuery('#wrapper').fixedScrollBlock({
    slideBlock: '#header',
    positionType: 'fixed',
    extraOffset: 5
  });
}
*/

// block in viewport init
function initInVieport () {
  jQuery('.viewport-section').itemInViewport({
    activeClass: 'in-viewport',
    once: true
  })
  jQuery('.viewport-banner').itemInViewport({
    activeClass: 'in-viewport'
  })
}

// handle dropdowns on mobile devices
function initTouchNav () {
  jQuery('#nav').each(function () {
    new TouchNav({
      navBlock: this
    })
  })
}

function initRetinaCover () {
  jQuery('.bg-stretch').retinaCover()
}

// add classes if item has dropdown
function initDropDownClasses () {
  jQuery('#nav li').each(function () {
    var item = jQuery(this)
    var drop = item.find('ul')
    var link = item.find('a').eq(0)
    if (drop.length) {
      item.addClass('has-drop-down')
      if (link.length) link.addClass('has-drop-down-a')
    }
  })
}

// add classes on hover/touch
function initCustomHover () {
  jQuery('.js-hover').touchHover()
}

/*
 * jQuery custom Slide Accordion plugin
 */
;(function ($) {
  function CustomSlideAccordion (options) {
    this.options = $.extend({
      addClassBeforeAnimation: false,
      allowClickWhenExpanded: false,
      activeClass: 'active',
      item: '.open-close-section',
      opener: '.opener',
      slider: '.slide',
      animSpeed: 300,
      collapsible: true,
      event: 'click touchend'
    }, options)

    this.init()
  }

  CustomSlideAccordion.prototype = {
    init: function () {
      this.findElements()
      this.makeCallback('onInit', this)
      this.refreshState()
      this.attachEvents()
    },
    findElements: function () {
      this.accordion = jQuery(this.options.holder)
      this.items = this.accordion.find(this.options.item)
      this.openers = this.items.find(this.options.opener)
      this.sliders = this.items.find(this.options.slider)
    },
    attachEvents: function () {
      var self = this

      this.clickHandler = function (e) {
        self.currentInd = self.openers.index(e.currentTarget)
        self.showSlide(e)
      }

      this.openers.on(this.options.event, this.clickHandler)
    },
    showSlide: function (ev) {
      var self = this
      var item = self.items.eq(self.currentInd)
      // var opener = item.find(self.options.opener)
      var slider = item.find(self.options.slider)

      if (!slider.is(':animated')) {
        if (item.hasClass(self.options.activeClass)) {
          if (self.options.allowClickWhenExpanded) {
            return
          } else if (self.options.collapsible) {
            slider.slideUp(self.options.animSpeed, function () {
              hideSlide(slider)
              item.removeClass(self.options.activeClass)
            })
          }
        } else {
          // show active
          var levelItems = self.items.filter('.' + self.options.activeClass)
          var sliderElements = levelItems.find(self.options.slider)
          item.addClass(self.options.activeClass)

          showSlide(slider).hide().slideDown({
            duration: self.options.animSpeed,
            complete: function () {
              self.makeCallback('onShow', slider, self)
            }
          })

          // collapse others
          sliderElements.slideUp(self.options.animSpeed, function () {
            levelItems.removeClass(self.options.activeClass)
            hideSlide(sliderElements)
          })
        }
      }

      ev.preventDefault()
    },
    hideAll: function () {
      var self = this

      var item = this.items.eq(this.currentInd)
      // var opener = item.find(this.options.opener)
      var slider = item.find(this.options.slider)

      slider.slideUp(this.options.animSpeed, function () {
        hideSlide(slider)
        item.removeClass(self.options.activeClass)
      })
    },
    refreshState: function () {
      var self = this
      this.items.each(function () {
        var item = $(this)
        var slider = item.find(self.options.slider)

        if (item.hasClass(self.options.activeClass)) {
          showSlide(slider)
        } else {
          hideSlide(slider)
        }
      })
    },
    destroy: function () {
      this.openers.off(this.options.event, this.clickHandler)
      this.sliders.removeAttr('style')
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments)
        args.shift()
        this.options[name].apply(this, args)
      }
    }
  }

  // accordion slide visibility
  var showSlide = function (slide) {
    return slide.css({ position: '', top: '', left: '', width: '' })
  }
  var hideSlide = function (slide) {
    return slide.show().css({ position: 'absolute', top: -9999, left: -9999, width: slide.width() })
  }

  $.fn.customSlideAccordion = function (options) {
    return this.each(function () {
      $(this).data('CustomSlideAccordion', new CustomSlideAccordion($.extend(options, { holder: this })))
    })
  }
})(jQuery)

/*
 * jQuery Video Resize Plugin
 */
;(function ($) {
  'use strict'

  // var win = jQuery(window)

  function VideoStretcher (options) {
    this.options = $.extend({
      video: 'video',
      playOnBtn: null,
      contactBox: null,
      bgHolder: '<div class="poster-holder" />',
      loop: false,
      posterOnTouchDevice: false,
      activeVideoClass: 'active',
      toggleBox: null,
      parentBox: null,
      parent: 'body',
      animSpeed: 500,
      hideOnClickInside: false,
      stretch: true
    }, options)
    this.init()
  }

  VideoStretcher.prototype = {
    init: function () {
      if (this.options.holder) {
        this.findElements()

        if (!isTouchDevice || !this.options.posterOnTouchDevice) {
          this.attachEvents()
        } else {
          this.createPoster()
        }
      }

      this.holder.data('VideoStretcher', this)
      this.makeCallback('onInit', this)
    },
    findElements: function () {
      this.holder = jQuery(this.options.holder)
      this.playOnBtn = this.holder.find(this.options.playOnBtn)
      this.contactBox = jQuery(this.options.contactBox)
      this.video = this.holder.find('video').eq(0)
      this.ratio = this.video.attr('width') / this.video.attr('height')

      this.parentBox = this.holder.closest(this.options.parentBox)
      this.toggleBox = this.holder.find(this.options.toggleBox)

      this.parent = jQuery(this.options.parent)

      this.loopFlag = false
    },
    createPoster: function () {
      var posterSrc = this.video.attr('poster')
      var bgHolder = jQuery(this.options.bgHolder)

      bgHolder.css({
        backgroundImage: 'url(' + posterSrc + ')'
      })

      bgHolder.insertBefore(this.video)
      this.video.remove()
    },
    attachEvents: function () {
      var self = this

      this.resizeHandler = function () {
        clearTimeout(self.resizeTimer)
        self.resizeTimer = setTimeout(function () {
          self.onResize()
        }, 100)
      }

      this.playHandler = function (e) {
        e.preventDefault()

        if (self.toggleBox.length !== 0) {
          if (self.parent.hasClass(self.options.activeVideoClass)) {
            self.showBox()
          } else {
            self.hideBox()
          }
        }

        self.loopVideo()
      }

      this.insideClickHandler = function (e) {
        if (self.options.hideOnClickInside) {
          var target = jQuery(e.target)
          var holder = self.parentBox.length !== 0 ? self.parentBox : self.holder

          // if (target.is(holder) && target.closest(holder).length && self.parent.hasClass(self.options.activeVideoClass)) {
          if (target.closest(holder).length && self.parent.hasClass(self.options.activeVideoClass)) {
            self.showBox()
          }
        }
      }

      if (this.options.loop && !this.loopFlag && this.playOnBtn.length === 0) {
        this.loopFlag = true

        this.loopVideo()
      }

      if (this.options.stretch) {
        jQuery(window).on('load resize orientationchange', this.resizeHandler)
        this.resizeHandler()
      }

      this.playOnBtn.on('click', this.playHandler)
      jQuery(document).on('click touchstart', this.insideClickHandler)
    },
    hideBox: function () {
      var self = this

      this.toggleBox.fadeOut({
        duration: this.options.animSpeed,
        complete: function () {
          self.parent.addClass(self.options.activeVideoClass)
        }
      })
    },
    showBox: function () {
      var self = this
      this.parent.removeClass(this.options.activeVideoClass)

      this.toggleBox.fadeIn({
        duration: this.options.animSpeed,
        complete: function () {
          self.video[0].pause()
        }
      })
    },
    loopVideo: function () {
      var self = this

      if (this.contactBox.length !== 0 && !this.parent.hasClass(this.options.activeVideoClass)) {
        var contactVideoApi = this.contactBox.data('VideoStretcher')
        var contactVideo = this.contactBox.find('video')

        this.contactBox.fadeOut({
          duration: this.options.animSpeed,
          complete: function () {
            if (contactVideo.length !== 0) {
              self.parent.removeClass(contactVideoApi.options.activeVideoClass)
              contactVideo.get(0).pause()
            }
          }
        })
      }

      // this.parent.addClass(this.options.activeVideoClass);

      this.video[0].play()

      this.video[0].addEventListener('ended', function () {
        self.video[0].play()
      }, false)
    },
    onResize: function () {
      if (this.ratio) {
        var styles = this.getDimensions({
          maskWidth: this.holder.innerWidth(),
          maskHeight: this.holder.innerHeight()
        })

        this.video.css({
          width: styles.width,
          height: styles.height,
          top: styles.top,
          left: styles.left
        }).attr({
          width: styles.width,
          height: styles.height
        })
      }
    },
    getDimensions: function (data) {
      // calculate element coords to fit in mask
      var slideWidth = data.maskWidth
      var slideHeight = slideWidth / this.ratio

      if (slideHeight < data.maskHeight) {
        slideHeight = data.maskHeight
        slideWidth = slideHeight * this.ratio
      }

      return {
        width: slideWidth,
        height: slideHeight,
        top: (data.maskHeight - slideHeight) / 2,
        left: (data.maskWidth - slideWidth) / 2
      }
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments)
        args.shift()
        this.options[name].apply(this, args)
      }
    }
  }

  // jQuery plugin interface
  $.fn.videoStretcher = function (options) {
    return this.each(function () {
      const params = $.extend({}, options, { holder: this })
      const instance = new VideoStretcher(params)
    })
  }

  // module VideoStretcher
  window.VideoStretcher = VideoStretcher
}(jQuery))

/*
 * Responsive Layout helper
 */
const ResponsiveHelper = (function ($) {
  // init variables
  var handlers = []
  var prevWinWidth
  var win = $(window)
  var nativeMatchMedia = false

  // detect match media support
  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true
    }
  }

  // prepare resize handler
  function resizeHandler () {
    var winWidth = win.width()
    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth

      // loop through range groups
      $.each(handlers, function (index, rangeObject) {
        // disable current active area if needed
        $.each(rangeObject.data, function (property, item) {
          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false
            if (typeof item.disableCallback === 'function') {
              item.disableCallback()
            }
          }
        })

        // enable areas that match current width
        $.each(rangeObject.data, function (property, item) {
          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true
            if (typeof item.enableCallback === 'function') {
              item.enableCallback()
            }
          }
        })
      })
    }
  }

  win.on('load resize orientationchange', resizeHandler)

  // test range
  function matchRange (r1, r2) {
    var mediaQueryString = ''
    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)'
    }
    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)'
    }
    return matchQuery(mediaQueryString, r1, r2)
  }

  // media query function
  function matchQuery (query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches
    } else if (window.styleMedia) {
      return styleMedia.matchMedium(query)
    } else if (window.media) {
      return media.matchMedium(query)
    } else {
      return prevWinWidth >= r1 && prevWinWidth <= r2
    }
  }

  // range parser
  function parseRange (rangeStr) {
    var rangeData = rangeStr.split('..')
    var x1 = parseInt(rangeData[0], 10) || -Infinity
    var x2 = parseInt(rangeData[1], 10) || Infinity
    return [x1, x2].sort(function (a, b) {
      return a - b
    })
  }

  // export public functions
  return {
    addRange: function (ranges) {
      // parse data and add items to collection
      var result = { data: {} }
      $.each(ranges, function (property, data) {
        result.data[property] = {
          range: parseRange(property),
          enableCallback: data.on,
          disableCallback: data.off
        }
      })
      handlers.push(result)

      // call resizeHandler to recalculate all events
      prevWinWidth = null
      resizeHandler()
    }
  }
}(jQuery))

/*
 * jQuery Cycle Carousel plugin
 */
;(function ($) {
  function ScrollAbsoluteGallery (options) {
    this.options = $.extend({
      activeClass: 'active',
      mask: 'div.slides-mask',
      slider: '>ul',
      slides: '>li',
      btnPrev: '.btn-prev',
      btnNext: '.btn-next',
      pagerLinks: 'ul.pager > li',
      generatePagination: false,
      pagerList: '<ul>',
      pagerListItem: '<li><a href="#"></a></li>',
      pagerListItemText: 'a',
      galleryReadyClass: 'gallery-js-ready',
      currentNumber: 'span.current-num',
      totalNumber: 'span.total-num',
      maskAutoSize: false,
      autoRotation: false,
      pauseOnHover: false,
      stretchSlideToMask: false,
      switchTime: 3000,
      animSpeed: 500,
      handleTouch: true,
      swipeThreshold: 15,
      vertical: false
    }, options)
    this.init()
  }

  ScrollAbsoluteGallery.prototype = {
    init: function () {
      if (this.options.holder) {
        this.findElements()
        this.attachEvents()
        this.makeCallback('onInit', this)
      }
    },
    findElements: function () {
      // find structure elements
      this.holder = $(this.options.holder).addClass(this.options.galleryReadyClass)
      this.mask = this.holder.find(this.options.mask)
      this.slider = this.mask.find(this.options.slider)
      this.slides = this.slider.find(this.options.slides)
      this.btnPrev = this.holder.find(this.options.btnPrev)
      this.btnNext = this.holder.find(this.options.btnNext)

      // slide count display
      this.currentNumber = this.holder.find(this.options.currentNumber)
      this.totalNumber = this.holder.find(this.options.totalNumber)

      // create gallery pagination
      if (typeof this.options.generatePagination === 'string') {
        this.pagerLinks = this.buildPagination()
      } else {
        this.pagerLinks = this.holder.find(this.options.pagerLinks)
      }

      // define index variables
      this.sizeProperty = this.options.vertical ? 'height' : 'width'
      this.positionProperty = this.options.vertical ? 'top' : 'left'
      this.animProperty = this.options.vertical ? 'marginTop' : 'marginLeft'

      this.slideSize = this.slides[this.sizeProperty]()
      this.currentIndex = 0
      this.prevIndex = 0

      // reposition elements
      this.options.maskAutoSize = this.options.vertical ? false : this.options.maskAutoSize
      if (this.options.vertical) {
        this.mask.css({
          height: this.slides.innerHeight()
        })
      }
      if (this.options.maskAutoSize) {
        this.mask.css({
          height: this.slider.height()
        })
      }
      this.slider.css({
        position: 'relative',
        height: this.options.vertical ? this.slideSize * this.slides.length : '100%'
      })
      this.slides.css({
        position: 'absolute'
      }).css(this.positionProperty, -9999).eq(this.currentIndex).css(this.positionProperty, 0)
      this.refreshState()
    },
    buildPagination: function () {
      var pagerLinks = $()
      if (!this.pagerHolder) {
        this.pagerHolder = this.holder.find(this.options.generatePagination)
      }
      if (this.pagerHolder.length) {
        this.pagerHolder.empty()
        this.pagerList = $(this.options.pagerList).appendTo(this.pagerHolder)
        for (var i = 0; i < this.slides.length; i++) {
          $(this.options.pagerListItem).appendTo(this.pagerList).find(this.options.pagerListItemText).text(i + 1)
        }
        pagerLinks = this.pagerList.children()
      }
      return pagerLinks
    },
    attachEvents: function () {
      // attach handlers
      var self = this
      if (this.btnPrev.length) {
        this.btnPrevHandler = function (e) {
          e.preventDefault()
          self.prevSlide()
        }
        this.btnPrev.click(this.btnPrevHandler)
      }
      if (this.btnNext.length) {
        this.btnNextHandler = function (e) {
          e.preventDefault()
          self.nextSlide()
        }
        this.btnNext.click(this.btnNextHandler)
      }
      if (this.pagerLinks.length) {
        this.pagerLinksHandler = function (e) {
          e.preventDefault()
          self.numSlide(self.pagerLinks.index(e.currentTarget))
        }
        this.pagerLinks.click(this.pagerLinksHandler)
      }

      // handle autorotation pause on hover
      if (this.options.pauseOnHover) {
        this.hoverHandler = function () {
          clearTimeout(self.timer)
        }
        this.leaveHandler = function () {
          self.autoRotate()
        }
        this.holder.on({ mouseenter: this.hoverHandler, mouseleave: this.leaveHandler })
      }

      // handle holder and slides dimensions
      this.resizeHandler = function () {
        if (!self.animating) {
          if (self.options.stretchSlideToMask) {
            self.resizeSlides()
          }
          self.resizeHolder()
          self.setSlidesPosition(self.currentIndex)
        }
      }
      $(window).on('load resize orientationchange', this.resizeHandler)
      if (self.options.stretchSlideToMask) {
        self.resizeSlides()
      }

      // handle swipe on mobile devices
      if (this.options.handleTouch && window.Hammer && this.mask.length && this.slides.length > 1 && isTouchDevice) {
        this.swipeHandler = new Hammer.Manager(this.mask[0])
        this.swipeHandler.add(new Hammer.Pan({
          direction: self.options.vertical ? Hammer.DIRECTION_VERTICAL : Hammer.DIRECTION_HORIZONTAL,
          threshold: self.options.swipeThreshold
        }))

        this.swipeHandler.on('panstart', function () {
          if (self.animating) {
            self.swipeHandler.stop()
          } else {
            clearTimeout(self.timer)
          }
        }).on('panmove', function (e) {
          self.swipeOffset = -self.slideSize + e[self.options.vertical ? 'deltaY' : 'deltaX']
          self.slider.css(self.animProperty, self.swipeOffset)
          clearTimeout(self.timer)
        }).on('panend', function (e) {
          if (e.distance > self.options.swipeThreshold) {
            if (e.offsetDirection === Hammer.DIRECTION_RIGHT || e.offsetDirection === Hammer.DIRECTION_DOWN) {
              self.nextSlide()
            } else {
              self.prevSlide()
            }
          } else {
            var tmpObj = {}
            tmpObj[self.animProperty] = -self.slideSize
            self.slider.animate(tmpObj, { duration: self.options.animSpeed })
            self.autoRotate()
          }
          self.swipeOffset = 0
        })
      }

      // start autorotation
      this.autoRotate()
      this.resizeHolder()
      this.setSlidesPosition(this.currentIndex)
    },
    resizeSlides: function () {
      this.slideSize = this.mask[this.options.vertical ? 'height' : 'width']()
      this.slides.css(this.sizeProperty, this.slideSize)
    },
    resizeHolder: function () {
      if (this.options.maskAutoSize) {
        this.mask.css({
          height: this.slides.eq(this.currentIndex).outerHeight(true)
        })
      }
    },
    prevSlide: function () {
      if (!this.animating && this.slides.length > 1) {
        this.direction = -1
        this.prevIndex = this.currentIndex
        if (this.currentIndex > 0) this.currentIndex--
        else this.currentIndex = this.slides.length - 1
        this.switchSlide()
      }
    },
    nextSlide: function (fromAutoRotation) {
      if (!this.animating && this.slides.length > 1) {
        this.direction = 1
        this.prevIndex = this.currentIndex
        if (this.currentIndex < this.slides.length - 1) this.currentIndex++
        else this.currentIndex = 0
        this.switchSlide()
      }
    },
    numSlide: function (c) {
      if (!this.animating && this.currentIndex !== c && this.slides.length > 1) {
        this.direction = c > this.currentIndex ? 1 : -1
        this.prevIndex = this.currentIndex
        this.currentIndex = c
        this.switchSlide()
      }
    },
    preparePosition: function () {
      // prepare slides position before animation
      this.setSlidesPosition(this.prevIndex, this.direction < 0 ? this.currentIndex : null, this.direction > 0 ? this.currentIndex : null, this.direction)
    },
    setSlidesPosition: function (index, slideLeft, slideRight, direction) {
      // reposition holder and nearest slides
      if (this.slides.length > 1) {
        var prevIndex = (typeof slideLeft === 'number' ? slideLeft : index > 0 ? index - 1 : this.slides.length - 1)
        var nextIndex = (typeof slideRight === 'number' ? slideRight : index < this.slides.length - 1 ? index + 1 : 0)

        this.slider.css(this.animProperty, this.swipeOffset ? this.swipeOffset : -this.slideSize)
        this.slides.css(this.positionProperty, -9999).eq(index).css(this.positionProperty, this.slideSize)
        if (prevIndex === nextIndex && typeof direction === 'number') {
          var calcOffset = direction > 0 ? this.slideSize * 2 : 0
          this.slides.eq(nextIndex).css(this.positionProperty, calcOffset)
        } else {
          this.slides.eq(prevIndex).css(this.positionProperty, 0)
          this.slides.eq(nextIndex).css(this.positionProperty, this.slideSize * 2)
        }
      }
    },
    switchSlide: function () {
      // prepare positions and calculate offset
      var self = this
      // var oldSlide = this.slides.eq(this.prevIndex)
      var newSlide = this.slides.eq(this.currentIndex)
      this.animating = true

      // resize mask to fit slide
      if (this.options.maskAutoSize) {
        this.mask.animate({
          height: newSlide.outerHeight(true)
        }, {
          duration: this.options.animSpeed
        })
      }

      // start animation
      var animProps = {}
      animProps[this.animProperty] = this.direction > 0 ? -this.slideSize * 2 : 0
      this.preparePosition()
      this.slider.animate(animProps, {
        duration: this.options.animSpeed,
        complete: function () {
          self.setSlidesPosition(self.currentIndex)

          // start autorotation
          self.animating = false
          self.autoRotate()

          // onchange callback
          self.makeCallback('onChange', self)
        }
      })

      // refresh classes
      this.refreshState()

      // onchange callback
      this.makeCallback('onBeforeChange', this)
    },
    refreshState: function (initial) {
      // slide change function
      this.slides.removeClass(this.options.activeClass).eq(this.currentIndex).addClass(this.options.activeClass)
      this.pagerLinks.removeClass(this.options.activeClass).eq(this.currentIndex).addClass(this.options.activeClass)

      // display current slide number
      this.currentNumber.html(this.currentIndex + 1)
      this.totalNumber.html(this.slides.length)

      // add class if not enough slides
      this.holder.toggleClass('not-enough-slides', this.slides.length === 1)
    },
    autoRotate: function () {
      var self = this
      clearTimeout(this.timer)
      if (this.options.autoRotation) {
        this.timer = setTimeout(function () {
          self.nextSlide()
        }, this.options.switchTime)
      }
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments)
        args.shift()
        this.options[name].apply(this, args)
      }
    },
    destroy: function () {
      // destroy handler
      this.btnPrev.off('click', this.btnPrevHandler)
      this.btnNext.off('click', this.btnNextHandler)
      this.pagerLinks.off('click', this.pagerLinksHandler)
      this.holder.off('mouseenter', this.hoverHandler)
      this.holder.off('mouseleave', this.leaveHandler)
      $(window).off('load resize orientationchange', this.resizeHandler)
      clearTimeout(this.timer)

      // destroy swipe handler
      if (this.swipeHandler) {
        this.swipeHandler.destroy()
      }

      // remove inline styles, classes and pagination
      this.holder.removeClass(this.options.galleryReadyClass)
      this.slider.add(this.slides).removeAttr('style')
      if (typeof this.options.generatePagination === 'string') {
        this.pagerHolder.empty()
      }
    }
  }

  // detect device type
  var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch

  // jquery plugin
  $.fn.scrollAbsoluteGallery = function (opt) {
    return this.each(function () {
      $(this).data('ScrollAbsoluteGallery', new ScrollAbsoluteGallery($.extend(opt, { holder: this })))
    })
  }
}(jQuery))

/*
 * jQuery SlideShow plugin
 */
;(function ($) {
  function FadeGallery (options) {
    this.options = $.extend({
      slides: 'ul.slideset > li',
      activeClass: 'active',
      disabledClass: 'disabled',
      btnPrev: 'a.btn-prev',
      btnNext: 'a.btn-next',
      generatePagination: false,
      pagerList: '<ul>',
      pagerListItem: '<li><a href="#"></a></li>',
      pagerListItemText: 'a',
      pagerLinks: '.pagination li',
      currentNumber: 'span.current-num',
      totalNumber: 'span.total-num',
      btnPlay: '.btn-play',
      btnPause: '.btn-pause',
      btnPlayPause: '.btn-play-pause',
      galleryReadyClass: 'gallery-js-ready',
      autorotationActiveClass: 'autorotation-active',
      autorotationDisabledClass: 'autorotation-disabled',
      autorotationStopAfterClick: false,
      circularRotation: true,
      switchSimultaneously: true,
      disableWhileAnimating: false,
      disableFadeIE: false,
      autoRotation: false,
      pauseOnHover: true,
      autoHeight: false,
      useSwipe: false,
      swipeThreshold: 15,
      switchTime: 4000,
      animSpeed: 600,
      event: 'click'
    }, options)
    this.init()
  }

  FadeGallery.prototype = {
    init: function () {
      if (this.options.holder) {
        this.findElements()
        this.attachEvents()
        this.refreshState(true)
        this.autoRotate()
        this.makeCallback('onInit', this)
      }
    },
    findElements: function () {
      // control elements
      this.gallery = $(this.options.holder).addClass(this.options.galleryReadyClass)
      this.slides = this.gallery.find(this.options.slides)
      this.slidesHolder = this.slides.eq(0).parent()
      this.stepsCount = this.slides.length
      this.btnPrev = this.gallery.find(this.options.btnPrev)
      this.btnNext = this.gallery.find(this.options.btnNext)
      this.currentIndex = 0

      // disable fade effect in old IE
      if (this.options.disableFadeIE && !$.support.opacity) {
        this.options.animSpeed = 0
      }

      // create gallery pagination
      if (typeof this.options.generatePagination === 'string') {
        this.pagerHolder = this.gallery.find(this.options.generatePagination).empty()
        this.pagerList = $(this.options.pagerList).appendTo(this.pagerHolder)
        for (var i = 0; i < this.stepsCount; i++) {
          $(this.options.pagerListItem).appendTo(this.pagerList).find(this.options.pagerListItemText).text(i + 1)
        }
        this.pagerLinks = this.pagerList.children()
      } else {
        this.pagerLinks = this.gallery.find(this.options.pagerLinks)
      }

      // get start index
      var activeSlide = this.slides.filter('.' + this.options.activeClass)
      if (activeSlide.length) {
        this.currentIndex = this.slides.index(activeSlide)
      }
      this.prevIndex = this.currentIndex

      // autorotation control buttons
      this.btnPlay = this.gallery.find(this.options.btnPlay)
      this.btnPause = this.gallery.find(this.options.btnPause)
      this.btnPlayPause = this.gallery.find(this.options.btnPlayPause)

      // misc elements
      this.curNum = this.gallery.find(this.options.currentNumber)
      this.allNum = this.gallery.find(this.options.totalNumber)

      // handle flexible layout
      this.slides.css({ display: 'block', opacity: 0 }).eq(this.currentIndex).css({
        opacity: ''
      })
    },
    attachEvents: function () {
      var self = this

      // flexible layout handler
      this.resizeHandler = function () {
        self.onWindowResize()
      }
      $(window).on('load resize orientationchange', this.resizeHandler)

      if (this.btnPrev.length) {
        this.btnPrevHandler = function (e) {
          e.preventDefault()
          self.prevSlide()
          if (self.options.autorotationStopAfterClick) {
            self.stopRotation()
          }
        }
        this.btnPrev.on(this.options.event, this.btnPrevHandler)
      }
      if (this.btnNext.length) {
        this.btnNextHandler = function (e) {
          e.preventDefault()
          self.nextSlide()
          if (self.options.autorotationStopAfterClick) {
            self.stopRotation()
          }
        }
        this.btnNext.on(this.options.event, this.btnNextHandler)
      }
      if (this.pagerLinks.length) {
        this.pagerLinksHandler = function (e) {
          e.preventDefault()
          self.numSlide(self.pagerLinks.index(e.currentTarget))
          if (self.options.autorotationStopAfterClick) {
            self.stopRotation()
          }
        }
        this.pagerLinks.on(self.options.event, this.pagerLinksHandler)
      }

      // autorotation buttons handler
      if (this.btnPlay.length) {
        this.btnPlayHandler = function (e) {
          e.preventDefault()
          self.startRotation()
        }
        this.btnPlay.on(this.options.event, this.btnPlayHandler)
      }
      if (this.btnPause.length) {
        this.btnPauseHandler = function (e) {
          e.preventDefault()
          self.stopRotation()
        }
        this.btnPause.on(this.options.event, this.btnPauseHandler)
      }
      if (this.btnPlayPause.length) {
        this.btnPlayPauseHandler = function (e) {
          e.preventDefault()
          if (!self.gallery.hasClass(self.options.autorotationActiveClass)) {
            self.startRotation()
          } else {
            self.stopRotation()
          }
        }
        this.btnPlayPause.on(this.options.event, this.btnPlayPauseHandler)
      }

      // swipe gestures handler
      if (this.options.useSwipe && window.Hammer && isTouchDevice) {
        this.swipeHandler = new Hammer.Manager(this.gallery[0])
        this.swipeHandler.add(new Hammer.Swipe({
          direction: Hammer.DIRECTION_HORIZONTAL,
          threshold: self.options.swipeThreshold
        }))
        this.swipeHandler.on('swipeleft', function () {
          self.nextSlide()
        }).on('swiperight', function () {
          self.prevSlide()
        })
      }

      // pause on hover handling
      if (this.options.pauseOnHover) {
        this.hoverHandler = function () {
          if (self.options.autoRotation) {
            self.galleryHover = true
            self.pauseRotation()
          }
        }
        this.leaveHandler = function () {
          if (self.options.autoRotation) {
            self.galleryHover = false
            self.resumeRotation()
          }
        }
        this.gallery.on({ mouseenter: this.hoverHandler, mouseleave: this.leaveHandler })
      }
    },
    onWindowResize: function () {
      if (this.options.autoHeight) {
        this.slidesHolder.css({ height: this.slides.eq(this.currentIndex).outerHeight(true) })
      }
    },
    prevSlide: function () {
      if (!(this.options.disableWhileAnimating && this.galleryAnimating)) {
        this.prevIndex = this.currentIndex
        if (this.currentIndex > 0) {
          this.currentIndex--
          this.switchSlide()
        } else if (this.options.circularRotation) {
          this.currentIndex = this.stepsCount - 1
          this.switchSlide()
        }
      }
    },
    nextSlide: function (fromAutoRotation) {
      if (!(this.options.disableWhileAnimating && this.galleryAnimating)) {
        this.prevIndex = this.currentIndex
        if (this.currentIndex < this.stepsCount - 1) {
          this.currentIndex++
          this.switchSlide()
        } else if (this.options.circularRotation || fromAutoRotation === true) {
          this.currentIndex = 0
          this.switchSlide()
        }
      }
    },
    numSlide: function (c) {
      if (this.currentIndex !== c) {
        this.prevIndex = this.currentIndex
        this.currentIndex = c
        this.switchSlide()
      }
    },
    switchSlide: function () {
      var self = this
      if (this.slides.length > 1) {
        this.galleryAnimating = true
        if (!this.options.animSpeed) {
          this.slides.eq(this.prevIndex).css({ opacity: 0 })
        } else {
          this.slides.eq(this.prevIndex).stop().animate({ opacity: 0 }, { duration: this.options.animSpeed })
        }

        this.switchNext = function () {
          if (!self.options.animSpeed) {
            self.slides.eq(self.currentIndex).css({ opacity: '' })
          } else {
            self.slides.eq(self.currentIndex).stop().animate({ opacity: 1 }, { duration: self.options.animSpeed })
          }
          clearTimeout(this.nextTimer)
          this.nextTimer = setTimeout(function () {
            self.slides.eq(self.currentIndex).css({ opacity: '' })
            self.galleryAnimating = false
            self.autoRotate()

            // onchange callback
            self.makeCallback('onChange', self)
          }, self.options.animSpeed)
        }

        if (this.options.switchSimultaneously) {
          self.switchNext()
        } else {
          clearTimeout(this.switchTimer)
          this.switchTimer = setTimeout(function () {
            self.switchNext()
          }, this.options.animSpeed)
        }
        this.refreshState()

        // onchange callback
        this.makeCallback('onBeforeChange', this)
      }
    },
    refreshState: function (initial) {
      this.slides.removeClass(this.options.activeClass).eq(this.currentIndex).addClass(this.options.activeClass)
      this.pagerLinks.removeClass(this.options.activeClass).eq(this.currentIndex).addClass(this.options.activeClass)
      this.curNum.html(this.currentIndex + 1)
      this.allNum.html(this.stepsCount)

      // initial refresh
      if (this.options.autoHeight) {
        if (initial) {
          this.slidesHolder.css({ height: this.slides.eq(this.currentIndex).outerHeight(true) })
        } else {
          this.slidesHolder.stop().animate({ height: this.slides.eq(this.currentIndex).outerHeight(true) }, { duration: this.options.animSpeed })
        }
      }

      // disabled state
      if (!this.options.circularRotation) {
        this.btnPrev.add(this.btnNext).removeClass(this.options.disabledClass)
        if (this.currentIndex === 0) this.btnPrev.addClass(this.options.disabledClass)
        if (this.currentIndex === this.stepsCount - 1) this.btnNext.addClass(this.options.disabledClass)
      }

      // add class if not enough slides
      this.gallery.toggleClass('not-enough-slides', this.stepsCount === 1)
    },
    startRotation: function () {
      this.options.autoRotation = true
      this.galleryHover = false
      this.autoRotationStopped = false
      this.resumeRotation()
    },
    stopRotation: function () {
      this.galleryHover = true
      this.autoRotationStopped = true
      this.pauseRotation()
    },
    pauseRotation: function () {
      this.gallery.addClass(this.options.autorotationDisabledClass)
      this.gallery.removeClass(this.options.autorotationActiveClass)
      clearTimeout(this.timer)
    },
    resumeRotation: function () {
      if (!this.autoRotationStopped) {
        this.gallery.addClass(this.options.autorotationActiveClass)
        this.gallery.removeClass(this.options.autorotationDisabledClass)
        this.autoRotate()
      }
    },
    autoRotate: function () {
      var self = this
      clearTimeout(this.timer)
      if (this.options.autoRotation && !this.galleryHover && !this.autoRotationStopped) {
        this.gallery.addClass(this.options.autorotationActiveClass)
        this.timer = setTimeout(function () {
          self.nextSlide(true)
        }, this.options.switchTime)
      } else {
        this.pauseRotation()
      }
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments)
        args.shift()
        this.options[name].apply(this, args)
      }
    },
    destroy: function () {
      // navigation buttons handler
      this.btnPrev.off(this.options.event, this.btnPrevHandler)
      this.btnNext.off(this.options.event, this.btnNextHandler)
      this.pagerLinks.off(this.options.event, this.pagerLinksHandler)
      $(window).off('load resize orientationchange', this.resizeHandler)

      // remove autorotation handlers
      this.stopRotation()
      this.btnPlay.off(this.options.event, this.btnPlayHandler)
      this.btnPause.off(this.options.event, this.btnPauseHandler)
      this.btnPlayPause.off(this.options.event, this.btnPlayPauseHandler)
      this.gallery.off('mouseenter', this.hoverHandler)
      this.gallery.off('mouseleave', this.leaveHandler)

      // remove swipe handler if used
      if (this.swipeHandler) {
        this.swipeHandler.destroy()
      }
      if (typeof this.options.generatePagination === 'string') {
        this.pagerHolder.empty()
      }

      // remove unneeded classes and styles
      var unneededClasses = [this.options.galleryReadyClass, this.options.autorotationActiveClass, this.options.autorotationDisabledClass]
      this.gallery.removeClass(unneededClasses.join(' '))
      this.slidesHolder.add(this.slides).removeAttr('style')
    }
  }

  // detect device type
  var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch

  // jquery plugin
  $.fn.fadeGallery = function (opt) {
    return this.each(function () {
      $(this).data('FadeGallery', new FadeGallery($.extend(opt, { holder: this })))
    })
  }
}(jQuery))

/*
 * jQuery Open/Close plugin
 */
;(function ($) {
  function OpenClose (options) {
    this.options = $.extend({
      addClassBeforeAnimation: true,
      hideOnClickOutside: true,
      activeClass: 'active',
      opener: '.opener',
      slider: '.slide',
      animSpeed: 400,
      effect: 'fade',
      event: 'click'
    }, options)
    this.init()
  }

  OpenClose.prototype = {
    init: function () {
      if (this.options.holder) {
        this.findElements()
        this.attachEvents()
        this.makeCallback('onInit', this)
      }
    },
    findElements: function () {
      this.holder = $(this.options.holder)
      this.opener = this.holder.find(this.options.opener)
      this.slider = this.holder.find(this.options.slider)
    },
    attachEvents: function () {
      // add handler
      var self = this
      this.eventHandler = function (e) {
        e.preventDefault()
        if (self.slider.hasClass(slideHiddenClass)) {
          self.showSlide()
        } else {
          self.hideSlide()
        }
      }
      self.opener.on(self.options.event, this.eventHandler)

      // hover mode handler
      if (self.options.event === 'over') {
        self.opener.on('mouseenter', function () {
          if (!self.holder.hasClass(self.options.activeClass)) {
            self.showSlide()
          }
        })
        self.holder.on('mouseleave', function () {
          self.hideSlide()
        })
      }

      // outside click handler
      self.outsideClickHandler = function (e) {
        if (self.options.hideOnClickOutside) {
          var target = $(e.target)
          if (!target.is(self.holder) && !target.closest(self.holder).length) {
            self.hideSlide()
          }
        }
      }

      // set initial styles
      if (this.holder.hasClass(this.options.activeClass)) {
        $(document).on('click touchstart', self.outsideClickHandler)
      } else {
        this.slider.addClass(slideHiddenClass)
      }
    },
    showSlide: function () {
      var self = this
      if (self.options.addClassBeforeAnimation) {
        self.holder.addClass(self.options.activeClass)
      }
      self.slider.removeClass(slideHiddenClass)
      $(document).on('click touchstart', self.outsideClickHandler)

      self.makeCallback('animStart', true)
      toggleEffects[self.options.effect].show({
        box: self.slider,
        speed: self.options.animSpeed,
        complete: function () {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.addClass(self.options.activeClass)
          }
          self.makeCallback('animEnd', true)
        }
      })
    },
    hideSlide: function () {
      var self = this
      if (self.options.addClassBeforeAnimation) {
        self.holder.removeClass(self.options.activeClass)
      }
      $(document).off('click touchstart', self.outsideClickHandler)

      self.makeCallback('animStart', false)
      toggleEffects[self.options.effect].hide({
        box: self.slider,
        speed: self.options.animSpeed,
        complete: function () {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.removeClass(self.options.activeClass)
          }
          self.slider.addClass(slideHiddenClass)
          self.makeCallback('animEnd', false)
        }
      })
    },
    destroy: function () {
      this.slider.removeClass(slideHiddenClass).css({ display: '' })
      this.opener.off(this.options.event, this.eventHandler)
      this.holder.removeClass(this.options.activeClass).removeData('OpenClose')
      $(document).off('click touchstart', this.outsideClickHandler)
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments)
        args.shift()
        this.options[name].apply(this, args)
      }
    }
  }

  // add stylesheet for slide on DOMReady
  var slideHiddenClass = 'js-slide-hidden';
  (function () {
    var tabStyleSheet = $('<style type="text/css">')[0]
    var tabStyleRule = '.' + slideHiddenClass
    tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}'
    if (tabStyleSheet.styleSheet) {
      tabStyleSheet.styleSheet.cssText = tabStyleRule
    } else {
      tabStyleSheet.appendChild(document.createTextNode(tabStyleRule))
    }
    $('head').append(tabStyleSheet)
  }())

  // animation effects
  var toggleEffects = {
    slide: {
      show: function (o) {
        o.box.stop(true).hide().slideDown(o.speed, o.complete)
      },
      hide: function (o) {
        o.box.stop(true).slideUp(o.speed, o.complete)
      }
    },
    fade: {
      show: function (o) {
        o.box.stop(true).hide().fadeIn(o.speed, o.complete)
      },
      hide: function (o) {
        o.box.stop(true).fadeOut(o.speed, o.complete)
      }
    },
    none: {
      show: function (o) {
        o.box.hide().show(0, o.complete)
      },
      hide: function (o) {
        o.box.hide(0, o.complete)
      }
    }
  }

  // jQuery plugin interface
  $.fn.openClose = function (opt) {
    return this.each(function () {
      jQuery(this).data('OpenClose', new OpenClose($.extend(opt, { holder: this })))
    })
  }
}(jQuery))

/*
 * Simple Mobile Navigation
 */
;(function ($) {
  function MobileNav (options) {
    this.options = $.extend({
      container: null,
      hideOnClickOutside: false,
      menuActiveClass: 'nav-active',
      menuOpener: '.nav-opener',
      menuDrop: '.nav-drop',
      toggleEvent: 'click',
      outsideClickEvent: 'click touchstart pointerdown MSPointerDown'
    }, options)
    this.initStructure()
    this.attachEvents()
  }

  MobileNav.prototype = {
    initStructure: function () {
      this.page = $('html')
      this.container = $(this.options.container)
      this.opener = this.container.find(this.options.menuOpener)
      this.drop = this.container.find(this.options.menuDrop)
    },
    attachEvents: function () {
      var self = this

      if (activateResizeHandler) {
        activateResizeHandler()
        activateResizeHandler = null
      }

      this.outsideClickHandler = function (e) {
        if (self.isOpened()) {
          var target = $(e.target)
          if (!target.closest(self.opener).length && !target.closest(self.drop).length) {
            self.hide()
          }
        }
      }

      this.openerClickHandler = function (e) {
        e.preventDefault()
        self.toggle()
      }

      this.opener.on(this.options.toggleEvent, this.openerClickHandler)
    },
    isOpened: function () {
      return this.container.hasClass(this.options.menuActiveClass)
    },
    show: function () {
      this.container.addClass(this.options.menuActiveClass)
      if (this.options.hideOnClickOutside) {
        this.page.on(this.options.outsideClickEvent, this.outsideClickHandler)
      }

      this.makeCallback('onShow', this)
    },
    hide: function () {
      this.container.removeClass(this.options.menuActiveClass)
      if (this.options.hideOnClickOutside) {
        this.page.off(this.options.outsideClickEvent, this.outsideClickHandler)
      }

      this.makeCallback('onHide', this)
    },
    toggle: function () {
      if (this.isOpened()) {
        this.hide()
      } else {
        this.show()
      }
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments)
        args.shift()
        this.options[name].apply(this, args)
      }
    },
    destroy: function () {
      this.container.removeClass(this.options.menuActiveClass)
      this.opener.off(this.options.toggleEvent, this.clickHandler)
      this.page.off(this.options.outsideClickEvent, this.outsideClickHandler)
    }
  }

  var activateResizeHandler = function () {
    var win = $(window)
    var doc = $('html')
    var resizeClass = 'resize-active'
    var flag
    var timer
    var removeClassHandler = function () {
      flag = false
      doc.removeClass(resizeClass)
    }
    var resizeHandler = function () {
      if (!flag) {
        flag = true
        doc.addClass(resizeClass)
      }
      clearTimeout(timer)
      timer = setTimeout(removeClassHandler, 500)
    }
    win.on('resize orientationchange', resizeHandler)
  }

  $.fn.mobileNav = function (options) {
    return this.each(function () {
      var params = $.extend({}, options, { container: this })
      var instance = new MobileNav(params)
      $.data(this, 'MobileNav', instance)
    })
  }
}(jQuery))

/*
 * FixedScrollBlock
 */
;(function ($, window) {
  'use strict'
/*  var isMobileDevice = ('ontouchstart' in window) ||
    (window.DocumentTouch && document instanceof DocumentTouch) ||
    /Windows Phone/.test(navigator.userAgent) */

  function FixedScrollBlock (options) {
    this.options = $.extend({
      fixedActiveClass: 'fixed-position',
      slideBlock: '[data-scroll-block]',
      positionType: 'auto',
      fixedOnlyIfFits: true,
      container: null,
      animDelay: 100,
      animSpeed: 200,
      extraBottom: 0,
      extraTop: 0
    }, options)
    this.initStructure()
    this.attachEvents()
  }

  FixedScrollBlock.prototype = {
    initStructure: function () {
      // find elements
      this.win = $(window)
      this.container = $(this.options.container)
      this.slideBlock = this.container.find(this.options.slideBlock)

      // detect method
      if (this.options.positionType === 'auto') {
        this.options.positionType = isMobileDevice ? 'absolute' : 'fixed'
      }
    },
    attachEvents: function () {
      var self = this

      // bind events
      this.onResize = function () {
        self.resizeHandler()
      }
      this.onScroll = function () {
        self.scrollHandler()
      }

      // handle events
      this.win.on({
        resize: this.onResize,
        scroll: this.onScroll
      })

      // initial handler call
      this.resizeHandler()
    },
    recalculateOffsets: function () {
      var defaultOffset = this.slideBlock.offset()
      var defaultPosition = this.slideBlock.position()
      var holderOffset = this.container.offset()
      // var windowSize = this.win.height()

      this.data = {
        windowHeight: this.win.height(),
        windowWidth: this.win.width(),

        blockPositionLeft: defaultPosition.left,
        blockPositionTop: defaultPosition.top,

        blockOffsetLeft: defaultOffset.left,
        blockOffsetTop: defaultOffset.top,
        blockHeight: this.slideBlock.innerHeight(),

        holderOffsetLeft: holderOffset.left,
        holderOffsetTop: holderOffset.top,
        holderHeight: this.container.innerHeight()
      }
    },
    isVisible: function () {
      return this.slideBlock.prop('offsetHeight')
    },
    fitsInViewport: function () {
      if (this.options.fixedOnlyIfFits && this.data) {
        return this.data.blockHeight + this.options.extraTop <= this.data.windowHeight
      } else {
        return true
      }
    },
    resizeHandler: function () {
      if (this.isVisible()) {
        FixedScrollBlock.stickyMethods[this.options.positionType].onResize.apply(this, arguments)
        this.scrollHandler()
      }
    },
    scrollHandler: function () {
      if (this.isVisible()) {
        if (!this.data) {
          this.resizeHandler()
          return
        }
        this.currentScrollTop = this.win.scrollTop()
        this.currentScrollLeft = this.win.scrollLeft()
        FixedScrollBlock.stickyMethods[this.options.positionType].onScroll.apply(this, arguments)
      }
    },
    refresh: function () {
      // refresh dimensions and state if needed
      if (this.data) {
        this.data.holderHeight = this.container.innerHeight()
        this.data.blockHeight = this.slideBlock.innerHeight()
        this.scrollHandler()
      }
    },
    destroy: function () {
      // remove event handlers and styles
      this.slideBlock.removeAttr('style').removeClass(this.options.fixedActiveClass)
      this.win.off({
        resize: this.onResize,
        scroll: this.onScroll
      })
    }
  }

  // sticky methods
  FixedScrollBlock.stickyMethods = {
    fixed: {
      onResize: function () {
        this.slideBlock.removeAttr('style')
        this.recalculateOffsets()
      },
      onScroll: function () {
        if (this.fitsInViewport() && this.currentScrollTop + this.options.extraTop > this.data.blockOffsetTop) {
          if (this.currentScrollTop + this.options.extraTop + this.data.blockHeight > this.data.holderOffsetTop + this.data.holderHeight - this.options.extraBottom) {
            this.slideBlock.css({
              position: 'absolute',
              top: this.data.blockPositionTop + this.data.holderHeight - this.data.blockHeight - this.options.extraBottom - (this.data.blockOffsetTop - this.data.holderOffsetTop),
              left: this.data.blockPositionLeft
            })
          } else {
            this.slideBlock.css({
              position: 'fixed',
              top: this.options.extraTop,
              left: this.data.blockOffsetLeft - this.currentScrollLeft
            })
          }
          this.slideBlock.addClass(this.options.fixedActiveClass)
        } else {
          this.slideBlock.removeClass(this.options.fixedActiveClass).removeAttr('style')
        }
      }
    },
    absolute: {
      onResize: function () {
        this.slideBlock.removeAttr('style')
        this.recalculateOffsets()

        this.slideBlock.css({
          position: 'absolute',
          top: this.data.blockPositionTop,
          left: this.data.blockPositionLeft
        })

        this.slideBlock.addClass(this.options.fixedActiveClass)
      },
      onScroll: function () {
        var self = this
        clearTimeout(this.animTimer)
        this.animTimer = setTimeout(function () {
          var currentScrollTop = self.currentScrollTop + self.options.extraTop
          var initialPosition = self.data.blockPositionTop - (self.data.blockOffsetTop - self.data.holderOffsetTop)
          var maxTopPosition = self.data.holderHeight - self.data.blockHeight - self.options.extraBottom
          var currentTopPosition = initialPosition + Math.min(currentScrollTop - self.data.holderOffsetTop, maxTopPosition)
          var calcTopPosition = self.fitsInViewport() && currentScrollTop > self.data.blockOffsetTop ? currentTopPosition : self.data.blockPositionTop

          self.slideBlock.stop().animate({
            top: calcTopPosition
          }, self.options.animSpeed)
        }, this.options.animDelay)
      }
    }
  }

  // jQuery plugin interface
  $.fn.fixedScrollBlock = function (options) {
    return this.each(function () {
      var params = $.extend({}, options, { container: this })
      var instance = new FixedScrollBlock(params)
      $.data(this, 'FixedScrollBlock', instance)
    })
  }

  // module exports
  /* window.FixedScrollBlock = FixedScrollBlock */
}(jQuery, this))

/*!
 * SmoothScroll module
 */
;(function ($, exports) {
  // private variables
  var page
  var win = $(window)
  var activeBlock
  var activeWheelHandler
  var wheelEvents = ('onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll')

  // animation handlers
  function scrollTo (offset, options, callback) {
    // initialize variables
    var scrollBlock
    if (document.body) {
      if (typeof options === 'number') {
        options = { duration: options }
      } else {
        options = options || {}
      }
      page = page || $('html, body')
      scrollBlock = options.container || page
    } else {
      return
    }

    // treat single number as scrollTop
    if (typeof offset === 'number') {
      offset = { top: offset }
    }

    // handle mousewheel/trackpad while animation is active
    if (activeBlock && activeWheelHandler) {
      activeBlock.off(wheelEvents, activeWheelHandler)
    }
    if (options.wheelBehavior && options.wheelBehavior !== 'none') {
      activeWheelHandler = function (e) {
        if (options.wheelBehavior === 'stop') {
          scrollBlock.off(wheelEvents, activeWheelHandler)
          scrollBlock.stop()
        } else if (options.wheelBehavior === 'ignore') {
          e.preventDefault()
        }
      }
      activeBlock = scrollBlock.on(wheelEvents, activeWheelHandler)
    }

    // start scrolling animation
    scrollBlock.stop().animate({
      scrollLeft: offset.left,
      scrollTop: offset.top
    }, options.duration, function () {
      if (activeWheelHandler) {
        scrollBlock.off(wheelEvents, activeWheelHandler)
      }
      if ($.isFunction(callback)) {
        callback()
      }
    })
  }

  // smooth scroll contstructor
  function SmoothScroll (options) {
    this.options = $.extend({
      anchorLinks: 'a[href^="#"]', // selector or jQuery object
      container: null, // specify container for scrolling (default - whole page)
      extraOffset: null, // function or fixed number
      activeClasses: null, // null, "link", "parent"
      easing: 'swing', // easing of scrolling
      animMode: 'duration', // or "speed" mode
      animDuration: 800, // total duration for scroll (any distance)
      animSpeed: 1500, // pixels per second
      anchorActiveClass: 'anchor-active',
      sectionActiveClass: 'section-active',
      wheelBehavior: 'stop', // "stop", "ignore" or "none"
      useNativeAnchorScrolling: false // do not handle click in devices with native smooth scrolling
    }, options)
    this.init()
  }

  SmoothScroll.prototype = {
    init: function () {
      this.initStructure()
      this.attachEvents()
    },
    initStructure: function () {
      // var self = this

      this.container = this.options.container ? $(this.options.container) : $('html,body')
      this.scrollContainer = this.options.container ? this.container : win
      this.anchorLinks = jQuery(this.options.anchorLinks).filter(function () {
        return document.getElementById(this.getAttribute('href').slice(1))
      })
    },
    getAnchorTarget: function (link) {
      // get target block from link href
      var targetId = $(link).attr('href')
      return $(targetId.length > 1 ? targetId : 'html')
    },
    getTargetOffset: function (block) {
      // get target offset
      var blockOffset = block.offset().top
      console.log('3025: blockOffset: ' + blockOffset)
      if (this.options.container) {
        blockOffset -= this.container.offset().top - this.container.prop('scrollTop')
        console.log('3028: blockOffset: ' + blockOffset)
      }

      // handle extra offset
      if (typeof this.options.extraOffset === 'number') {
        blockOffset -= this.options.extraOffset
        console.log('3034: blockOffset: ' + blockOffset)
      } else if (typeof this.options.extraOffset === 'function') {
        blockOffset -= this.options.extraOffset(block)
        console.log('3037: blockOffset: ' + blockOffset)
      }
      return { top: blockOffset }
    },
    attachEvents: function () {
      var self = this

      // handle active classes
      if (this.options.activeClasses && this.anchorLinks.length) {
        // cache structure
        this.anchorData = []

        for (var i = 0; i < this.anchorLinks.length; i++) {
          var link = jQuery(this.anchorLinks[i])
          var targetBlock = self.getAnchorTarget(link)
          var anchorDataItem

          $.each(self.anchorData, function (index, item) {
            if (item.block[0] === targetBlock[0]) {
              anchorDataItem = item
            }
          })

          if (anchorDataItem) {
            anchorDataItem.link = anchorDataItem.link.add(link)
          } else {
            self.anchorData.push({
              link: link,
              block: targetBlock
            })
          }
        }

        // add additional event handlers
        this.resizeHandler = function () {
          self.recalculateOffsets()
        }
        this.scrollHandler = function () {
          self.refreshActiveClass()
        }

        this.recalculateOffsets()
        this.scrollContainer.on('scroll', this.scrollHandler)
        win.on('resize', this.resizeHandler)
      }

      // handle click event
      this.clickHandler = function (e) {
        self.onClick(e)
      }
      if (!this.options.useNativeAnchorScrolling) {
        this.anchorLinks.on('click', this.clickHandler)
      }
    },
    recalculateOffsets: function () {
      var self = this
      $.each(this.anchorData, function (index, data) {
        data.offset = self.getTargetOffset(data.block)
        data.height = data.block.outerHeight()
      })
      this.refreshActiveClass()
    },
    refreshActiveClass: function () {
      var self = this
      var foundFlag = false
      var containerHeight = this.container.prop('scrollHeight')
      var viewPortHeight = this.scrollContainer.height()
      var scrollTop = this.options.container ? this.container.prop('scrollTop') : win.scrollTop()

      // user function instead of default handler
      if (this.options.customScrollHandler) {
        this.options.customScrollHandler.call(this, scrollTop, this.anchorData)
        return
      }

      // sort anchor data by offsets
      this.anchorData.sort(function (a, b) {
        return a.offset.top - b.offset.top
      })

      function toggleActiveClass (anchor, block, state) {
        anchor.toggleClass(self.options.anchorActiveClass, state)
        block.toggleClass(self.options.sectionActiveClass, state)
      }

      // default active class handler
      $.each(this.anchorData, function (index) {
        var reverseIndex = self.anchorData.length - index - 1
        var data = self.anchorData[reverseIndex]
        var anchorElement = (self.options.activeClasses === 'parent' ? data.link.parent() : data.link)

        if (scrollTop >= containerHeight - viewPortHeight) {
          // handle last section
          if (reverseIndex === self.anchorData.length - 1) {
            toggleActiveClass(anchorElement, data.block, true)
          } else {
            toggleActiveClass(anchorElement, data.block, false)
          }
        } else {
          // handle other sections
          if (!foundFlag && (scrollTop >= data.offset.top - 1 || reverseIndex === 0)) {
            foundFlag = true
            toggleActiveClass(anchorElement, data.block, true)
          } else {
            toggleActiveClass(anchorElement, data.block, false)
          }
        }
      })
    },
    calculateScrollDuration: function (offset) {
      var distance
      if (this.options.animMode === 'speed') {
        distance = Math.abs(this.scrollContainer.scrollTop() - offset.top)
        return (distance / this.options.animSpeed) * 1000
      } else {
        return this.options.animDuration
      }
    },
    onClick: function (e) {
      var targetBlock = this.getAnchorTarget(e.currentTarget)
      var targetOffset = this.getTargetOffset(targetBlock)

      e.preventDefault()
      scrollTo(targetOffset, {
        container: this.container,
        wheelBehavior: this.options.wheelBehavior,
        duration: this.calculateScrollDuration(targetOffset)
      })
    },
    destroy: function () {
      if (this.options.activeClasses) {
        win.off('resize', this.resizeHandler)
        this.scrollContainer.off('scroll', this.scrollHandler)
      }
      this.anchorLinks.off('click', this.clickHandler)
    }
  }

  // public API
  $.extend(SmoothScroll, {
    scrollTo: function (blockOrOffset, durationOrOptions, callback) {
      scrollTo(blockOrOffset, durationOrOptions, callback)
    }
  })

  // export module
  /* exports.SmoothScroll = SmoothScroll */
}(jQuery, this))

/*
 * jQuery In Viewport plugin
 */
;(function ($, $win) {
  'use strict'

  var ScrollDetector = (function () {
    var data = {}

    return {
      init: function () {
        var self = this

        this.addHolder('win', $win)

        $win.on('load.blockInViewport resize.blockInViewport orientationchange.blockInViewport', function () {
          $.each(data, function (holderKey, holderData) {
            self.calcHolderSize(holderData)

            $.each(holderData.items, function (itemKey, itemData) {
              self.calcItemSize(itemKey, itemData)
            })
          })
        })
      },

      addHolder: function (holderKey, $holder) {
        var self = this
        var holderData = {
          holder: $holder,
          items: {},
          props: {
            height: 0,
            scroll: 0
          }
        }

        data[holderKey] = holderData

        $holder.on('scroll.blockInViewport', function () {
          self.calcHolderScroll(holderData)

          $.each(holderData.items, function (itemKey, itemData) {
            self.calcItemScroll(itemKey, itemData)
          })
        })

        this.calcHolderSize(data[holderKey])
      },

      calcHolderSize: function (holderData) {
        if (typeof holderData.holder.getBoundingClientRect === 'function') {
          var holderOffset = holderData.holder.offset()
          holderData.props.offset = holderOffset ? holderOffset.top : 0
        } else {
          holderData.props.offset = 0
        }
        holderData.props.height = holderData.holder.get(0) === window ? (window.innerHeight || document.documentElement.clientHeight) : holderData.holder.outerHeight()

        this.calcHolderScroll(holderData)
      },

      calcItemSize: function (itemKey, itemData) {
        itemData.offset = itemData.$el.offset().top - itemData.holderProps.props.offset
        itemData.height = itemData.$el.outerHeight()

        this.calcItemScroll(itemKey, itemData)
      },

      calcHolderScroll: function (holderData) {
        holderData.props.scroll = holderData.holder.scrollTop()
      },

      calcItemScroll: function (itemKey, itemData) {
        var itemInViewPortFromUp
        var itemInViewPortFromDown
        var itemOutViewPort
        var holderProps = itemData.holderProps.props

        switch (itemData.options.visibleMode) {
          case 1:
            itemInViewPortFromDown = itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + itemData.height < holderProps.scroll + holderProps.height
            itemInViewPortFromUp = itemData.offset > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2
            break

          case 2:
            itemInViewPortFromDown = itemInViewPortFromDown || (itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + itemData.height / 2 < holderProps.scroll + holderProps.height)
            itemInViewPortFromUp = itemInViewPortFromUp || (itemData.offset + itemData.height / 2 > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2)
            break

          case 3:
            itemInViewPortFromDown = itemInViewPortFromDown || (itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset < holderProps.scroll + holderProps.height)
            itemInViewPortFromUp = itemInViewPortFromUp || (itemData.offset + itemData.height > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2)
            break

          default:
            itemInViewPortFromDown = itemInViewPortFromDown || (itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + Math.min(itemData.options.visibleMode, itemData.height) < holderProps.scroll + holderProps.height)
            itemInViewPortFromUp = itemInViewPortFromUp || (itemData.offset + itemData.height - Math.min(itemData.options.visibleMode, itemData.height) > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2)
            break
        }

        if (itemInViewPortFromUp && itemInViewPortFromDown) {
          if (!itemData.state) {
            itemData.state = true
            itemData.$el.addClass(itemData.options.activeClass)
              .trigger('in-viewport', true)

            if (itemData.options.once || ($.isFunction(itemData.options.onShow) && itemData.options.onShow(itemData))) {
              delete itemData.holderProps.items[itemKey]
            }
          }
        } else {
          itemOutViewPort = itemData.offset < holderProps.scroll + holderProps.height && itemData.offset + itemData.height > holderProps.scroll

          if ((itemData.state || isNaN(itemData.state)) && !itemOutViewPort) {
            itemData.state = false
            itemData.$el.removeClass(itemData.options.activeClass)
              .trigger('in-viewport', false)
          }
        }
      },

      addItem: function (el, options) {
        var itemKey = 'item' + this.getRandomValue()
        var newItem = {
          $el: $(el),
          options: options
        }
        var holderKeyDataName = 'in-viewport-holder'

        var $holder = newItem.$el.closest(options.holder)
        var holderKey = $holder.data(holderKeyDataName)

        if (!$holder.length) {
          holderKey = 'win'
        } else if (!holderKey) {
          holderKey = 'holder' + this.getRandomValue()
          $holder.data(holderKeyDataName, holderKey)

          this.addHolder(holderKey, $holder)
        }

        newItem.holderProps = data[holderKey]

        data[holderKey].items[itemKey] = newItem

        this.calcItemSize(itemKey, newItem)
      },

      getRandomValue: function () {
        return (Math.random() * 100000).toFixed(0)
      },

      destroy: function () {
        $win.off('.blockInViewport')

        $.each(data, function (key, value) {
          value.holder.off('.blockInViewport')

          $.each(value.items, function (key, value) {
            value.$el.removeClass(value.options.activeClass)
            value.$el.get(0).itemInViewportAdded = null
          })
        })

        data = {}
      }
    }
  }())

  ScrollDetector.init()

  $.fn.itemInViewport = function (options) {
    options = $.extend({
      activeClass: 'in-viewport',
      once: true,
      holder: '',
      visibleMode: 2 // 1 - full block, 2 - half block, 3 - immediate, 4... - custom
    }, options)

    return this.each(function () {
      if (this.itemInViewportAdded) {
        return
      }

      this.itemInViewportAdded = true

      ScrollDetector.addItem(this, options)
    })
  }
}(jQuery, jQuery(window)))

/*
 * jQuery retina cover plugin
 */
;(function ($) {
  'use strict'

  var styleRules = {}
  var templates = {
    '2x': [
      '(-webkit-min-device-pixel-ratio: 1.5)',
      '(min-resolution: 192dpi)',
      '(min-device-pixel-ratio: 1.5)',
      '(min-resolution: 1.5dppx)'
    ],
    '3x': [
      '(-webkit-min-device-pixel-ratio: 3)',
      '(min-resolution: 384dpi)',
      '(min-device-pixel-ratio: 3)',
      '(min-resolution: 3dppx)'
    ]
  }

  function addSimple (imageSrc, media, id) {
    var style = buildRule(id, imageSrc)

    addRule(media, style)
  }

  function addRetina (imageData, media, id) {
    var currentRules = templates[imageData[1]].slice()
    var patchedRules = currentRules
    var style = buildRule(id, imageData[0])

    if (media !== 'default') {
      patchedRules = $.map(currentRules, function (ele, i) {
        return ele + ' and ' + media
      })
    }

    media = patchedRules.join(',')

    addRule(media, style)
  }

  function buildRule (id, src) {
    return '#' + id + '{background-image: url("' + src + '");}'
  }

  function addRule (media, rule) {
    var $styleTag = styleRules[media]
    var styleTagData
    var rules = ''

    if (media === 'default') {
      rules = rule + ' '
    } else {
      rules = '@media ' + media + '{' + rule + '}'
    }

    if (!$styleTag) {
      styleRules[media] = $('<style>').text(rules).appendTo('head')
    } else {
      styleTagData = $styleTag.text()
      styleTagData = styleTagData.substring(0, styleTagData.length - 2) + ' }' + rule + '}'
      $styleTag.text(styleTagData)
    }
  }

  $.fn.retinaCover = function () {
    return this.each(function () {
      var $block = $(this)
      var $items = $block.children('[data-srcset]')
      var id = 'bg-stretch' + Date.now() + (Math.random() * 1000).toFixed(0)

      if ($items.length) {
        $block.attr('id', id)

        $items.each(function () {
          var $item = $(this)
          var data = $item.data('srcset').split(', ')
          var media = $item.data('media') || 'default'
          var dataLength = data.length
          var itemData
          var i

          for (i = 0; i < dataLength; i++) {
            itemData = data[i].split(' ')

            if (itemData.length === 1) {
              addSimple(itemData[0], media, id)
            } else {
              addRetina(itemData, media, id)
            }
          }
        })
      }

      $items.detach()
    })
  }
}(jQuery))

/*
 * Mobile hover plugin
 */
;(function ($) {
  // detect device type
  var isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch
  var isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent)

  // define events
  var eventOn = (isTouchDevice && 'touchstart') || (isWinPhoneDevice && navigator.pointerEnabled && 'pointerdown') || (isWinPhoneDevice && navigator.msPointerEnabled && 'MSPointerDown') || 'mouseenter'
  var eventOff = (isTouchDevice && 'touchend') || (isWinPhoneDevice && navigator.pointerEnabled && 'pointerup') || (isWinPhoneDevice && navigator.msPointerEnabled && 'MSPointerUp') || 'mouseleave'

  // event handlers
  var toggleOn, toggleOff, preventHandler
  if (isTouchDevice || isWinPhoneDevice) {
    // prevent click handler
    preventHandler = function (e) {
      e.preventDefault()
    }

    // touch device handlers
    toggleOn = function (e) {
      var options = e.data
      var element = $(this)

      var toggleOff = function (e) {
        var target = $(e.target)
        if (!target.is(element) && !target.closest(element).length) {
          element.removeClass(options.hoverClass)
          element.off('click', preventHandler)
          if (options.onLeave) options.onLeave(element)
          $(document).off(eventOn, toggleOff)
        }
      }

      if (!element.hasClass(options.hoverClass)) {
        element.addClass(options.hoverClass)
        element.one('click', preventHandler)
        $(document).on(eventOn, toggleOff)
        if (options.onHover) options.onHover(element)
      }
    }
  } else {
    // desktop browser handlers
    toggleOn = function (e) {
      var options = e.data
      var element = $(this)
      element.addClass(options.hoverClass)
      $(options.context).on(eventOff, options.selector, options, toggleOff)
      if (options.onHover) options.onHover(element)
    }
    toggleOff = function (e) {
      var options = e.data
      var element = $(this)
      element.removeClass(options.hoverClass)
      $(options.context).off(eventOff, options.selector, toggleOff)
      if (options.onLeave) options.onLeave(element)
    }
  }

  // jQuery plugin
  $.fn.touchHover = function (opt) {
    var options = $.extend({
      context: this.context,
      selector: this.selector,
      hoverClass: 'hover'
    }, opt)

    $(this.context).on(eventOn, this.selector, options, toggleOn)
    return this
  }
}(jQuery))

/*!
 * JavaScript Custom Forms
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
/*;(function (root, factory) {
  'use strict'
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory)
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'))
  } else {
    root.jcf = factory(jQuery)
  }
}(this, function ($) {
  'use strict'

  // define version
  var version = '1.1.3'

  // private variables
  var customInstances = []

  // default global options
  var commonOptions = {
    optionsKey: 'jcf',
    dataKey: 'jcf-instance',
    rtlClass: 'jcf-rtl',
    focusClass: 'jcf-focus',
    pressedClass: 'jcf-pressed',
    disabledClass: 'jcf-disabled',
    hiddenClass: 'jcf-hidden',
    resetAppearanceClass: 'jcf-reset-appearance',
    unselectableClass: 'jcf-unselectable'
  }

  // detect device type
  var isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch
  var isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent)
  commonOptions.isMobileDevice = !!(isTouchDevice || isWinPhoneDevice)

  // create global stylesheet if custom forms are used
  var createStyleSheet = function () {
    var styleTag = $('<style>').appendTo('head')
    var styleSheet = styleTag.prop('sheet') || styleTag.prop('styleSheet')

    // crossbrowser style handling
    var addCSSRule = function (selector, rules, index) {
      if (styleSheet.insertRule) {
        styleSheet.insertRule(selector + '{' + rules + '}', index)
      } else {
        styleSheet.addRule(selector, rules, index)
      }
    }

    // add special rules
    addCSSRule('.' + commonOptions.hiddenClass, 'position:absolute !important;left:-9999px !important;height:1px !important;width:1px !important;margin:0 !important;border-width:0 !important;-webkit-appearance:none;-moz-appearance:none;appearance:none', 0)
    addCSSRule('.' + commonOptions.rtlClass + ' .' + commonOptions.hiddenClass, 'right:-9999px !important; left: auto !important', 0)
    addCSSRule('.' + commonOptions.unselectableClass, '-webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -webkit-tap-highlight-color: rgba(0,0,0,0);', 0)
    addCSSRule('.' + commonOptions.resetAppearanceClass, 'background: none; border: none; -webkit-appearance: none; appearance: none; opacity: 0; filter: alpha(opacity=0);', 0)

    // detect rtl pages
    var html = $('html')
    var body = $('body')
    if (html.css('direction') === 'rtl' || body.css('direction') === 'rtl') {
      html.addClass(commonOptions.rtlClass)
    }

    // handle form reset event
    html.on('reset', function () {
      setTimeout(function () {
        api.refreshAll()
      }, 0)
    })

    // mark stylesheet as created
    commonOptions.styleSheetCreated = true
  };

  // simplified pointer events handler
  (function () {
    var pointerEventsSupported = navigator.pointerEnabled || navigator.msPointerEnabled
    var touchEventsSupported = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch
    var eventList
    var eventMap = {}
    var eventPrefix = 'jcf-'

    // detect events to attach
    if (pointerEventsSupported) {
      eventList = {
        pointerover: navigator.pointerEnabled ? 'pointerover' : 'MSPointerOver',
        pointerdown: navigator.pointerEnabled ? 'pointerdown' : 'MSPointerDown',
        pointermove: navigator.pointerEnabled ? 'pointermove' : 'MSPointerMove',
        pointerup: navigator.pointerEnabled ? 'pointerup' : 'MSPointerUp'
      }
    } else {
      eventList = {
        pointerover: 'mouseover',
        pointerdown: 'mousedown' + (touchEventsSupported ? ' touchstart' : ''),
        pointermove: 'mousemove' + (touchEventsSupported ? ' touchmove' : ''),
        pointerup: 'mouseup' + (touchEventsSupported ? ' touchend' : '')
      }
    }

    // create event map
    $.each(eventList, function (targetEventName, fakeEventList) {
      $.each(fakeEventList.split(' '), function (index, fakeEventName) {
        eventMap[fakeEventName] = targetEventName
      })
    })

    // jQuery event hooks
    $.each(eventList, function (eventName, eventHandlers) {
      eventHandlers = eventHandlers.split(' ')
      $.event.special[eventPrefix + eventName] = {
        setup: function () {
          var self = this
          $.each(eventHandlers, function (index, fallbackEvent) {
            if (self.addEventListener) self.addEventListener(fallbackEvent, fixEvent, false)
            else self['on' + fallbackEvent] = fixEvent
          })
        },
        teardown: function () {
          var self = this
          $.each(eventHandlers, function (index, fallbackEvent) {
            if (self.addEventListener) self.removeEventListener(fallbackEvent, fixEvent, false)
            else self['on' + fallbackEvent] = null
          })
        }
      }
    })

    // check that mouse event are not simulated by mobile browsers
    var lastTouch = null
    var mouseEventSimulated = function (e) {
      var dx = Math.abs(e.pageX - lastTouch.x)
      var dy = Math.abs(e.pageY - lastTouch.y)
      var rangeDistance = 25

      if (dx <= rangeDistance && dy <= rangeDistance) {
        return true
      }
    }

    // normalize event
    var fixEvent = function (e) {
      var origEvent = e || window.event
      var touchEventData = null
      var targetEventName = eventMap[origEvent.type]

      e = $.event.fix(origEvent)
      e.type = eventPrefix + targetEventName

      if (origEvent.pointerType) {
        switch (origEvent.pointerType) {
          case 2:
            e.pointerType = 'touch'
            break
          case 3:
            e.pointerType = 'pen'
            break
          case 4:
            e.pointerType = 'mouse'
            break
          default:
            e.pointerType = origEvent.pointerType
        }
      } else {
        e.pointerType = origEvent.type.substr(0, 5) // "mouse" or "touch" word length
      }

      if (!e.pageX && !e.pageY) {
        touchEventData = origEvent.changedTouches ? origEvent.changedTouches[0] : origEvent
        e.pageX = touchEventData.pageX
        e.pageY = touchEventData.pageY
      }

      if (origEvent.type === 'touchend') {
        lastTouch = { x: e.pageX, y: e.pageY }
      }
      if (e.pointerType === 'mouse' && lastTouch && mouseEventSimulated(e)) {

      } else {
        return ($.event.dispatch || $.event.handle).call(this, e)
      }
    }
  }());

  // custom mousewheel/trackpad handler
  (function () {
    var wheelEvents = ('onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll').split(' ')
    var shimEventName = 'jcf-mousewheel'

    $.event.special[shimEventName] = {
      setup: function () {
        var self = this
        $.each(wheelEvents, function (index, fallbackEvent) {
          if (self.addEventListener) self.addEventListener(fallbackEvent, fixEvent, false)
          else self['on' + fallbackEvent] = fixEvent
        })
      },
      teardown: function () {
        var self = this
        $.each(wheelEvents, function (index, fallbackEvent) {
          if (self.addEventListener) self.removeEventListener(fallbackEvent, fixEvent, false)
          else self['on' + fallbackEvent] = null
        })
      }
    }

    var fixEvent = function (e) {
      var origEvent = e || window.event
      e = $.event.fix(origEvent)
      e.type = shimEventName

      // old wheel events handler
      if ('detail' in origEvent) {
        e.deltaY = -origEvent.detail
      }
      if ('wheelDelta' in origEvent) {
        e.deltaY = -origEvent.wheelDelta
      }
      if ('wheelDeltaY' in origEvent) {
        e.deltaY = -origEvent.wheelDeltaY
      }
      if ('wheelDeltaX' in origEvent) {
        e.deltaX = -origEvent.wheelDeltaX
      }

      // modern wheel event handler
      if ('deltaY' in origEvent) {
        e.deltaY = origEvent.deltaY
      }
      if ('deltaX' in origEvent) {
        e.deltaX = origEvent.deltaX
      }

      // handle deltaMode for mouse wheel
      e.delta = e.deltaY || e.deltaX
      if (origEvent.deltaMode === 1) {
        var lineHeight = 16
        e.delta *= lineHeight
        e.deltaY *= lineHeight
        e.deltaX *= lineHeight
      }

      return ($.event.dispatch || $.event.handle).call(this, e)
    }
  }())

  // extra module methods
  var moduleMixin = {
    // provide function for firing native events
    fireNativeEvent: function (elements, eventName) {
      $(elements).each(function () {
        var element = this
        var eventObject
        if (element.dispatchEvent) {
          eventObject = document.createEvent('HTMLEvents')
          eventObject.initEvent(eventName, true, true)
          element.dispatchEvent(eventObject)
        } else if (document.createEventObject) {
          eventObject = document.createEventObject()
          eventObject.target = element
          element.fireEvent('on' + eventName, eventObject)
        }
      })
    },
    // bind event handlers for module instance (functions beggining with "on")
    bindHandlers: function () {
      var self = this
      $.each(self, function (propName, propValue) {
        if (propName.indexOf('on') === 0 && $.isFunction(propValue)) {
          // dont use $.proxy here because it doesn't create unique handler
          self[propName] = function () {
            return propValue.apply(self, arguments)
          }
        }
      })
    }
  }

  // public API
  var api = {
    version: version,
    modules: {},
    getOptions: function () {
      return $.extend({}, commonOptions)
    },
    setOptions: function (moduleName, moduleOptions) {
      if (arguments.length > 1) {
        // set module options
        if (this.modules[moduleName]) {
          $.extend(this.modules[moduleName].prototype.options, moduleOptions)
        }
      } else {
        // set common options
        $.extend(commonOptions, moduleName)
      }
    },
    addModule: function (proto) {
      // add module to list
      var Module = function (options) {
        // save instance to collection
        if (!options.element.data(commonOptions.dataKey)) {
          options.element.data(commonOptions.dataKey, this)
        }
        customInstances.push(this)

        // save options
        this.options = $.extend({}, commonOptions, this.options, getInlineOptions(options.element), options)

        // bind event handlers to instance
        this.bindHandlers()

        // call constructor
        this.init.apply(this, arguments)
      }

      // parse options from HTML attribute
      var getInlineOptions = function (element) {
        var dataOptions = element.data(commonOptions.optionsKey)
        var attrOptions = element.attr(commonOptions.optionsKey)

        if (dataOptions) {
          return dataOptions
        } else if (attrOptions) {
          try {
            return $.parseJSON(attrOptions)
          } catch (e) {
            // ignore invalid attributes
          }
        }
      }

      // set proto as prototype for new module
      Module.prototype = proto

      // add mixin methods to module proto
      $.extend(proto, moduleMixin)
      if (proto.plugins) {
        $.each(proto.plugins, function (pluginName, plugin) {
          $.extend(plugin.prototype, moduleMixin)
        })
      }

      // override destroy method
      var originalDestroy = Module.prototype.destroy
      Module.prototype.destroy = function () {
        this.options.element.removeData(this.options.dataKey)

        for (var i = customInstances.length - 1; i >= 0; i--) {
          if (customInstances[i] === this) {
            customInstances.splice(i, 1)
            break
          }
        }

        if (originalDestroy) {
          originalDestroy.apply(this, arguments)
        }
      }

      // save module to list
      this.modules[proto.name] = Module
    },
    getInstance: function (element) {
      return $(element).data(commonOptions.dataKey)
    },
    replace: function (elements, moduleName, customOptions) {
      var self = this
      var instance

      if (!commonOptions.styleSheetCreated) {
        createStyleSheet()
      }

      $(elements).each(function () {
        var moduleOptions
        var element = $(this)

        instance = element.data(commonOptions.dataKey)
        if (instance) {
          instance.refresh()
        } else {
          if (!moduleName) {
            $.each(self.modules, function (currentModuleName, module) {
              // eslint-disable-next-line no-useless-call
              if (module.prototype.matchElement.call(module.prototype, element)) {
                moduleName = currentModuleName
                return false
              }
            })
          }
          if (moduleName) {
            moduleOptions = $.extend({ element: element }, customOptions)
            instance = new self.modules[moduleName](moduleOptions)
          }
        }
      })
      return instance
    },
    refresh: function (elements) {
      $(elements).each(function () {
        var instance = $(this).data(commonOptions.dataKey)
        if (instance) {
          instance.refresh()
        }
      })
    },
    destroy: function (elements) {
      $(elements).each(function () {
        var instance = $(this).data(commonOptions.dataKey)
        if (instance) {
          instance.destroy()
        }
      })
    },
    replaceAll: function (context) {
      var self = this
      $.each(this.modules, function (moduleName, module) {
        $(module.prototype.selector, context).each(function () {
          if (this.className.indexOf('jcf-ignore') < 0) {
            self.replace(this, moduleName)
          }
        })
      })
    },
    refreshAll: function (context) {
      if (context) {
        $.each(this.modules, function (moduleName, module) {
          $(module.prototype.selector, context).each(function () {
            var instance = $(this).data(commonOptions.dataKey)
            if (instance) {
              instance.refresh()
            }
          })
        })
      } else {
        for (var i = customInstances.length - 1; i >= 0; i--) {
          customInstances[i].refresh()
        }
      }
    },
    destroyAll: function (context) {
      if (context) {
        $.each(this.modules, function (moduleName, module) {
          $(module.prototype.selector, context).each(function (index, element) {
            var instance = $(element).data(commonOptions.dataKey)
            if (instance) {
              instance.destroy()
            }
          })
        })
      } else {
        while (customInstances.length) {
          customInstances[0].destroy()
        }
      }
    }
  }

  // always export API to the global window object
  window.jcf = api

  return api
}))*/

/*!
 * JavaScript Custom Forms : Scrollbar Module
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
/*;(function ($, window) {
  'use strict'

  jcf.addModule({
    name: 'Scrollable',
    selector: '.jcf-scrollable',
    plugins: {
      ScrollBar: ScrollBar
    },
    options: {
      mouseWheelStep: 150,
      handleResize: true,
      alwaysShowScrollbars: false,
      alwaysPreventMouseWheel: false,
      scrollAreaStructure: '<div class="jcf-scrollable-wrapper"></div>'
    },
    matchElement: function (element) {
      return element.is('.jcf-scrollable')
    },
    init: function () {
      this.initStructure()
      this.attachEvents()
      this.rebuildScrollbars()
    },
    initStructure: function () {
      // prepare structure
      this.doc = $(document)
      this.win = $(window)
      this.realElement = $(this.options.element)
      this.scrollWrapper = $(this.options.scrollAreaStructure).insertAfter(this.realElement)

      // set initial styles
      this.scrollWrapper.css('position', 'relative')
      this.realElement.css('overflow', 'hidden')
      this.vBarEdge = 0
    },
    attachEvents: function () {
      // create scrollbars
      var self = this
      this.vBar = new ScrollBar({
        holder: this.scrollWrapper,
        vertical: true,
        onScroll: function (scrollTop) {
          self.realElement.scrollTop(scrollTop)
        }
      })
      this.hBar = new ScrollBar({
        holder: this.scrollWrapper,
        vertical: false,
        onScroll: function (scrollLeft) {
          self.realElement.scrollLeft(scrollLeft)
        }
      })

      // add event handlers
      this.realElement.on('scroll', this.onScroll)
      if (this.options.handleResize) {
        this.win.on('resize orientationchange load', this.onResize)
      }

      // add pointer/wheel event handlers
      this.realElement.on('jcf-mousewheel', this.onMouseWheel)
      this.realElement.on('jcf-pointerdown', this.onTouchBody)
    },
    onScroll: function () {
      this.redrawScrollbars()
    },
    onResize: function () {
      // do not rebuild scrollbars if form field is in focus
      if (!$(document.activeElement).is(':input')) {
        this.rebuildScrollbars()
      }
    },
    onTouchBody: function (e) {
      if (e.pointerType === 'touch') {
        this.touchData = {
          scrollTop: this.realElement.scrollTop(),
          scrollLeft: this.realElement.scrollLeft(),
          left: e.pageX,
          top: e.pageY
        }
        this.doc.on({
          'jcf-pointermove': this.onMoveBody,
          'jcf-pointerup': this.onReleaseBody
        })
      }
    },
    onMoveBody: function (e) {
      var targetScrollTop
      var targetScrollLeft
      var verticalScrollAllowed = this.verticalScrollActive
      var horizontalScrollAllowed = this.horizontalScrollActive

      if (e.pointerType === 'touch') {
        targetScrollTop = this.touchData.scrollTop - e.pageY + this.touchData.top
        targetScrollLeft = this.touchData.scrollLeft - e.pageX + this.touchData.left

        // check that scrolling is ended and release outer scrolling
        if (this.verticalScrollActive && (targetScrollTop < 0 || targetScrollTop > this.vBar.maxValue)) {
          verticalScrollAllowed = false
        }
        if (this.horizontalScrollActive && (targetScrollLeft < 0 || targetScrollLeft > this.hBar.maxValue)) {
          horizontalScrollAllowed = false
        }

        this.realElement.scrollTop(targetScrollTop)
        this.realElement.scrollLeft(targetScrollLeft)

        if (verticalScrollAllowed || horizontalScrollAllowed) {
          e.preventDefault()
        } else {
          this.onReleaseBody(e)
        }
      }
    },
    onReleaseBody: function (e) {
      if (e.pointerType === 'touch') {
        delete this.touchData
        this.doc.off({
          'jcf-pointermove': this.onMoveBody,
          'jcf-pointerup': this.onReleaseBody
        })
      }
    },
    onMouseWheel: function (e) {
      var currentScrollTop = this.realElement.scrollTop()
      var currentScrollLeft = this.realElement.scrollLeft()
      var maxScrollTop = this.realElement.prop('scrollHeight') - this.embeddedDimensions.innerHeight
      var maxScrollLeft = this.realElement.prop('scrollWidth') - this.embeddedDimensions.innerWidth
      var extraLeft
      var extraTop
      var preventFlag

      // check edge cases
      if (!this.options.alwaysPreventMouseWheel) {
        if (this.verticalScrollActive && e.deltaY) {
          if (!(currentScrollTop <= 0 && e.deltaY < 0) && !(currentScrollTop >= maxScrollTop && e.deltaY > 0)) {
            preventFlag = true
          }
        }
        if (this.horizontalScrollActive && e.deltaX) {
          if (!(currentScrollLeft <= 0 && e.deltaX < 0) && !(currentScrollLeft >= maxScrollLeft && e.deltaX > 0)) {
            preventFlag = true
          }
        }
        if (!this.verticalScrollActive && !this.horizontalScrollActive) {
          return
        }
      }

      // prevent default action and scroll item
      if (preventFlag || this.options.alwaysPreventMouseWheel) {
        e.preventDefault()
      } else {
        return
      }

      extraLeft = e.deltaX / 100 * this.options.mouseWheelStep
      extraTop = e.deltaY / 100 * this.options.mouseWheelStep

      this.realElement.scrollTop(currentScrollTop + extraTop)
      this.realElement.scrollLeft(currentScrollLeft + extraLeft)
    },
    setScrollBarEdge: function (edgeSize) {
      this.vBarEdge = edgeSize || 0
      this.redrawScrollbars()
    },
    saveElementDimensions: function () {
      this.savedDimensions = {
        top: this.realElement.width(),
        left: this.realElement.height()
      }
      return this
    },
    restoreElementDimensions: function () {
      if (this.savedDimensions) {
        this.realElement.css({
          width: this.savedDimensions.width,
          height: this.savedDimensions.height
        })
      }
      return this
    },
    saveScrollOffsets: function () {
      this.savedOffsets = {
        top: this.realElement.scrollTop(),
        left: this.realElement.scrollLeft()
      }
      return this
    },
    restoreScrollOffsets: function () {
      if (this.savedOffsets) {
        this.realElement.scrollTop(this.savedOffsets.top)
        this.realElement.scrollLeft(this.savedOffsets.left)
      }
      return this
    },
    getContainerDimensions: function () {
      // save current styles
      var desiredDimensions,
        currentStyles,
        currentHeight,
        currentWidth

      if (this.isModifiedStyles) {
        desiredDimensions = {
          width: this.realElement.innerWidth() + this.vBar.getThickness(),
          height: this.realElement.innerHeight() + this.hBar.getThickness()
        }
      } else {
        // unwrap real element and measure it according to CSS
        this.saveElementDimensions().saveScrollOffsets()
        this.realElement.insertAfter(this.scrollWrapper)
        this.scrollWrapper.detach()

        // measure element
        currentStyles = this.realElement.prop('style')
        currentWidth = parseFloat(currentStyles.width)
        currentHeight = parseFloat(currentStyles.height)

        // reset styles if needed
        if (this.embeddedDimensions && currentWidth && currentHeight) {
          this.isModifiedStyles |= (currentWidth !== this.embeddedDimensions.width || currentHeight !== this.embeddedDimensions.height)
          this.realElement.css({
            overflow: '',
            width: '',
            height: ''
          })
        }

        // calculate desired dimensions for real element
        desiredDimensions = {
          width: this.realElement.outerWidth(),
          height: this.realElement.outerHeight()
        }

        // restore structure and original scroll offsets
        this.scrollWrapper.insertAfter(this.realElement)
        this.realElement.css('overflow', 'hidden').prependTo(this.scrollWrapper)
        this.restoreElementDimensions().restoreScrollOffsets()
      }

      return desiredDimensions
    },
    getEmbeddedDimensions: function (dimensions) {
      // handle scrollbars cropping
      var fakeBarWidth = this.vBar.getThickness()
      var fakeBarHeight = this.hBar.getThickness()
      var paddingWidth = this.realElement.outerWidth() - this.realElement.width()
      var paddingHeight = this.realElement.outerHeight() - this.realElement.height()
      var resultDimensions

      if (this.options.alwaysShowScrollbars) {
        // simply return dimensions without custom scrollbars
        this.verticalScrollActive = true
        this.horizontalScrollActive = true
        resultDimensions = {
          innerWidth: dimensions.width - fakeBarWidth,
          innerHeight: dimensions.height - fakeBarHeight
        }
      } else {
        // detect when to display each scrollbar
        this.saveElementDimensions()
        this.verticalScrollActive = false
        this.horizontalScrollActive = false

        // fill container with full size
        this.realElement.css({
          width: dimensions.width - paddingWidth,
          height: dimensions.height - paddingHeight
        })

        this.horizontalScrollActive = this.realElement.prop('scrollWidth') > this.containerDimensions.width
        this.verticalScrollActive = this.realElement.prop('scrollHeight') > this.containerDimensions.height

        this.restoreElementDimensions()
        resultDimensions = {
          innerWidth: dimensions.width - (this.verticalScrollActive ? fakeBarWidth : 0),
          innerHeight: dimensions.height - (this.horizontalScrollActive ? fakeBarHeight : 0)
        }
      }
      $.extend(resultDimensions, {
        width: resultDimensions.innerWidth - paddingWidth,
        height: resultDimensions.innerHeight - paddingHeight
      })
      return resultDimensions
    },
    rebuildScrollbars: function () {
      // resize wrapper according to real element styles
      this.containerDimensions = this.getContainerDimensions()
      this.embeddedDimensions = this.getEmbeddedDimensions(this.containerDimensions)

      // resize wrapper to desired dimensions
      this.scrollWrapper.css({
        width: this.containerDimensions.width,
        height: this.containerDimensions.height
      })

      // resize element inside wrapper excluding scrollbar size
      this.realElement.css({
        overflow: 'hidden',
        width: this.embeddedDimensions.width,
        height: this.embeddedDimensions.height
      })

      // redraw scrollbar offset
      this.redrawScrollbars()
    },
    redrawScrollbars: function () {
      var viewSize, maxScrollValue

      // redraw vertical scrollbar
      if (this.verticalScrollActive) {
        viewSize = this.vBarEdge ? this.containerDimensions.height - this.vBarEdge : this.embeddedDimensions.innerHeight
        maxScrollValue = Math.max(this.realElement.prop('offsetHeight'), this.realElement.prop('scrollHeight')) - this.vBarEdge

        this.vBar.show().setMaxValue(maxScrollValue - viewSize).setRatio(viewSize / maxScrollValue).setSize(viewSize)
        this.vBar.setValue(this.realElement.scrollTop())
      } else {
        this.vBar.hide()
      }

      // redraw horizontal scrollbar
      if (this.horizontalScrollActive) {
        viewSize = this.embeddedDimensions.innerWidth
        maxScrollValue = this.realElement.prop('scrollWidth')

        if (maxScrollValue === viewSize) {
          this.horizontalScrollActive = false
        }
        this.hBar.show().setMaxValue(maxScrollValue - viewSize).setRatio(viewSize / maxScrollValue).setSize(viewSize)
        this.hBar.setValue(this.realElement.scrollLeft())
      } else {
        this.hBar.hide()
      }

      // set "touch-action" style rule
      var touchAction = ''
      if (this.verticalScrollActive && this.horizontalScrollActive) {
        touchAction = 'none'
      } else if (this.verticalScrollActive) {
        touchAction = 'pan-x'
      } else if (this.horizontalScrollActive) {
        touchAction = 'pan-y'
      }
      this.realElement.css('touchAction', touchAction)
    },
    refresh: function () {
      this.rebuildScrollbars()
    },
    destroy: function () {
      // remove event listeners
      this.win.off('resize orientationchange load', this.onResize)
      this.realElement.off({
        'jcf-mousewheel': this.onMouseWheel,
        'jcf-pointerdown': this.onTouchBody
      })
      this.doc.off({
        'jcf-pointermove': this.onMoveBody,
        'jcf-pointerup': this.onReleaseBody
      })

      // restore structure
      this.saveScrollOffsets()
      this.vBar.destroy()
      this.hBar.destroy()
      this.realElement.insertAfter(this.scrollWrapper).css({
        touchAction: '',
        overflow: '',
        width: '',
        height: ''
      })
      this.scrollWrapper.remove()
      this.restoreScrollOffsets()
    }
  })

  // custom scrollbar
  function ScrollBar (options) {
    this.options = $.extend({
      holder: null,
      vertical: true,
      inactiveClass: 'jcf-inactive',
      verticalClass: 'jcf-scrollbar-vertical',
      horizontalClass: 'jcf-scrollbar-horizontal',
      scrollbarStructure: '<div class="jcf-scrollbar"><div class="jcf-scrollbar-dec"></div><div class="jcf-scrollbar-slider"><div class="jcf-scrollbar-handle"></div></div><div class="jcf-scrollbar-inc"></div></div>',
      btnDecSelector: '.jcf-scrollbar-dec',
      btnIncSelector: '.jcf-scrollbar-inc',
      sliderSelector: '.jcf-scrollbar-slider',
      handleSelector: '.jcf-scrollbar-handle',
      scrollInterval: 300,
      scrollStep: 400 // px/sec
    }, options)
    this.init()
  }

  $.extend(ScrollBar.prototype, {
    init: function () {
      this.initStructure()
      this.attachEvents()
    },
    initStructure: function () {
      // define proporties
      this.doc = $(document)
      this.isVertical = !!this.options.vertical
      this.sizeProperty = this.isVertical ? 'height' : 'width'
      this.fullSizeProperty = this.isVertical ? 'outerHeight' : 'outerWidth'
      this.invertedSizeProperty = this.isVertical ? 'width' : 'height'
      this.thicknessMeasureMethod = 'outer' + this.invertedSizeProperty.charAt(0).toUpperCase() + this.invertedSizeProperty.substr(1)
      this.offsetProperty = this.isVertical ? 'top' : 'left'
      this.offsetEventProperty = this.isVertical ? 'pageY' : 'pageX'

      // initialize variables
      this.value = this.options.value || 0
      this.maxValue = this.options.maxValue || 0
      this.currentSliderSize = 0
      this.handleSize = 0

      // find elements
      this.holder = $(this.options.holder)
      this.scrollbar = $(this.options.scrollbarStructure).appendTo(this.holder)
      this.btnDec = this.scrollbar.find(this.options.btnDecSelector)
      this.btnInc = this.scrollbar.find(this.options.btnIncSelector)
      this.slider = this.scrollbar.find(this.options.sliderSelector)
      this.handle = this.slider.find(this.options.handleSelector)

      // set initial styles
      this.scrollbar.addClass(this.isVertical ? this.options.verticalClass : this.options.horizontalClass).css({
        touchAction: this.isVertical ? 'pan-x' : 'pan-y',
        position: 'absolute'
      })
      this.slider.css({
        position: 'relative'
      })
      this.handle.css({
        touchAction: 'none',
        position: 'absolute'
      })
    },
    attachEvents: function () {
      this.bindHandlers()
      this.handle.on('jcf-pointerdown', this.onHandlePress)
      this.slider.add(this.btnDec).add(this.btnInc).on('jcf-pointerdown', this.onButtonPress)
    },
    onHandlePress: function (e) {
      if (e.pointerType === 'mouse' && e.button > 1) {

      } else {
        e.preventDefault()
        this.handleDragActive = true
        this.sliderOffset = this.slider.offset()[this.offsetProperty]
        this.innerHandleOffset = e[this.offsetEventProperty] - this.handle.offset()[this.offsetProperty]

        this.doc.on('jcf-pointermove', this.onHandleDrag)
        this.doc.on('jcf-pointerup', this.onHandleRelease)
      }
    },
    onHandleDrag: function (e) {
      e.preventDefault()
      this.calcOffset = e[this.offsetEventProperty] - this.sliderOffset - this.innerHandleOffset
      this.setValue(this.calcOffset / (this.currentSliderSize - this.handleSize) * this.maxValue)
      this.triggerScrollEvent(this.value)
    },
    onHandleRelease: function () {
      this.handleDragActive = false
      this.doc.off('jcf-pointermove', this.onHandleDrag)
      this.doc.off('jcf-pointerup', this.onHandleRelease)
    },
    onButtonPress: function (e) {
      var direction, clickOffset
      if (e.pointerType === 'mouse' && e.button > 1) {

      } else {
        e.preventDefault()
        if (!this.handleDragActive) {
          if (this.slider.is(e.currentTarget)) {
            // slider pressed
            direction = this.handle.offset()[this.offsetProperty] > e[this.offsetEventProperty] ? -1 : 1
            clickOffset = e[this.offsetEventProperty] - this.slider.offset()[this.offsetProperty]
            this.startPageScrolling(direction, clickOffset)
          } else {
            // scrollbar buttons pressed
            direction = this.btnDec.is(e.currentTarget) ? -1 : 1
            this.startSmoothScrolling(direction)
          }
          this.doc.on('jcf-pointerup', this.onButtonRelease)
        }
      }
    },
    onButtonRelease: function () {
      this.stopPageScrolling()
      this.stopSmoothScrolling()
      this.doc.off('jcf-pointerup', this.onButtonRelease)
    },
    startPageScrolling: function (direction, clickOffset) {
      var self = this
      var stepValue = direction * self.currentSize

      // limit checker
      var isFinishedScrolling = function () {
        var handleTop = (self.value / self.maxValue) * (self.currentSliderSize - self.handleSize)

        if (direction > 0) {
          return handleTop + self.handleSize >= clickOffset
        } else {
          return handleTop <= clickOffset
        }
      }

      // scroll by page when track is pressed
      var doPageScroll = function () {
        self.value += stepValue
        self.setValue(self.value)
        self.triggerScrollEvent(self.value)

        if (isFinishedScrolling()) {
          clearInterval(self.pageScrollTimer)
        }
      }

      // start scrolling
      this.pageScrollTimer = setInterval(doPageScroll, this.options.scrollInterval)
      doPageScroll()
    },
    stopPageScrolling: function () {
      clearInterval(this.pageScrollTimer)
    },
    startSmoothScrolling: function (direction) {
      var self = this
      var dt
      this.stopSmoothScrolling()

      // simple animation functions
      var raf = window.requestAnimationFrame || function (func) {
        setTimeout(func, 16)
      }
      var getTimestamp = function () {
        return Date.now ? Date.now() : new Date().getTime()
      }

      // set animation limit
      var isFinishedScrolling = function () {
        if (direction > 0) {
          return self.value >= self.maxValue
        } else {
          return self.value <= 0
        }
      }

      // animation step
      var doScrollAnimation = function () {
        var stepValue = (getTimestamp() - dt) / 1000 * self.options.scrollStep

        if (self.smoothScrollActive) {
          self.value += stepValue * direction
          self.setValue(self.value)
          self.triggerScrollEvent(self.value)

          if (!isFinishedScrolling()) {
            dt = getTimestamp()
            raf(doScrollAnimation)
          }
        }
      }

      // start animation
      self.smoothScrollActive = true
      dt = getTimestamp()
      raf(doScrollAnimation)
    },
    stopSmoothScrolling: function () {
      this.smoothScrollActive = false
    },
    triggerScrollEvent: function (scrollValue) {
      if (this.options.onScroll) {
        this.options.onScroll(scrollValue)
      }
    },
    getThickness: function () {
      return this.scrollbar[this.thicknessMeasureMethod]()
    },
    setSize: function (size) {
      // resize scrollbar
      var btnDecSize = this.btnDec[this.fullSizeProperty]()
      var btnIncSize = this.btnInc[this.fullSizeProperty]()

      // resize slider
      this.currentSize = size
      this.currentSliderSize = size - btnDecSize - btnIncSize
      this.scrollbar.css(this.sizeProperty, size)
      this.slider.css(this.sizeProperty, this.currentSliderSize)
      this.currentSliderSize = this.slider[this.sizeProperty]()

      // resize handle
      this.handleSize = Math.round(this.currentSliderSize * this.ratio)
      this.handle.css(this.sizeProperty, this.handleSize)
      this.handleSize = this.handle[this.fullSizeProperty]()

      return this
    },
    setRatio: function (ratio) {
      this.ratio = ratio
      return this
    },
    setMaxValue: function (maxValue) {
      this.maxValue = maxValue
      this.setValue(Math.min(this.value, this.maxValue))
      return this
    },
    setValue: function (value) {
      this.value = value
      if (this.value < 0) {
        this.value = 0
      } else if (this.value > this.maxValue) {
        this.value = this.maxValue
      }
      this.refresh()
    },
    setPosition: function (styles) {
      this.scrollbar.css(styles)
      return this
    },
    hide: function () {
      this.scrollbar.detach()
      return this
    },
    show: function () {
      this.scrollbar.appendTo(this.holder)
      return this
    },
    refresh: function () {
      // recalculate handle position
      if (this.value === 0 || this.maxValue === 0) {
        this.calcOffset = 0
      } else {
        this.calcOffset = (this.value / this.maxValue) * (this.currentSliderSize - this.handleSize)
      }
      this.handle.css(this.offsetProperty, this.calcOffset)

      // toggle inactive classes
      this.btnDec.toggleClass(this.options.inactiveClass, this.value === 0)
      this.btnInc.toggleClass(this.options.inactiveClass, this.value === this.maxValue)
      this.scrollbar.toggleClass(this.options.inactiveClass, this.maxValue === 0)
    },
    destroy: function () {
      // remove event handlers and scrollbar block itself
      this.btnDec.add(this.btnInc).off('jcf-pointerdown', this.onButtonPress)
      this.handle.off('jcf-pointerdown', this.onHandlePress)
      this.doc.off('jcf-pointermove', this.onHandleDrag)
      this.doc.off('jcf-pointerup', this.onHandleRelease)
      this.doc.off('jcf-pointerup', this.onButtonRelease)
      this.stopSmoothScrolling()
      this.stopPageScrolling()
      this.scrollbar.remove()
    }
  })
}(jQuery, this))*/

// navigation accesibility module
function TouchNav (opt) {
  this.options = {
    hoverClass: 'hover',
    menuItems: 'li',
    menuOpener: 'a',
    menuDrop: 'ul',
    navBlock: null
  }
  for (var p in opt) {
    const hasProperty = Object.prototype.hasOwnProperty.call(opt, 'p')
    if (hasProperty) {
      this.options[p] = opt[p]
    }
  }
  this.init()
}

TouchNav.isActiveOn = function (elem) {
  return elem && elem.touchNavActive
}
TouchNav.prototype = {
  init: function () {
    if (typeof this.options.navBlock === 'string') {
      this.menu = document.getElementById(this.options.navBlock)
    } else if (typeof this.options.navBlock === 'object') {
      this.menu = this.options.navBlock
    }
    if (this.menu) {
      this.addEvents()
    }
  },
  addEvents: function () {
    // attach event handlers
    var self = this
    var touchEvent = (navigator.pointerEnabled && 'pointerdown') || (navigator.msPointerEnabled && 'MSPointerDown') || (this.isTouchDevice && 'touchstart')
    this.menuItems = lib.queryElementsBySelector(this.options.menuItems, this.menu)

    var initMenuItem = function (item) {
      var currentDrop = lib.queryElementsBySelector(self.options.menuDrop, item)[0]
      var currentOpener = lib.queryElementsBySelector(self.options.menuOpener, item)[0]

      // only for touch input devices
      if (currentDrop && currentOpener && (self.isTouchDevice || self.isPointerDevice)) {
        lib.event.add(currentOpener, 'click', lib.bind(self.clickHandler, self))
        lib.event.add(currentOpener, 'mousedown', lib.bind(self.mousedownHandler, self))
        lib.event.add(currentOpener, touchEvent, function (e) {
          if (!self.isTouchPointerEvent(e)) {
            self.preventCurrentClick = false
            return
          }
          self.touchFlag = true
          self.currentItem = item
          self.currentLink = currentOpener
          self.pressHandler.apply(self, arguments)
        })
      }
      // for desktop computers and touch devices
      jQuery(item).on('mouseenter', function () {
        if (!self.touchFlag) {
          self.currentItem = item
          self.mouseoverHandler()
        }
      })
      jQuery(item).on('mouseleave', function () {
        if (!self.touchFlag) {
          self.currentItem = item
          self.mouseoutHandler()
        }
      })
      item.touchNavActive = true
    }

    // add handlers for all menu items
    for (var i = 0; i < this.menuItems.length; i++) {
      initMenuItem(self.menuItems[i])
    }

    // hide dropdowns when clicking outside navigation
    if (this.isTouchDevice || this.isPointerDevice) {
      lib.event.add(document.documentElement, 'mousedown', lib.bind(this.clickOutsideHandler, this))
      lib.event.add(document.documentElement, touchEvent, lib.bind(this.clickOutsideHandler, this))
    }
  },
  mousedownHandler: function (e) {
    if (this.touchFlag) {
      e.preventDefault()
      this.touchFlag = false
      this.preventCurrentClick = false
    }
  },
  mouseoverHandler: function () {
    lib.addClass(this.currentItem, this.options.hoverClass)
    jQuery(this.currentItem).trigger('itemhover')
  },
  mouseoutHandler: function () {
    lib.removeClass(this.currentItem, this.options.hoverClass)
    jQuery(this.currentItem).trigger('itemleave')
  },
  hideActiveDropdown: function () {
    for (var i = 0; i < this.menuItems.length; i++) {
      if (lib.hasClass(this.menuItems[i], this.options.hoverClass)) {
        lib.removeClass(this.menuItems[i], this.options.hoverClass)
        jQuery(this.menuItems[i]).trigger('itemleave')
      }
    }
    this.activeParent = null
  },
  pressHandler: function (e) {
    // hide previous drop (if active)
    if (this.currentItem !== this.activeParent) {
      if (this.activeParent && this.currentItem.parentNode === this.activeParent.parentNode) {
        lib.removeClass(this.activeParent, this.options.hoverClass)
      } else if (!this.isParent(this.activeParent, this.currentLink)) {
        this.hideActiveDropdown()
      }
    }
    // handle current drop
    this.activeParent = this.currentItem
    if (lib.hasClass(this.currentItem, this.options.hoverClass)) {
      this.preventCurrentClick = false
    } else {
      e.preventDefault()
      this.preventCurrentClick = true
      lib.addClass(this.currentItem, this.options.hoverClass)
      jQuery(this.currentItem).trigger('itemhover')
    }
  },
  clickHandler: function (e) {
    // prevent first click on link
    if (this.preventCurrentClick) {
      e.preventDefault()
    }
  },
  clickOutsideHandler: function (event) {
    var e = event.changedTouches ? event.changedTouches[0] : event
    if (this.activeParent && !this.isParent(this.menu, e.target)) {
      this.hideActiveDropdown()
      this.touchFlag = false
    }
  },
  isParent: function (parent, child) {
    while (child.parentNode) {
      if (child.parentNode === parent) {
        return true
      }
      child = child.parentNode
    }
    return false
  },
  isTouchPointerEvent: function (e) {
    return (e.type.indexOf('touch') > -1) ||
      (navigator.pointerEnabled && e.pointerType === 'touch') ||
      (navigator.msPointerEnabled && e.pointerType === e.MSPOINTER_TYPE_TOUCH)
  },
  isPointerDevice: (function () {
    return !!(navigator.pointerEnabled || navigator.msPointerEnabled)
  }()),
  isTouchDevice: (function () {
    return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch)
  }())
}

/*
 * Utility module
 */
var lib = {
  hasClass: function (el, cls) {
    return el && el.className ? el.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)')) : false
  },
  addClass: function (el, cls) {
    if (el && !this.hasClass(el, cls)) el.className += ' ' + cls
  },
  removeClass: function (el, cls) {
    if (el && this.hasClass(el, cls)) {
      el.className = el.className.replace(new RegExp('(\\s|^)' + cls + '(\\s|$)'), ' ')
    }
  },
  extend: function (obj) {
    for (var i = 1; i < arguments.length; i++) {
      for (var p in arguments[i]) {
        const hasProperty = Object.prototype.hasOwnProperty.call(arguments[i], 'p')
        if (hasProperty) {
          obj[p] = arguments[i][p]
        }
      }
    }
    return obj
  },
  each: function (obj, callback) {
    var property, len
    if (typeof obj.length === 'number') {
      for (property = 0, len = obj.length; property < len; property++) {
        if (callback.call(obj[property], property, obj[property]) === false) {
          break
        }
      }
    } else {
      for (property in obj) {
        const hasProperty = Object.prototype.hasOwnProperty.call(obj, 'property')
        if (hasProperty) {
          if (callback.call(obj[property], property, obj[property]) === false) {
            break
          }
        }
      }
    }
  },
  event: (function () {
    var fixEvent = function (e) {
      e = e || window.event
      if (e.isFixed) { return e } else { e.isFixed = true }
      if (!e.target) e.target = e.srcElement
      e.preventDefault = e.preventDefault || function () {
        this.returnValue = false
      }
      e.stopPropagation = e.stopPropagation || function () {
        this.cancelBubble = true
      }
      return e
    }
    return {
      add: function (elem, event, handler) {
        if (!elem.events) {
          elem.events = {}
          elem.handle = function (e) {
            var ret
            var handlers = elem.events[e.type]
            e = fixEvent(e)
            for (var i = 0, len = handlers.length; i < len; i++) {
              if (handlers[i]) {
                ret = handlers[i].call(elem, e)
                if (ret === false) {
                  e.preventDefault()
                  e.stopPropagation()
                }
              }
            }
          }
        }
        if (!elem.events[event]) {
          elem.events[event] = []
          if (elem.addEventListener) elem.addEventListener(event, elem.handle, false)
          else if (elem.attachEvent) elem.attachEvent('on' + event, elem.handle)
        }
        elem.events[event].push(handler)
      },
      remove: function (elem, event, handler) {
        var handlers = elem.events[event]
        for (var i = handlers.length - 1; i >= 0; i--) {
          if (handlers[i] === handler) {
            handlers.splice(i, 1)
          }
        }
        if (!handlers.length) {
          delete elem.events[event]
          if (elem.removeEventListener) elem.removeEventListener(event, elem.handle, false)
          else if (elem.detachEvent) elem.detachEvent('on' + event, elem.handle)
        }
      }
    }
  }()),
  queryElementsBySelector: function (selector, scope) {
    scope = scope || document
    if (!selector) return []
    if (selector === '>*') return scope.children
    if (typeof document.querySelectorAll === 'function') {
      return scope.querySelectorAll(selector)
    }
    var selectors = selector.split(',')
    var resultList = []
    for (var s = 0; s < selectors.length; s++) {
      var currentContext = [scope || document]
      var tokens = selectors[s].replace(/^\s+/, '').replace(/\s+$/, '').split(' ')
      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '')
        let bits, tagName
        if (token.indexOf('#') > -1) {
          bits = token.split('#')
          tagName = bits[0]
          var id = bits[1]
          var element = document.getElementById(id)
          if (element && tagName && element.nodeName.toLowerCase() !== tagName) {
            return []
          }
          currentContext = element ? [element] : []
          continue
        }
        let found, foundCount
        if (token.indexOf('.') > -1) {
          bits = token.split('.')
          tagName = bits[0] || '*'
          var className = bits[1]
          found = []
          foundCount = 0
          for (var h = 0; h < currentContext.length; h++) {
            var elements
            if (tagName === '*') {
              elements = currentContext[h].getElementsByTagName('*')
            } else {
              elements = currentContext[h].getElementsByTagName(tagName)
            }
            for (var j = 0; j < elements.length; j++) {
              found[foundCount++] = elements[j]
            }
          }
          currentContext = []
          let currentContextIndex = 0
          for (var k = 0; k < found.length; k++) {
            if (found[k].className && found[k].className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))) {
              currentContext[currentContextIndex++] = found[k]
            }
          }
          continue
        }
        if (token.match(/^(\w*)\[(\w+)([=~|^$*]?)=?"?([^\]"]*)"?\]$/)) {
          tagName = RegExp.$1 || '*'
          var attrName = RegExp.$2
          var attrOperator = RegExp.$3
          var attrValue = RegExp.$4
          if (attrName.toLowerCase() === 'for' && this.browser.msie && this.browser.version < 8) {
            attrName = 'htmlFor'
          }
          found = []
          foundCount = 0
          for (let h = 0; h < currentContext.length; h++) {
            let elements
            if (tagName === '*') {
              elements = currentContext[h].getElementsByTagName('*')
            } else {
              elements = currentContext[h].getElementsByTagName(tagName)
            }
            for (let j = 0; elements[j]; j++) {
              found[foundCount++] = elements[j]
            }
          }
          currentContext = []
          let currentContextIndex = 0
          var checkFunction
          switch (attrOperator) {
            case '=':
              checkFunction = function (e) {
                return (e.getAttribute(attrName) === attrValue)
              }
              break
            case '~':
              checkFunction = function (e) {
                return (e.getAttribute(attrName).match(new RegExp('(\\s|^)' + attrValue + '(\\s|$)')))
              }
              break
            case '|':
              checkFunction = function (e) {
                return (e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?')))
              }
              break
            case '^':
              checkFunction = function (e) {
                return (e.getAttribute(attrName).indexOf(attrValue) === 0)
              }
              break
            case '$':
              checkFunction = function (e) {
                return (e.getAttribute(attrName).lastIndexOf(attrValue) === e.getAttribute(attrName).length - attrValue.length)
              }
              break
            case '*':
              checkFunction = function (e) {
                return (e.getAttribute(attrName).indexOf(attrValue) > -1)
              }
              break
            default :
              checkFunction = function (e) {
                return e.getAttribute(attrName)
              }
          }
          currentContext = []
          currentContextIndex = 0
          for (let k = 0; k < found.length; k++) {
            if (checkFunction(found[k])) {
              currentContext[currentContextIndex++] = found[k]
            }
          }
          continue
        }
        tagName = token
        found = []
        foundCount = 0
        for (let h = 0; h < currentContext.length; h++) {
          const elements = currentContext[h].getElementsByTagName(tagName)
          for (let j = 0; j < elements.length; j++) {
            found[foundCount++] = elements[j]
          }
        }
        currentContext = found
      }
      resultList = [].concat(resultList, currentContext)
    }
    return resultList
  },
  trim: function (str) {
    return str.replace(/^\s+/, '').replace(/\s+$/, '')
  },
  bind: function (f, scope, forceArgs) {
    return function () {
      return f.apply(scope, typeof forceArgs !== 'undefined' ? [forceArgs] : arguments)
    }
  }
}

/* eslint-disable no-sequences, no-unused-expressions */

/*! Hammer.JS - v2.0.4 - 2014-09-28
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2014 Jorik Tangelder;
 * Licensed under the MIT license */
if (Object.create) {
  // !
  (function (a, b, c, d) {
    'use strict'

    function e (a, b, c) {
      return setTimeout(k(a, c), b)
    }

    function f (a, b, c) {
      return Array.isArray(a) ? (g(a, c[b], c), !0) : !1
    }

    function g (a, b, c) {
      var e
      if (a) if (a.forEach) { a.forEach(b, c) } else if (a.length !== d) { for (e = 0; e < a.length;) { b.call(c, a[e], e, a), e++ } } else { for (e in a) Object.prototype.hasOwnProperty.call(a, 'e') && b.call(c, a[e], e, a) }
    }

    function h (a, b, c) {
      for (var e = Object.keys(b), f = 0; f < e.length;) { ((!c || c) && a[e[f]] === d) && (a[e[f]] = b[e[f]]), f++ }
      return a
    }

    function i (a, b) {
      return h(a, b, !0)
    }

    function j (a, b, c) {
      var d
      var e = b.prototype
      d = a.prototype = Object.create(e), d.constructor = a, d._super = e, c && h(d, c)
    }

    function k (a, b) {
      return function () {
        return a.apply(b, arguments)
      }
    }

    function l (a, b) {
      return typeof a === 'function' ? a.apply(b ? b[0] || d : d, b) : a
    }

    function m (a, b) {
      return a === d ? b : a
    }

    function n (a, b, c) {
      g(r(b), function (b) {
        a.addEventListener(b, c, !1)
      })
    }

    function o (a, b, c) {
      g(r(b), function (b) {
        a.removeEventListener(b, c, !1)
      })
    }

    function p (a, b) {
      for (; a;) {
        if (a === b) return !0
        a = a.parentNode
      }
      return !1
    }

    function q (a, b) {
      return a.indexOf(b) > -1
    }

    function r (a) {
      return a.trim().split(/\s+/g)
    }

    function s (a, b, c) {
      if (a.indexOf && !c) return a.indexOf(b)
      for (var d = 0; d < a.length;) {
        if ((c && a[d][c] === b) || (!c && a[d] === b)) return d
        d++
      }
      return -1
    }

    function t (a) {
      return Array.prototype.slice.call(a, 0)
    }

    function u (a, b, c) {
      for (var d = [], e = [], f = 0; f < a.length;) {
        var g = b ? a[f][b] : a[f]
        s(e, g) < 0 && d.push(a[f]), e[f] = g, f++
      }
      return c && (d = b ? d.sort(function (a, c) {
        return a[b] > c[b]
      }) : d.sort()), d
    }

    function v (a, b) {
      for (var c, e, f = b[0].toUpperCase() + b.slice(1), g = 0; g < ib.length;) {
        if (c = ib[g], e = c ? c + f : b, e in a) return e
        g++
      }
      return d
    }

    function w () {
      return ob++
    }

    function x (a) {
      var b = a.ownerDocument
      return b.defaultView || b.parentWindow
    }

    function y (a, b) {
      var c = this
      this.manager = a, this.callback = b, this.element = a.element, this.target = a.options.inputTarget, this.domHandler = function (b) {
        l(a.options.enable, [a]) && c.handler(b)
      }, this.init()
    }

    function z (a) {
      // var b
      var c = a.options.inputClass
      return new (b = c || (rb ? N : sb ? Q : qb ? S : M))(a, A)
    }

    function A (a, b, c) {
      var d = c.pointers.length
      var e = c.changedPointers.length
      var f = b & yb && d - e === 0
      var g = b & (Ab | Bb) && d - e === 0
      c.isFirst = !!f, c.isFinal = !!g, f && (a.session = {}), c.eventType = b, B(a, c), a.emit('hammer.input', c), a.recognize(c), a.session.prevInput = c
    }

    function B (a, b) {
      var c = a.session
      var d = b.pointers
      var e = d.length
      c.firstInput || (c.firstInput = E(b)), e > 1 && !c.firstMultiple ? c.firstMultiple = E(b) : e === 1 && (c.firstMultiple = !1)
      var f = c.firstInput
      var g = c.firstMultiple
      var h = g ? g.center : f.center
      var i = b.center = F(d)
      b.timeStamp = nb(), b.deltaTime = b.timeStamp - f.timeStamp, b.angle = J(h, i), b.distance = I(h, i), C(c, b), b.offsetDirection = H(b.deltaX, b.deltaY), b.scale = g ? L(g.pointers, d) : 1, b.rotation = g ? K(g.pointers, d) : 0, D(c, b)
      var j = a.element
      p(b.srcEvent.target, j) && (j = b.srcEvent.target), b.target = j
    }

    function C (a, b) {
      var c = b.center
      var d = a.offsetDelta || {}
      var e = a.prevDelta || {}
      var f = a.prevInput || {};

      (b.eventType === yb || f.eventType === Ab) && (e = a.prevDelta = {
        x: f.deltaX || 0,
        y: f.deltaY || 0
      }, d = a.offsetDelta = { x: c.x, y: c.y }), b.deltaX = e.x + (c.x - d.x), b.deltaY = e.y + (c.y - d.y)
    }

    function D (a, b) {
      var c
      var e
      var f
      var g
      var h = a.lastInterval || b
      var i = b.timeStamp - h.timeStamp
      if (b.eventType !== Bb && (i > xb || h.velocity === d)) {
        var j = h.deltaX - b.deltaX
        var k = h.deltaY - b.deltaY
        var l = G(i, j, k)
        e = l.x, f = l.y, c = mb(l.x) > mb(l.y) ? l.x : l.y, g = H(j, k), a.lastInterval = b
      } else c = h.velocity, e = h.velocityX, f = h.velocityY, g = h.direction
      b.velocity = c, b.velocityX = e, b.velocityY = f, b.direction = g
    }

    function E (a) {
      for (var b = [], c = 0; c < a.pointers.length;) {
        b[c] = {
          clientX: lb(a.pointers[c].clientX),
          clientY: lb(a.pointers[c].clientY)
        }, c++
      }
      return { timeStamp: nb(), pointers: b, center: F(b), deltaX: a.deltaX, deltaY: a.deltaY }
    }

    function F (a) {
      var b = a.length
      if (b === 1) return { x: lb(a[0].clientX), y: lb(a[0].clientY) }
      for (var c = 0, d = 0, e = 0; b > e;) c += a[e].clientX, d += a[e].clientY, e++
      return { x: lb(c / b), y: lb(d / b) }
    }

    function G (a, b, c) {
      return { x: b / a || 0, y: c / a || 0 }
    }

    function H (a, b) {
      return a === b ? Cb : mb(a) >= mb(b) ? a > 0 ? Db : Eb : b > 0 ? Fb : Gb
    }

    function I (a, b, c) {
      c || (c = Kb)
      var d = b[c[0]] - a[c[0]]
      var e = b[c[1]] - a[c[1]]
      return Math.sqrt(d * d + e * e)
    }

    function J (a, b, c) {
      c || (c = Kb)
      var d = b[c[0]] - a[c[0]]
      var e = b[c[1]] - a[c[1]]
      return 180 * Math.atan2(e, d) / Math.PI
    }

    function K (a, b) {
      return J(b[1], b[0], Lb) - J(a[1], a[0], Lb)
    }

    function L (a, b) {
      return I(b[0], b[1], Lb) / I(a[0], a[1], Lb)
    }

    function M () {
      this.evEl = Nb, this.evWin = Ob, this.allow = !0, this.pressed = !1, y.apply(this, arguments)
    }

    function N () {
      this.evEl = Rb, this.evWin = Sb, y.apply(this, arguments), this.store = this.manager.session.pointerEvents = []
    }

    function O () {
      this.evTarget = Ub, this.evWin = Vb, this.started = !1, y.apply(this, arguments)
    }

    function P (a, b) {
      var c = t(a.touches)
      var d = t(a.changedTouches)
      return b & (Ab | Bb) && (c = u(c.concat(d), 'identifier', !0)), [c, d]
    }

    function Q () {
      this.evTarget = Xb, this.targetIds = {}, y.apply(this, arguments)
    }

    function R (a, b) {
      var c = t(a.touches)
      var d = this.targetIds
      // eslint-disable-next-line no-return-assign,no-sequences
      if (b & (yb | zb) && c.length === 1) return d[c[0].identifier] = !0, [c, c]
      var e
      var f
      var g = t(a.changedTouches)
      var h = []
      var i = this.target
      if (f = c.filter(function (a) {
        return p(a.target, i)
      }), b === yb) for (e = 0; e < f.length;) d[f[e].identifier] = !0, e++
      for (e = 0; e < g.length;) d[g[e].identifier] && h.push(g[e]), b & (Ab | Bb) && delete d[g[e].identifier], e++
      // eslint-disable-next-line no-void
      return h.length ? [u(f.concat(h), 'identifier', !0), h] : void 0
    }

    function S () {
      y.apply(this, arguments)
      var a = k(this.handler, this)
      this.touch = new Q(this.manager, a), this.mouse = new M(this.manager, a)
    }

    function T (a, b) {
      this.manager = a, this.set(b)
    }

    function U (a) {
      if (q(a, bc)) return bc
      var b = q(a, cc)
      var c = q(a, dc)
      return b && c ? cc + ' ' + dc : b || c ? b ? cc : dc : q(a, ac) ? ac : _b
    }

    function V (a) {
      this.id = w(), this.manager = null, this.options = i(a || {}, this.defaults), this.options.enable = m(this.options.enable, !0), this.state = ec, this.simultaneous = {}, this.requireFail = []
    }

    function W (a) {
      return a & jc ? 'cancel' : a & hc ? 'end' : a & gc ? 'move' : a & fc ? 'start' : ''
    }

    function X (a) {
      return a === Gb ? 'down' : a === Fb ? 'up' : a === Db ? 'left' : a === Eb ? 'right' : ''
    }

    function Y (a, b) {
      var c = b.manager
      return c ? c.get(a) : a
    }

    function Z () {
      V.apply(this, arguments)
    }

    function $ () {
      Z.apply(this, arguments), this.pX = null, this.pY = null
    }

    function _ () {
      Z.apply(this, arguments)
    }

    function ab () {
      V.apply(this, arguments), this._timer = null, this._input = null
    }

    function bb () {
      Z.apply(this, arguments)
    }

    function cb () {
      Z.apply(this, arguments)
    }

    function db () {
      V.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0
    }

    function eb (a, b) {
      // eslint-disable-next-line no-return-assign,new-cap
      return b = b || {}, b.recognizers = m(b.recognizers, eb.defaults.preset), new fb(a, b)
    }

    function fb (a, b) {
      b = b || {}, this.options = i(b, eb.defaults), this.options.inputTarget = this.options.inputTarget || a, this.handlers = {}, this.session = {}, this.recognizers = [], this.element = a, this.input = z(this), this.touchAction = new T(this, this.options.touchAction), gb(this, !0), g(b.recognizers, function (a) {
        var b = this.add(new a[0](a[1]))
        a[2] && b.recognizeWith(a[2]), a[3] && b.requireFailure(a[3])
      }, this)
    }

    function gb (a, b) {
      var c = a.element
      g(a.options.cssProps, function (a, d) {
        c.style[v(c.style, d)] = b ? a : ''
      })
    }

    function hb (a, c) {
      var d = b.createEvent('Event')
      d.initEvent(a, !0, !0), d.gesture = c, c.target.dispatchEvent(d)
    }

    var ib = ['', 'webkit', 'moz', 'MS', 'ms', 'o']
    var jb = b.createElement('div')
    // var kb = 'function'
    var lb = Math.round
    var mb = Math.abs
    var nb = Date.now
    var ob = 1
    var pb = /mobile|tablet|ip(ad|hone|od)|android/i
    var qb = 'ontouchstart' in a
    var rb = v(a, 'PointerEvent') !== d
    var sb = qb && pb.test(navigator.userAgent)
    var tb = 'touch'
    var ub = 'pen'
    var vb = 'mouse'
    var wb = 'kinect'
    var xb = 25
    var yb = 1
    var zb = 2
    var Ab = 4
    var Bb = 8
    var Cb = 1
    var Db = 2
    var Eb = 4
    var Fb = 8
    var Gb = 16
    var Hb = Db | Eb
    var Ib = Fb | Gb
    var Jb = Hb | Ib
    var Kb = ['x', 'y']
    var Lb = ['clientX', 'clientY']
    y.prototype = {
      handler: function () {
      },
      init: function () {
        this.evEl && n(this.element, this.evEl, this.domHandler), this.evTarget && n(this.target, this.evTarget, this.domHandler), this.evWin && n(x(this.element), this.evWin, this.domHandler)
      },
      destroy: function () {
        this.evEl && o(this.element, this.evEl, this.domHandler), this.evTarget && o(this.target, this.evTarget, this.domHandler), this.evWin && o(x(this.element), this.evWin, this.domHandler)
      }
    }
    var Mb = { mousedown: yb, mousemove: zb, mouseup: Ab }
    var Nb = 'mousedown'
    var Ob = 'mousemove mouseup'
    j(M, y, {
      handler: function (a) {
        var b = Mb[a.type]
        b & yb && a.button === 0 && (this.pressed = !0), b & zb && a.which !== 1 && (b = Ab), this.pressed && this.allow && (b & Ab && (this.pressed = !1), this.callback(this.manager, b, {
          pointers: [a],
          changedPointers: [a],
          pointerType: vb,
          srcEvent: a
        }))
      }
    })
    var Pb = { pointerdown: yb, pointermove: zb, pointerup: Ab, pointercancel: Bb, pointerout: Bb }
    var Qb = {
      2: tb,
      3: ub,
      4: vb,
      5: wb
    }
    var Rb = 'pointerdown'
    var Sb = 'pointermove pointerup pointercancel'
    a.MSPointerEvent && (Rb = 'MSPointerDown', Sb = 'MSPointerMove MSPointerUp MSPointerCancel'), j(N, y, {
      handler: function (a) {
        var b = this.store
        var c = !1
        var d = a.type.toLowerCase().replace('ms', '')
        var e = Pb[d]
        var f = Qb[a.pointerType] || a.pointerType
        var g = f === tb
        var h = s(b, a.pointerId, 'pointerId')
        e & yb && (a.button === 0 || g) ? h < 0 && (b.push(a), h = b.length - 1) : e & (Ab | Bb) && (c = !0), h < 0 || (b[h] = a, this.callback(this.manager, e, {
          pointers: b,
          changedPointers: [a],
          pointerType: f,
          srcEvent: a
        }), c && b.splice(h, 1))
      }
    })
    var Tb = {
      touchstart: yb,
      touchmove: zb,
      touchend: Ab,
      touchcancel: Bb
    }
    var Ub = 'touchstart'
    var Vb = 'touchstart touchmove touchend touchcancel'
    j(O, y, {
      handler: function (a) {
        var b = Tb[a.type]
        if (b === yb && (this.started = !0), this.started) {
          var c = P.call(this, a, b)
          b & (Ab | Bb) && c[0].length - c[1].length === 0 && (this.started = !1), this.callback(this.manager, b, {
            pointers: c[0],
            changedPointers: c[1],
            pointerType: tb,
            srcEvent: a
          })
        }
      }
    })
    var Wb = {
      touchstart: yb,
      touchmove: zb,
      touchend: Ab,
      touchcancel: Bb
    }
    var Xb = 'touchstart touchmove touchend touchcancel'
    j(Q, y, {
      handler: function (a) {
        var b = Wb[a.type]
        var c = R.call(this, a, b)
        c && this.callback(this.manager, b, {
          pointers: c[0],
          changedPointers: c[1],
          pointerType: tb,
          srcEvent: a
        })
      }
    }), j(S, y, {
      handler: function (a, b, c) {
        var d = c.pointerType === tb
        var e = c.pointerType === vb
        if (d) { this.mouse.allow = !1 } else if (e && !this.mouse.allow) return
        b & (Ab | Bb) && (this.mouse.allow = !0), this.callback(a, b, c)
      },
      destroy: function () {
        this.touch.destroy(), this.mouse.destroy()
      }
    })
    var Yb = v(jb.style, 'touchAction')
    var Zb = Yb !== d
    var $b = 'compute'
    var _b = 'auto'
    var ac = 'manipulation'
    var bc = 'none'
    var cc = 'pan-x'
    var dc = 'pan-y'
    T.prototype = {
      set: function (a) {
        a === $b && (a = this.compute()), Zb && (this.manager.element.style[Yb] = a), this.actions = a.toLowerCase().trim()
      },
      update: function () {
        this.set(this.manager.options.touchAction)
      },
      compute: function () {
        var a = []
        return g(this.manager.recognizers, function (b) {
          l(b.options.enable, [b]) && (a = a.concat(b.getTouchAction()))
        }), U(a.join(' '))
      },
      preventDefaults: function (a) {
        if (!Zb) {
          var b = a.srcEvent
          var c = a.offsetDirection
          // eslint-disable-next-line no-void
          if (this.manager.session.prevented) return void b.preventDefault()
          var d = this.actions
          var e = q(d, bc)
          var f = q(d, dc)
          var g = q(d, cc)
          // eslint-disable-next-line no-void
          return e || (f && (c & Hb)) || (g && (c & Ib)) ? this.preventSrc(b) : void 0
        }
      },
      preventSrc: function (a) {
        this.manager.session.prevented = !0, a.preventDefault()
      }
    }
    var ec = 1
    var fc = 2
    var gc = 4
    var hc = 8
    var ic = hc
    var jc = 16
    var kc = 32
    V.prototype = {
      defaults: {},
      set: function (a) {
        return h(this.options, a), this.manager && this.manager.touchAction.update(), this
      },
      recognizeWith: function (a) {
        if (f(a, 'recognizeWith', this)) return this
        var b = this.simultaneous
        return a = Y(a, this), b[a.id] || (b[a.id] = a, a.recognizeWith(this)), this
      },
      dropRecognizeWith: function (a) {
        return f(a, 'dropRecognizeWith', this) ? this : (a = Y(a, this), delete this.simultaneous[a.id], this)
      },
      requireFailure: function (a) {
        if (f(a, 'requireFailure', this)) return this
        var b = this.requireFail
        return a = Y(a, this), s(b, a) === -1 && (b.push(a), a.requireFailure(this)), this
      },
      dropRequireFailure: function (a) {
        if (f(a, 'dropRequireFailure', this)) return this
        a = Y(a, this)
        var b = s(this.requireFail, a)
        return b > -1 && this.requireFail.splice(b, 1), this
      },
      hasRequireFailures: function () {
        return this.requireFail.length > 0
      },
      canRecognizeWith: function (a) {
        return !!this.simultaneous[a.id]
      },
      emit: function (a) {
        function b (b) {
          c.manager.emit(c.options.event + (b ? W(d) : ''), a)
        }

        var c = this
        var d = this.state
        hc > d && b(!0), b(), d >= hc && b(!0)
      },
      tryEmit: function (a) {
        return this.canEmit() ? this.emit(a) : void (this.state = kc)
      },
      canEmit: function () {
        for (var a = 0; a < this.requireFail.length;) {
          if (!(this.requireFail[a].state & (kc | ec))) return !1
          a++
        }
        return !0
      },
      recognize: function (a) {
        var b = h({}, a)
        return l(this.options.enable, [this, b]) ? (this.state & (ic | jc | kc) && (this.state = ec), this.state = this.process(b), void (this.state & (fc | gc | hc | jc) && this.tryEmit(b))) : (this.reset(), void (this.state = kc))
      },
      process: function () {
      },
      getTouchAction: function () {
      },
      reset: function () {
      }
    }, j(Z, V, {
      defaults: { pointers: 1 },
      attrTest: function (a) {
        var b = this.options.pointers
        return b === 0 || a.pointers.length === b
      },
      process: function (a) {
        var b = this.state
        var c = a.eventType
        var d = b & (fc | gc)
        var e = this.attrTest(a)
        return d && (c & Bb || !e) ? b | jc : d || e ? c & Ab ? b | hc : b & fc ? b | gc : fc : kc
      }
    }), j($, Z, {
      defaults: { event: 'pan', threshold: 10, pointers: 1, direction: Jb },
      getTouchAction: function () {
        var a = this.options.direction
        var b = []
        return a & Hb && b.push(dc), a & Ib && b.push(cc), b
      },
      directionTest: function (a) {
        var b = this.options
        var c = !0
        var d = a.distance
        var e = a.direction
        var f = a.deltaX
        var g = a.deltaY
        return e & b.direction || (b.direction & Hb ? (e = f === 0 ? Cb : f < 0 ? Db : Eb, c = f != this.pX, d = Math.abs(a.deltaX)) : (e = g === 0 ? Cb : g < 0 ? Fb : Gb, c = g != this.pY, d = Math.abs(a.deltaY))), a.direction = e, c && d > b.threshold && e & b.direction
      },
      attrTest: function (a) {
        return Z.prototype.attrTest.call(this, a) && (this.state & fc || !(this.state & fc) && this.directionTest(a))
      },
      emit: function (a) {
        this.pX = a.deltaX, this.pY = a.deltaY
        var b = X(a.direction)
        b && this.manager.emit(this.options.event + b, a), this._super.emit.call(this, a)
      }
    }), j(_, Z, {
      defaults: { event: 'pinch', threshold: 0, pointers: 2 },
      getTouchAction: function () {
        return [bc]
      },
      attrTest: function (a) {
        return this._super.attrTest.call(this, a) && (Math.abs(a.scale - 1) > this.options.threshold || this.state & fc)
      },
      emit: function (a) {
        if (this._super.emit.call(this, a), a.scale !== 1) {
          var b = a.scale < 1 ? 'in' : 'out'
          this.manager.emit(this.options.event + b, a)
        }
      }
    }), j(ab, V, {
      defaults: { event: 'press', pointers: 1, time: 500, threshold: 5 },
      getTouchAction: function () {
        return [_b]
      },
      process: function (a) {
        var b = this.options
        var c = a.pointers.length === b.pointers
        var d = a.distance < b.threshold
        var f = a.deltaTime > b.time
        if (this._input = a, !d || !c || a.eventType & (Ab | Bb) && !f) { this.reset() } else if (a.eventType & yb) {
          this.reset(), this._timer = e(function () {
            this.state = ic, this.tryEmit()
          }, b.time, this)
        } else if (a.eventType & Ab) return ic
        return kc
      },
      reset: function () {
        clearTimeout(this._timer)
      },
      emit: function (a) {
        this.state === ic && (a && a.eventType & Ab ? this.manager.emit(this.options.event + 'up', a) : (this._input.timeStamp = nb(), this.manager.emit(this.options.event, this._input)))
      }
    }), j(bb, Z, {
      defaults: { event: 'rotate', threshold: 0, pointers: 2 },
      getTouchAction: function () {
        return [bc]
      },
      attrTest: function (a) {
        return this._super.attrTest.call(this, a) && (Math.abs(a.rotation) > this.options.threshold || this.state & fc)
      }
    }), j(cb, Z, {
      defaults: { event: 'swipe', threshold: 10, velocity: 0.65, direction: Hb | Ib, pointers: 1 },
      getTouchAction: function () {
        return $.prototype.getTouchAction.call(this)
      },
      attrTest: function (a) {
        var b
        var c = this.options.direction
        return c & (Hb | Ib) ? b = a.velocity : c & Hb ? b = a.velocityX : c & Ib && (b = a.velocityY), this._super.attrTest.call(this, a) && c & a.direction && a.distance > this.options.threshold && mb(b) > this.options.velocity && a.eventType & Ab
      },
      emit: function (a) {
        var b = X(a.direction)
        b && this.manager.emit(this.options.event + b, a), this.manager.emit(this.options.event, a)
      }
    }), j(db, V, {
      defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300,
        time: 250,
        threshold: 2,
        posThreshold: 10
      },
      getTouchAction: function () {
        return [ac]
      },
      process: function (a) {
        var b = this.options
        var c = a.pointers.length === b.pointers
        var d = a.distance < b.threshold
        var f = a.deltaTime < b.time
        if (this.reset(), a.eventType & yb && this.count === 0) return this.failTimeout()
        if (d && f && c) {
          if (a.eventType != Ab) return this.failTimeout()
          var g = this.pTime ? a.timeStamp - this.pTime < b.interval : !0
          var h = !this.pCenter || I(this.pCenter, a.center) < b.posThreshold
          this.pTime = a.timeStamp, this.pCenter = a.center, h && g ? this.count += 1 : this.count = 1, this._input = a
          var i = this.count % b.taps
          if (i === 0) {
            return this.hasRequireFailures() ? (this._timer = e(function () {
              this.state = ic, this.tryEmit()
            }, b.interval, this), fc) : ic
          }
        }
        return kc
      },
      failTimeout: function () {
        return this._timer = e(function () {
          this.state = kc
        }, this.options.interval, this), kc
      },
      reset: function () {
        clearTimeout(this._timer)
      },
      emit: function () {
        this.state == ic && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input))
      }
    }), eb.VERSION = '2.0.4', eb.defaults = {
      domEvents: !1,
      touchAction: $b,
      enable: !0,
      inputTarget: null,
      inputClass: null,
      preset: [[bb, { enable: !1 }], [_, { enable: !1 }, ['rotate']], [cb, { direction: Hb }], [$, { direction: Hb }, ['swipe']], [db], [db, {
        event: 'doubletap',
        taps: 2
      }, ['tap']], [ab]],
      cssProps: {
        userSelect: 'none',
        touchSelect: 'none',
        touchCallout: 'none',
        contentZooming: 'none',
        userDrag: 'none',
        tapHighlightColor: 'rgba(0,0,0,0)'
      }
    }
    var lc = 1
    var mc = 2
    fb.prototype = {
      set: function (a) {
        return h(this.options, a), a.touchAction && this.touchAction.update(), a.inputTarget && (this.input.destroy(), this.input.target = a.inputTarget, this.input.init()), this
      },
      stop: function (a) {
        this.session.stopped = a ? mc : lc
      },
      recognize: function (a) {
        var b = this.session
        if (!b.stopped) {
          this.touchAction.preventDefaults(a)
          var c
          var d = this.recognizers
          var e = b.curRecognizer;
          (!e || e && e.state & ic) && (e = b.curRecognizer = null)
          for (var f = 0; f < d.length;) c = d[f], b.stopped === mc || e && c != e && !c.canRecognizeWith(e) ? c.reset() : c.recognize(a), !e && c.state & (fc | gc | hc) && (e = b.curRecognizer = c), f++
        }
      },
      get: function (a) {
        if (a instanceof V) return a
        for (var b = this.recognizers, c = 0; c < b.length; c++) if (b[c].options.event == a) return b[c]
        return null
      },
      add: function (a) {
        if (f(a, 'add', this)) return this
        var b = this.get(a.options.event)
        return b && this.remove(b), this.recognizers.push(a), a.manager = this, this.touchAction.update(), a
      },
      remove: function (a) {
        if (f(a, 'remove', this)) return this
        var b = this.recognizers
        return a = this.get(a), b.splice(s(b, a), 1), this.touchAction.update(), this
      },
      on: function (a, b) {
        var c = this.handlers
        return g(r(a), function (a) {
          c[a] = c[a] || [], c[a].push(b)
        }), this
      },
      off: function (a, b) {
        var c = this.handlers
        return g(r(a), function (a) {
          b ? c[a].splice(s(c[a], b), 1) : delete c[a]
        }), this
      },
      emit: function (a, b) {
        this.options.domEvents && hb(a, b)
        var c = this.handlers[a] && this.handlers[a].slice()
        if (c && c.length) {
          b.type = a, b.preventDefault = function () {
            b.srcEvent.preventDefault()
          }
          for (var d = 0; d < c.length;) c[d](b), d++
        }
      },
      destroy: function () {
        this.element && gb(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null
      }
    }, h(eb, {
      INPUT_START: yb,
      INPUT_MOVE: zb,
      INPUT_END: Ab,
      INPUT_CANCEL: Bb,
      STATE_POSSIBLE: ec,
      STATE_BEGAN: fc,
      STATE_CHANGED: gc,
      STATE_ENDED: hc,
      STATE_RECOGNIZED: ic,
      STATE_CANCELLED: jc,
      STATE_FAILED: kc,
      DIRECTION_NONE: Cb,
      DIRECTION_LEFT: Db,
      DIRECTION_RIGHT: Eb,
      DIRECTION_UP: Fb,
      DIRECTION_DOWN: Gb,
      DIRECTION_HORIZONTAL: Hb,
      DIRECTION_VERTICAL: Ib,
      DIRECTION_ALL: Jb,
      Manager: fb,
      Input: y,
      TouchAction: T,
      TouchInput: Q,
      MouseInput: M,
      PointerEventInput: N,
      TouchMouseInput: S,
      SingleTouchInput: O,
      Recognizer: V,
      AttrRecognizer: Z,
      Tap: db,
      Pan: $,
      Swipe: cb,
      Pinch: _,
      Rotate: bb,
      Press: ab,
      on: n,
      off: o,
      each: g,
      merge: i,
      extend: h,
      inherit: j,
      bindFn: k,
      prefixed: v
    }), typeof define === 'function' && define.amd ? define(function () {
      return eb
    }) : typeof module !== 'undefined' && module.exports ? module.exports = eb : a[c] = eb
  }(window, document, 'Hammer'))
}

/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
;(function (r, G, f, v) {
  var J = f('html')
  var n = f(r)
  var p = f(G)
  var b = f.fancybox = function () {
    b.open.apply(this, arguments)
  }
  var I = navigator.userAgent.match(/msie/i)
  var B = null
  var s = G.createTouch !== v
  var t = function (a) {
    return a && a.hasOwnProperty && a instanceof f
  }
  var q = function (a) {
    return a && f.type(a) === 'string'
  }
  var E = function (a) {
    return q(a) && a.indexOf('%') > 0
  }
  var l = function (a, d) {
    var e = parseInt(a, 10) || 0
    d && E(a) && (e *= b.getViewport()[d] / 100)
    return Math.ceil(e)
  }
  var w = function (a, b) {
    return l(a, b) + 'px'
  }
  f.extend(b, {
    version: '2.1.5',
    defaults: {
      padding: 15,
      margin: 20,
      width: 800,
      height: 600,
      minWidth: 100,
      minHeight: 100,
      maxWidth: 9999,
      maxHeight: 9999,
      pixelRatio: 1,
      autoSize: !0,
      autoHeight: !1,
      autoWidth: !1,
      autoResize: !0,
      autoCenter: !s,
      fitToView: !0,
      aspectRatio: !1,
      topRatio: 0.5,
      leftRatio: 0.5,
      scrolling: 'auto',
      wrapCSS: '',
      arrows: !0,
      closeBtn: !0,
      closeClick: !1,
      nextClick: !1,
      mouseWheel: !0,
      autoPlay: !1,
      playSpeed: 3E3,
      preload: 3,
      modal: !1,
      loop: !0,
      ajax: { dataType: 'html', headers: { 'X-fancyBox': !0 } },
      iframe: { scrolling: 'auto', preload: !0 },
      swf: { wmode: 'transparent', allowfullscreen: 'true', allowscriptaccess: 'always' },
      keys: {
        next: { 13: 'left', 34: 'up', 39: 'left', 40: 'up' },
        prev: { 8: 'right', 33: 'down', 37: 'right', 38: 'down' },
        close: [27],
        play: [32],
        toggle: [70]
      },
      direction: { next: 'left', prev: 'right' },
      scrollOutside: !0,
      index: 0,
      type: null,
      href: null,
      content: null,
      title: null,
      tpl: {
        wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
        image: '<img class="fancybox-image" src="{href}" alt="" />',
        iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (I ? ' allowtransparency="true"' : '') + '></iframe>',
        error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
        closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
        next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
        prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
      },
      openEffect: 'fade',
      openSpeed: 250,
      openEasing: 'swing',
      openOpacity: !0,
      openMethod: 'zoomIn',
      closeEffect: 'fade',
      closeSpeed: 250,
      closeEasing: 'swing',
      closeOpacity: !0,
      closeMethod: 'zoomOut',
      nextEffect: 'elastic',
      nextSpeed: 250,
      nextEasing: 'swing',
      nextMethod: 'changeIn',
      prevEffect: 'elastic',
      prevSpeed: 250,
      prevEasing: 'swing',
      prevMethod: 'changeOut',
      helpers: { overlay: !0, title: !0 },
      onCancel: f.noop,
      beforeLoad: f.noop,
      afterLoad: f.noop,
      beforeShow: f.noop,
      afterShow: f.noop,
      beforeChange: f.noop,
      beforeClose: f.noop,
      afterClose: f.noop
    },
    group: {},
    opts: {},
    previous: null,
    coming: null,
    current: null,
    isActive: !1,
    isOpen: !1,
    isOpened: !1,
    wrap: null,
    skin: null,
    outer: null,
    inner: null,
    player: { timer: null, isActive: !1 },
    ajaxLoad: null,
    imgPreload: null,
    transitions: {},
    helpers: {},
    open: function (a, d) {
      if (a && (f.isPlainObject(d) || (d = {}), !1 !== b.close(!0))) {
        return f.isArray(a) || (a = t(a) ? f(a).get() : [a]), f.each(a, function (e, c) {
          var k = {}
          var g
          var h
          var j
          var m
          var l
          f.type(c) === 'object' && (c.nodeType && (c = f(c)), t(c) ? (k = {
            href: c.data('fancybox-href') || c.attr('href'),
            title: c.data('fancybox-title') || c.attr('title'),
            isDom: !0,
            element: c
          }, f.metadata && f.extend(!0, k, c.metadata())) : k = c)
          g = d.href || k.href || (q(c) ? c : null)
          h = d.title !== v ? d.title : k.title || ''
          m = (j = d.content || k.content) ? 'html' : d.type || k.type
          !m && k.isDom && (m = c.data('fancybox-type'), m || (m = (m = c.prop('class').match(/fancybox\.(\w+)/)) ? m[1] : null))
          q(g) && (m || (b.isImage(g) ? m = 'image' : b.isSWF(g) ? m = 'swf' : g.charAt(0) === '#' ? m = 'inline' : q(c) && (m = 'html', j = c)), m === 'ajax' && (l = g.split(/\s+/, 2), g = l.shift(), l = l.shift()))
          j || (m === 'inline' ? g ? j = f(q(g) ? g.replace(/.*(?=#[^\s]+$)/, '') : g) : k.isDom && (j = c) : m === 'html' ? j = g : !m && (!g && k.isDom) && (m = 'inline', j = c))
          f.extend(k, { href: g, type: m, content: j, title: h, selector: l })
          a[e] = k
        }), b.opts = f.extend(!0, {}, b.defaults, d), d.keys !== v && (b.opts.keys = d.keys ? f.extend({}, b.defaults.keys, d.keys) : !1), b.group = a, b._start(b.opts.index)
      }
    },
    cancel: function () {
      var a = b.coming
      a && !1 !== b.trigger('onCancel') && (b.hideLoading(), b.ajaxLoad && b.ajaxLoad.abort(), b.ajaxLoad = null, b.imgPreload && (b.imgPreload.onload = b.imgPreload.onerror = null), a.wrap && a.wrap.stop(!0, !0).trigger('onReset').remove(), b.coming = null, b.current || b._afterZoomOut(a))
    },
    close: function (a) {
      b.cancel()
      !1 !== b.trigger('beforeClose') && (b.unbindEvents(), b.isActive && (!b.isOpen || !0 === a ? (f('.fancybox-wrap').stop(!0).trigger('onReset').remove(), b._afterZoomOut()) : (b.isOpen = b.isOpened = !1, b.isClosing = !0, f('.fancybox-item, .fancybox-nav').remove(), b.wrap.stop(!0, !0).removeClass('fancybox-opened'), b.transitions[b.current.closeMethod]())))
    },
    play: function (a) {
      var d = function () {
        clearTimeout(b.player.timer)
      }
      var e = function () {
        d()
        b.current && b.player.isActive && (b.player.timer = setTimeout(b.next, b.current.playSpeed))
      }
      var c = function () {
        d()
        p.off('.player')
        b.player.isActive = !1
        b.trigger('onPlayEnd')
      }
      if (!0 === a || !b.player.isActive && !1 !== a) {
        if (b.current && (b.current.loop || b.current.index < b.group.length - 1)) {
          b.player.isActive = !0, p.on({
            'onCancel.player beforeClose.player': c,
            'onUpdate.player': e,
            'beforeLoad.player': d
          }), e(), b.trigger('onPlayStart')
        }
      } else c()
    },
    next: function (a) {
      var d = b.current
      d && (q(a) || (a = d.direction.next), b.jumpto(d.index + 1, a, 'next'))
    },
    prev: function (a) {
      var d = b.current
      d && (q(a) || (a = d.direction.prev), b.jumpto(d.index - 1, a, 'prev'))
    },
    jumpto: function (a, d, e) {
      var c = b.current
      c && (a = l(a), b.direction = d || c.direction[a >= c.index ? 'next' : 'prev'], b.router = e || 'jumpto', c.loop && (a < 0 && (a = c.group.length + a % c.group.length), a %= c.group.length), c.group[a] !== v && (b.cancel(), b._start(a)))
    },
    reposition: function (a, d) {
      var e = b.current
      var c = e ? e.wrap : null
      var k
      c && (k = b._getPosition(d), a && a.type === 'scroll' ? (delete k.position, c.stop(!0, !0).animate(k, 200)) : (c.css(k), e.pos = f.extend({}, e.dim, k)))
    },
    update: function (a) {
      var d = a && a.type
      var e = !d || d === 'orientationchange'
      e && (clearTimeout(B), B = null)
      b.isOpen && !B && (B = setTimeout(function () {
        var c = b.current
        c && !b.isClosing && (b.wrap.removeClass('fancybox-tmp'), (e || d === 'load' || d === 'resize' && c.autoResize) && b._setDimension(), d === 'scroll' && c.canShrink || b.reposition(a), b.trigger('onUpdate'), B = null)
      }, e && !s ? 0 : 300))
    },
    toggle: function (a) {
      b.isOpen && (b.current.fitToView = f.type(a) === 'boolean' ? a : !b.current.fitToView, s && (b.wrap.removeAttr('style').addClass('fancybox-tmp'), b.trigger('onUpdate')), b.update())
    },
    hideLoading: function () {
      p.off('.loading')
      f('#fancybox-loading').remove()
    },
    showLoading: function () {
      var a, d
      b.hideLoading()
      a = f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo('body')
      p.on('keydown.loading', function (a) {
        if ((a.which || a.keyCode) === 27) a.preventDefault(), b.cancel()
      })
      b.defaults.fixed || (d = b.getViewport(), a.css({
        position: 'absolute',
        top: 0.5 * d.h + d.y,
        left: 0.5 * d.w + d.x
      }))
    },
    getViewport: function () {
      var a = b.current && b.current.locked || !1
      var d = { x: n.scrollLeft(), y: n.scrollTop() }
      a ? (d.w = a[0].clientWidth, d.h = a[0].clientHeight) : (d.w = s && r.innerWidth ? r.innerWidth : n.width(), d.h = s && r.innerHeight ? r.innerHeight : n.height())
      return d
    },
    unbindEvents: function () {
      b.wrap && t(b.wrap) && b.wrap.off('.fb')
      p.off('.fb')
      n.off('.fb')
    },
    bindEvents: function () {
      var a = b.current
      var d
      a && (n.on('orientationchange.fb' + (s ? '' : ' resize.fb') + (a.autoCenter && !a.locked ? ' scroll.fb' : ''), b.update), (d = a.keys) && p.on('keydown.fb', function (e) {
        var c = e.which || e.keyCode
        var k = e.target || e.srcElement
        if (c === 27 && b.coming) return !1
        !e.ctrlKey && (!e.altKey && !e.shiftKey && !e.metaKey && (!k || !k.type && !f(k).is('[contenteditable]'))) && f.each(d, function (d, k) {
          if (a.group.length > 1 && k[c] !== v) return b[d](k[c]), e.preventDefault(), !1
          if (f.inArray(c, k) > -1) return b[d](), e.preventDefault(), !1
        })
      }), f.fn.mousewheel && a.mouseWheel && b.wrap.on('mousewheel.fb', function (d, c, k, g) {
        for (var h = f(d.target || null), j = !1; h.length && !j && !h.is('.fancybox-skin') && !h.is('.fancybox-wrap');) j = h[0] && !(h[0].style.overflow && h[0].style.overflow === 'hidden') && (h[0].clientWidth && h[0].scrollWidth > h[0].clientWidth || h[0].clientHeight && h[0].scrollHeight > h[0].clientHeight), h = f(h).parent()
        if (c !== 0 && !j && b.group.length > 1 && !a.canShrink) {
          if (g > 0 || k > 0) { b.prev(g > 0 ? 'down' : 'left') } else if (g < 0 || k < 0) b.next(g < 0 ? 'up' : 'right')
          d.preventDefault()
        }
      }))
    },
    trigger: function (a, d) {
      var e
      var c = d || b.coming || b.current
      if (c) {
        f.isFunction(c[a]) && (e = c[a].apply(c, Array.prototype.slice.call(arguments, 1)))
        if (!1 === e) return !1
        c.helpers && f.each(c.helpers, function (d, e) {
          if (e && b.helpers[d] && f.isFunction(b.helpers[d][a])) b.helpers[d][a](f.extend(!0, {}, b.helpers[d].defaults, e), c)
        })
        p.trigger(a)
      }
    },
    isImage: function (a) {
      return q(a) && a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)
    },
    isSWF: function (a) {
      return q(a) && a.match(/\.(swf)((\?|#).*)?$/i)
    },
    _start: function (a) {
      var d = {}
      var e
      var c
      a = l(a)
      e = b.group[a] || null
      if (!e) return !1
      d = f.extend(!0, {}, b.opts, e)
      e = d.margin
      c = d.padding
      f.type(e) === 'number' && (d.margin = [e, e, e, e])
      f.type(c) === 'number' && (d.padding = [c, c, c, c])
      d.modal && f.extend(!0, d, {
        closeBtn: !1,
        closeClick: !1,
        nextClick: !1,
        arrows: !1,
        mouseWheel: !1,
        keys: null,
        helpers: { overlay: { closeClick: !1 } }
      })
      d.autoSize && (d.autoWidth = d.autoHeight = !0)
      d.width === 'auto' && (d.autoWidth = !0)
      d.height === 'auto' && (d.autoHeight = !0)
      d.group = b.group
      d.index = a
      b.coming = d
      if (!1 === b.trigger('beforeLoad')) { b.coming = null } else {
        c = d.type
        e = d.href
        if (!c) return b.coming = null, b.current && b.router && b.router !== 'jumpto' ? (b.current.index = a, b[b.router](b.direction)) : !1
        b.isActive = !0
        if (c === 'image' || c === 'swf') d.autoHeight = d.autoWidth = !1, d.scrolling = 'visible'
        c === 'image' && (d.aspectRatio = !0)
        c === 'iframe' && s && (d.scrolling = 'scroll')
        d.wrap = f(d.tpl.wrap).addClass('fancybox-' + (s ? 'mobile' : 'desktop') + ' fancybox-type-' + c + ' fancybox-tmp ' + d.wrapCSS).appendTo(d.parent || 'body')
        f.extend(d, {
          skin: f('.fancybox-skin', d.wrap),
          outer: f('.fancybox-outer', d.wrap),
          inner: f('.fancybox-inner', d.wrap)
        })
        f.each(['Top', 'Right', 'Bottom', 'Left'], function (a, b) {
          d.skin.css('padding' + b, w(d.padding[a]))
        })
        b.trigger('onReady')
        if (c === 'inline' || c === 'html') {
          if (!d.content || !d.content.length) return b._error('content')
        } else if (!e) return b._error('href')
        c === 'image' ? b._loadImage() : c === 'ajax' ? b._loadAjax() : c === 'iframe' ? b._loadIframe() : b._afterLoad()
      }
    },
    _error: function (a) {
      f.extend(b.coming, {
        type: 'html',
        autoWidth: !0,
        autoHeight: !0,
        minWidth: 0,
        minHeight: 0,
        scrolling: 'no',
        hasError: a,
        content: b.coming.tpl.error
      })
      b._afterLoad()
    },
    _loadImage: function () {
      var a = b.imgPreload = new Image()
      a.onload = function () {
        this.onload = this.onerror = null
        b.coming.width = this.width / b.opts.pixelRatio
        b.coming.height = this.height / b.opts.pixelRatio
        b._afterLoad()
      }
      a.onerror = function () {
        this.onload = this.onerror = null
        b._error('image')
      }
      a.src = b.coming.href
      !0 !== a.complete && b.showLoading()
    },
    _loadAjax: function () {
      var a = b.coming
      b.showLoading()
      b.ajaxLoad = f.ajax(f.extend({}, a.ajax, {
        url: a.href,
        error: function (a, e) {
          b.coming && e !== 'abort' ? b._error('ajax', a) : b.hideLoading()
        },
        success: function (d, e) {
          e === 'success' && (a.content = d, b._afterLoad())
        }
      }))
    },
    _loadIframe: function () {
      var a = b.coming
      var d = f(a.tpl.iframe.replace(/\{rnd\}/g, (new Date()).getTime())).attr('scrolling', s ? 'auto' : a.iframe.scrolling).attr('src', a.href)
      f(a.wrap).on('onReset', function () {
        try {
          f(this).find('iframe').hide().attr('src', '//about:blank').end().empty()
        } catch (a) {
        }
      })
      a.iframe.preload && (b.showLoading(), d.one('load', function () {
        f(this).data('ready', 1)
        s || f(this).on('load.fb', b.update)
        f(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show()
        b._afterLoad()
      }))
      a.content = d.appendTo(a.inner)
      a.iframe.preload || b._afterLoad()
    },
    _preloadImages: function () {
      var a = b.group
      var d = b.current
      var e = a.length
      var c = d.preload ? Math.min(d.preload, e - 1) : 0
      var f
      var g
      for (g = 1; g <= c; g += 1) f = a[(d.index + g) % e], f.type === 'image' && f.href && ((new Image()).src = f.href)
    },
    _afterLoad: function () {
      var a = b.coming
      var d = b.current
      var e
      var c
      var k
      var g
      var h
      b.hideLoading()
      if (a && !1 !== b.isActive) {
        if (!1 === b.trigger('afterLoad', a, d)) { a.wrap.stop(!0).trigger('onReset').remove(), b.coming = null } else {
          d && (b.trigger('beforeChange', d), d.wrap.stop(!0).removeClass('fancybox-opened').find('.fancybox-item, .fancybox-nav').remove())
          b.unbindEvents()
          e = a.content
          c = a.type
          k = a.scrolling
          f.extend(b, { wrap: a.wrap, skin: a.skin, outer: a.outer, inner: a.inner, current: a, previous: d })
          g = a.href
          switch (c) {
            case 'inline':
            case 'ajax':
            case 'html':
              a.selector ? e = f('<div>').html(e).find(a.selector) : t(e) && (e.data('fancybox-placeholder') || e.data('fancybox-placeholder', f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()), e = e.show().detach(), a.wrap.on('onReset', function () {
                f(this).find(e).length && e.hide().replaceAll(e.data('fancybox-placeholder')).data('fancybox-placeholder', !1)
              }))
              break
            case 'image':
              e = a.tpl.image.replace('{href}', g)
              break
            case 'swf':
              e = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + g + '"></param>', h = '', f.each(a.swf, function (a, b) {
                e += '<param name="' + a + '" value="' + b + '"></param>'
                h += ' ' + a + '="' + b + '"'
              }), e += '<embed src="' + g + '" type="application/x-shockwave-flash" width="100%" height="100%"' + h + '></embed></object>'
          }
          (!t(e) || !e.parent().is(a.inner)) && a.inner.append(e)
          b.trigger('beforeShow')
          a.inner.css('overflow', k === 'yes' ? 'scroll' : k === 'no' ? 'hidden' : k)
          b._setDimension()
          b.reposition()
          b.isOpen = !1
          b.coming = null
          b.bindEvents()
          if (b.isOpened) {
            if (d.prevMethod) b.transitions[d.prevMethod]()
          } else f('.fancybox-wrap').not(a.wrap).stop(!0).trigger('onReset').remove()
          b.transitions[b.isOpened ? a.nextMethod : a.openMethod]()
          b._preloadImages()
        }
      }
    },
    _setDimension: function () {
      var a = b.getViewport()
      var d = 0
      var e = !1
      var c = !1
      var e = b.wrap
      var k = b.skin
      var g = b.inner
      var h = b.current
      var c = h.width
      var j = h.height
      var m = h.minWidth
      var u = h.minHeight
      var n = h.maxWidth
      var p = h.maxHeight
      var s = h.scrolling
      var q = h.scrollOutside ? h.scrollbarWidth : 0
      var x = h.margin
      var y = l(x[1] + x[3])
      var r = l(x[0] + x[2])
      var v
      var z
      var t
      var C
      var A
      var F
      var B
      var D
      var H
      e.add(k).add(g).width('auto').height('auto').removeClass('fancybox-tmp')
      x = l(k.outerWidth(!0) - k.width())
      v = l(k.outerHeight(!0) - k.height())
      z = y + x
      t = r + v
      C = E(c) ? (a.w - z) * l(c) / 100 : c
      A = E(j) ? (a.h - t) * l(j) / 100 : j
      if (h.type === 'iframe') {
        if (H = h.content, h.autoHeight && H.data('ready') === 1) {
          try {
            H[0].contentWindow.document.location && (g.width(C).height(9999), F = H.contents().find('body'), q && F.css('overflow-x', 'hidden'), A = F.outerHeight(!0))
          } catch (G) {
          }
        }
      } else if (h.autoWidth || h.autoHeight) g.addClass('fancybox-tmp'), h.autoWidth || g.width(C), h.autoHeight || g.height(A), h.autoWidth && (C = g.width()), h.autoHeight && (A = g.height()), g.removeClass('fancybox-tmp')
      c = l(C)
      j = l(A)
      D = C / A
      m = l(E(m) ? l(m, 'w') - z : m)
      n = l(E(n) ? l(n, 'w') - z : n)
      u = l(E(u) ? l(u, 'h') - t : u)
      p = l(E(p) ? l(p, 'h') - t : p)
      F = n
      B = p
      h.fitToView && (n = Math.min(a.w - z, n), p = Math.min(a.h - t, p))
      z = a.w - y
      r = a.h - r
      h.aspectRatio ? (c > n && (c = n, j = l(c / D)), j > p && (j = p, c = l(j * D)), c < m && (c = m, j = l(c / D)), j < u && (j = u, c = l(j * D))) : (c = Math.max(m, Math.min(c, n)), h.autoHeight && h.type !== 'iframe' && (g.width(c), j = g.height()), j = Math.max(u, Math.min(j, p)))
      if (h.fitToView) if (g.width(c).height(j), e.width(c + x), a = e.width(), y = e.height(), h.aspectRatio) { for (; (a > z || y > r) && (c > m && j > u) && !(d++ > 19);) j = Math.max(u, Math.min(p, j - 10)), c = l(j * D), c < m && (c = m, j = l(c / D)), c > n && (c = n, j = l(c / D)), g.width(c).height(j), e.width(c + x), a = e.width(), y = e.height() } else c = Math.max(m, Math.min(c, c - (a - z))), j = Math.max(u, Math.min(j, j - (y - r)))
      q && (s === 'auto' && j < A && c + x + q < z) && (c += q)
      g.width(c).height(j)
      e.width(c + x)
      a = e.width()
      y = e.height()
      e = (a > z || y > r) && c > m && j > u
      c = h.aspectRatio ? c < F && j < B && c < C && j < A : (c < F || j < B) && (c < C || j < A)
      f.extend(h, {
        dim: { width: w(a), height: w(y) },
        origWidth: C,
        origHeight: A,
        canShrink: e,
        canExpand: c,
        wPadding: x,
        hPadding: v,
        wrapSpace: y - k.outerHeight(!0),
        skinSpace: k.height() - j
      })
      !H && (h.autoHeight && j > u && j < p && !c) && g.height('auto')
    },
    _getPosition: function (a) {
      var d = b.current
      var e = b.getViewport()
      var c = d.margin
      var f = b.wrap.width() + c[1] + c[3]
      var g = b.wrap.height() + c[0] + c[2]
      var c = {
        position: 'absolute',
        top: c[0],
        left: c[3]
      }
      d.autoCenter && d.fixed && !a && g <= e.h && f <= e.w ? c.position = 'fixed' : d.locked || (c.top += e.y, c.left += e.x)
      c.top = w(Math.max(c.top, c.top + (e.h - g) * d.topRatio))
      c.left = w(Math.max(c.left, c.left + (e.w - f) * d.leftRatio))
      return c
    },
    _afterZoomIn: function () {
      var a = b.current
      a && (b.isOpen = b.isOpened = !0, b.wrap.css('overflow', 'visible').addClass('fancybox-opened'), b.update(), (a.closeClick || a.nextClick && b.group.length > 1) && b.inner.css('cursor', 'pointer').on('click.fb', function (d) {
        !f(d.target).is('a') && !f(d.target).parent().is('a') && (d.preventDefault(), b[a.closeClick ? 'close' : 'next']())
      }), a.closeBtn && f(a.tpl.closeBtn).appendTo(b.skin).on('click.fb', function (a) {
        a.preventDefault()
        b.close()
      }), a.arrows && b.group.length > 1 && ((a.loop || a.index > 0) && f(a.tpl.prev).appendTo(b.outer).on('click.fb', b.prev), (a.loop || a.index < b.group.length - 1) && f(a.tpl.next).appendTo(b.outer).on('click.fb', b.next)), b.trigger('afterShow'), !a.loop && a.index === a.group.length - 1 ? b.play(!1) : b.opts.autoPlay && !b.player.isActive && (b.opts.autoPlay = !1, b.play()))
    },
    _afterZoomOut: function (a) {
      a = a || b.current
      f('.fancybox-wrap').trigger('onReset').remove()
      f.extend(b, {
        group: {},
        opts: {},
        router: !1,
        current: null,
        isActive: !1,
        isOpened: !1,
        isOpen: !1,
        isClosing: !1,
        wrap: null,
        skin: null,
        outer: null,
        inner: null
      })
      b.trigger('afterClose', a)
    }
  })
  b.transitions = {
    getOrigPosition: function () {
      var a = b.current
      var d = a.element
      var e = a.orig
      var c = {}
      var f = 50
      var g = 50
      var h = a.hPadding
      var j = a.wPadding
      var m = b.getViewport()
      !e && (a.isDom && d.is(':visible')) && (e = d.find('img:first'), e.length || (e = d))
      t(e) ? (c = e.offset(), e.is('img') && (f = e.outerWidth(), g = e.outerHeight())) : (c.top = m.y + (m.h - g) * a.topRatio, c.left = m.x + (m.w - f) * a.leftRatio)
      if (b.wrap.css('position') === 'fixed' || a.locked) c.top -= m.y, c.left -= m.x
      return c = {
        top: w(c.top - h * a.topRatio),
        left: w(c.left - j * a.leftRatio),
        width: w(f + j),
        height: w(g + h)
      }
    },
    step: function (a, d) {
      var e
      var c
      var f = d.prop
      c = b.current
      var g = c.wrapSpace
      var h = c.skinSpace
      if (f === 'width' || f === 'height') e = d.end === d.start ? 1 : (a - d.start) / (d.end - d.start), b.isClosing && (e = 1 - e), c = f === 'width' ? c.wPadding : c.hPadding, c = a - c, b.skin[f](l(f === 'width' ? c : c - g * e)), b.inner[f](l(f === 'width' ? c : c - g * e - h * e))
    },
    zoomIn: function () {
      var a = b.current
      var d = a.pos
      var e = a.openEffect
      var c = e === 'elastic'
      var k = f.extend({ opacity: 1 }, d)
      delete k.position
      c ? (d = this.getOrigPosition(), a.openOpacity && (d.opacity = 0.1)) : e === 'fade' && (d.opacity = 0.1)
      b.wrap.css(d).animate(k, {
        duration: e === 'none' ? 0 : a.openSpeed,
        easing: a.openEasing,
        step: c ? this.step : null,
        complete: b._afterZoomIn
      })
    },
    zoomOut: function () {
      var a = b.current
      var d = a.closeEffect
      var e = d === 'elastic'
      var c = { opacity: 0.1 }
      e && (c = this.getOrigPosition(), a.closeOpacity && (c.opacity = 0.1))
      b.wrap.animate(c, {
        duration: d === 'none' ? 0 : a.closeSpeed,
        easing: a.closeEasing,
        step: e ? this.step : null,
        complete: b._afterZoomOut
      })
    },
    changeIn: function () {
      var a = b.current
      var d = a.nextEffect
      var e = a.pos
      var c = { opacity: 1 }
      var f = b.direction
      var g
      e.opacity = 0.1
      d === 'elastic' && (g = f === 'down' || f === 'up' ? 'top' : 'left', f === 'down' || f === 'right' ? (e[g] = w(l(e[g]) - 200), c[g] = '+=200px') : (e[g] = w(l(e[g]) + 200), c[g] = '-=200px'))
      d === 'none' ? b._afterZoomIn() : b.wrap.css(e).animate(c, {
        duration: a.nextSpeed,
        easing: a.nextEasing,
        complete: b._afterZoomIn
      })
    },
    changeOut: function () {
      var a = b.previous
      var d = a.prevEffect
      var e = { opacity: 0.1 }
      var c = b.direction
      d === 'elastic' && (e[c === 'down' || c === 'up' ? 'top' : 'left'] = (c === 'up' || c === 'left' ? '-' : '+') + '=200px')
      a.wrap.animate(e, {
        duration: d === 'none' ? 0 : a.prevSpeed,
        easing: a.prevEasing,
        complete: function () {
          f(this).trigger('onReset').remove()
        }
      })
    }
  }
  b.helpers.overlay = {
    defaults: { closeClick: !0, speedOut: 200, showEarly: !0, css: {}, locked: !s, fixed: !0 },
    overlay: null,
    fixed: !1,
    el: f('html'),
    create: function (a) {
      a = f.extend({}, this.defaults, a)
      this.overlay && this.close()
      this.overlay = f('<div class="fancybox-overlay"></div>').appendTo(b.coming ? b.coming.parent : a.parent)
      this.fixed = !1
      a.fixed && b.defaults.fixed && (this.overlay.addClass('fancybox-overlay-fixed'), this.fixed = !0)
    },
    open: function (a) {
      var d = this
      a = f.extend({}, this.defaults, a)
      this.overlay ? this.overlay.off('.overlay').width('auto').height('auto') : this.create(a)
      this.fixed || (n.on('resize.overlay', f.proxy(this.update, this)), this.update())
      a.closeClick && this.overlay.on('click.overlay', function (a) {
        if (f(a.target).hasClass('fancybox-overlay')) return b.isActive ? b.close() : d.close(), !1
      })
      this.overlay.css(a.css).show()
    },
    close: function () {
      var a, b
      n.off('resize.overlay')
      this.el.hasClass('fancybox-lock') && (f('.fancybox-margin').removeClass('fancybox-margin'), a = n.scrollTop(), b = n.scrollLeft(), this.el.removeClass('fancybox-lock'), n.scrollTop(a).scrollLeft(b))
      f('.fancybox-overlay').remove().hide()
      f.extend(this, { overlay: null, fixed: !1 })
    },
    update: function () {
      var a = '100%'
      var b
      this.overlay.width(a).height('100%')
      I ? (b = Math.max(G.documentElement.offsetWidth, G.body.offsetWidth), p.width() > b && (a = p.width())) : p.width() > n.width() && (a = p.width())
      this.overlay.width(a).height(p.height())
    },
    onReady: function (a, b) {
      var e = this.overlay
      f('.fancybox-overlay').stop(!0, !0)
      e || this.create(a)
      a.locked && (this.fixed && b.fixed) && (e || (this.margin = p.height() > n.height() ? f('html').css('margin-right').replace('px', '') : !1), b.locked = this.overlay.append(b.wrap), b.fixed = !1)
      !0 === a.showEarly && this.beforeShow.apply(this, arguments)
    },
    beforeShow: function (a, b) {
      var e, c
      b.locked && (!1 !== this.margin && (f('*').filter(function () {
        return f(this).css('position') === 'fixed' && !f(this).hasClass('fancybox-overlay') && !f(this).hasClass('fancybox-wrap')
      }).addClass('fancybox-margin'), this.el.addClass('fancybox-margin')), e = n.scrollTop(), c = n.scrollLeft(), this.el.addClass('fancybox-lock'), n.scrollTop(e).scrollLeft(c))
      this.open(a)
    },
    onUpdate: function () {
      this.fixed || this.update()
    },
    afterClose: function (a) {
      this.overlay && !b.coming && this.overlay.fadeOut(a.speedOut, f.proxy(this.close, this))
    }
  }
  b.helpers.title = {
    defaults: { type: 'float', position: 'bottom' },
    beforeShow: function (a) {
      var d = b.current
      var e = d.title
      var c = a.type
      f.isFunction(e) && (e = e.call(d.element, d))
      if (q(e) && f.trim(e) !== '') {
        d = f('<div class="fancybox-title fancybox-title-' + c + '-wrap">' + e + '</div>')
        switch (c) {
          case 'inside':
            c = b.skin
            break
          case 'outside':
            c = b.wrap
            break
          case 'over':
            c = b.inner
            break
          default:
            c = b.skin, d.appendTo('body'), I && d.width(d.width()), d.wrapInner('<span class="child"></span>'), b.current.margin[2] += Math.abs(l(d.css('margin-bottom')))
        }
        d[a.position === 'top' ? 'prependTo' : 'appendTo'](c)
      }
    }
  }
  f.fn.fancybox = function (a) {
    var d
    var e = f(this)
    var c = this.selector || ''
    var k = function (g) {
      var h = f(this).blur()
      var j = d
      var k
      var l
      !g.ctrlKey && (!g.altKey && !g.shiftKey && !g.metaKey) && !h.is('.fancybox-wrap') && (k = a.groupAttr || 'data-fancybox-group', l = h.attr(k), l || (k = 'rel', l = h.get(0)[k]), l && (l !== '' && l !== 'nofollow') && (h = c.length ? f(c) : e, h = h.filter('[' + k + '="' + l + '"]'), j = h.index(this)), a.index = j, !1 !== b.open(h, a) && g.preventDefault())
    }
    a = a || {}
    d = a.index || 0
    !c || !1 === a.live ? e.off('click.fb-start').on('click.fb-start', k) : p.undelegate(c, 'click.fb-start').delegate(c + ':not(\'.fancybox-item, .fancybox-nav\')', 'click.fb-start', k)
    this.filter('[data-fancybox-start=1]').trigger('click')
    return this
  }
  p.ready(function () {
    var a, d
    f.scrollbarWidth === v && (f.scrollbarWidth = function () {
      var a = f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body')
      var b = a.children()
      var b = b.innerWidth() - b.height(99).innerWidth()
      a.remove()
      return b
    })
    if (f.support.fixedPosition === v) {
      a = f.support
      d = f('<div style="position:fixed;top:20px;"></div>').appendTo('body')
      var e = d[0].offsetTop === 20 || d[0].offsetTop === 15
      d.remove()
      a.fixedPosition = e
    }
    f.extend(b.defaults, { scrollbarWidth: f.scrollbarWidth(), fixed: f.support.fixedPosition, parent: f('body') })
    a = f(r).width()
    J.addClass('fancybox-lock-test')
    d = f(r).width()
    J.removeClass('fancybox-lock-test')
    f('<style type=\'text/css\'>.fancybox-margin{margin-right:' + (d - a) + 'px;}</style>').appendTo('head')
  })
})(window, document, jQuery)

/* -------------------------------
 * Every Day I'm Instagrammin'
 * http://everydayiminstagrammin.stephenscaff.com
 * Version: 1.0
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2015, Stephen Scaff
 * http://sosweetcreative.com
 * http://stephenscaff.com
 *
 *------------------------------- */
/*
!(function ($) {
  $.everydayImInstagrammin = {
    defaults: {
      clientID: 'null',
      accessToken: 'null',
      numberPics: '12',
      imgClass: 'everyday-img',
      sequenceFadeIn: 'true',
      sequenceDuration: '220',
      captions: 'false',
      captionAlign: 'bottom',
      instaType: 'instaUser'
    }
  }, $.fn.extend({
    everydayImInstagrammin: function (a) {
      return $.extend($.everydayImInstagrammin.defaults, a), this.each(function () {
        var e = $(this)
        var t = a.clientID
        var n = a.accessToken
        var s = a.numberPics
        var i = a.imgClass
        var c = a.sequenceFadeIn
        var o = a.sequenceDuration
        var r = a.captionAlign
        var l = a.hashTag
        var d = 'https://api.instagram.com/v1/users/' + t + '/media/recent/?access_token=' + n + '&callback=?'
        a.instaType === 'byHash' && (d = 'https://api.instagram.com/v1/tags/' + l + '/media/recent/?access_token=' + n + '&callback=?'), $.ajax({
          type: 'GET',
          dataType: 'jsonp',
          cache: !1,
          url: d,
          success: function (t) {
            for (var n = 0; n < a.numberPics; n++) {
              if (t.data[n].hasOwnProperty('caption')) {
                var s = ''
                t.data[n].caption !== null && (s = t.data[n].caption.text), e.append('<li class=\'everyday-item\'><a target=\'_blank\' href=\'' + t.data[n].link + '\'><img class=\'' + a.imgClass + '\' src=\'' + t.data[n].images.standard_resolution.url + '\' alt=\'\' /><div class=\'everyday-caption\'><p>' + s + '</p></div></a></li>')
              } else e.append('<li class=\'everyday-item\'><a target=\'_blank\' href=\'' + t.data[n].link + '\'><img class=\'' + a.imgClass + '\' src=\'' + t.data[n].images.standard_resolution.url + '\' alt=\'\' /></a></li>')
            }
            if (a.captionAlign === 'bottom' && $('.everyday-caption p').css({
              position: 'absolute',
              bottom: '10px'
            }), a.captionAlign === 'top' && $('.everyday-caption p').css({
              position: 'absolute',
              top: '10px'
            }), a.sequenceFadeIn === 'true') {
              var c = 0
              $('.' + i).hide().each(function () {
                $(this).delay(c).fadeIn(500), c += o
              })
            }
            $('li.everyday-item a').on({
              mouseenter: function () {
                $('.everyday-caption', this).filter(':not(:animated)').fadeIn(400)
              },
              mouseleave: function () {
                $('.everyday-caption', this).fadeOut(400)
              }
            })
          }
        })
      })
    }
  })
}(jQuery))

// initialization of Instagram plugin
$('.instagram-feed').everydayImInstagrammin({
  clientID: '1422364139',
  accessToken: '1422364139.f69e29e.ce16d77ae7cc48e290551f7ab9fa94e2',
  numberPics: '4',
  imgClass: 'insta-img',
  captions: 'true',
  captionAlign: 'bottom',
  sequenceFadeIn: 'true',
  sequenceDuration: 300
});
*/

/*
 * Tweetie: A simple Twitter feed plugin
 * Author: Sonny T. <hi@sonnyt.com>, sonnyt.com
 * */
/*
(function ($) {
  $.fn.twittie = function (options) {
    // Default settings
    var settings = $.extend({
      count: 10,
      hideReplies: false,
      dateFormat: '%b/%d/%Y',
      template: '{{date}} - {{tweet}}'
    }, options)

    /!**
     * Applies @reply, #hash and http links
     * @param  {String} tweet A single tweet
     * @return {String}       Fixed tweet
     *!/
    var linking = function (tweet) {
      var twit = tweet.replace(/(https?:\/\/([-\w\.]+)+(:\d+)?(\/([\w\/_\.]*(\?\S+)?)?)?)/ig, '<a href="$1" target="_blank" title="Visit this link">$1</a>')
        .replace(/#([a-zA-Z0-9_]+)/g, '<a href="https://twitter.com/search?q=%23$1&amp;src=hash" target="_blank" title="Search for #$1">#$1</a>')
      // .replace(/@([a-zA-Z0-9_]+)/g,'<a href="https://twitter.com/$1" target="_blank" title="$1 on Twitter">@$1</a>');

      return twit
    }

    /!**
     * Formating a date
     * @param  {String} twt_date Twitter date
     * @return {String}          Formatted date
     *!/
    var dating = function (twt_date) {
      // fix for IE
      var time = twt_date.split(' ')
      twt_date = new Date(Date.parse(time[1] + ' ' + time[2] + ', ' + time[5] + ' ' + time[3] + ' UTC'))

      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

      var _date = {
        '%d': twt_date.getDate(),
        '%m': twt_date.getMonth() + 1,
        '%b': months[twt_date.getMonth()].substr(0, 3),
        '%B': months[twt_date.getMonth()],
        '%y': String(twt_date.getFullYear()).slice(-2),
        '%Y': twt_date.getFullYear()
      }

      var date = settings.dateFormat
      var format = settings.dateFormat.match(/%[dmbByY]/g)

      for (var i = 0, len = format.length; i < len; i++) {
        date = date.replace(format[i], _date[format[i]])
      }

      return date
    }

    /!**
     * Templating a tweet using '{{ }}' braces
     * @param  {Object} data Tweet details are passed
     * @return {String}      Templated string
     *!/
    var templating = function (data) {
      var temp = settings.template
      var temp_variables = ['date', 'tweet', 'avatar']

      for (var i = 0, len = temp_variables.length; i < len; i++) {
        temp = temp.replace(new RegExp('{{' + temp_variables[i] + '}}', 'gi'), data[temp_variables[i]])
      }

      return temp
    }

    // Set loading
    this.html('<span>Loading...</span>')

    var that = this

    // Fetch tweets
    $.getJSON('/media/api/tweet.php', {
      count: settings.count,
      exclude_replies: settings.hideReplies
    }, function (twt) {
      that.find('span').fadeOut('fast', function () {
        that.html('<ul></ul>')

        for (var i = 0; i < settings.count; i++) {
          if (twt[i]) {
            var temp_data = {
              date: dating(twt[i].created_at),
              tweet: '<div class="description">' + linking(twt[i].full_text) + '</div>',
              avatar: '<img src="' + twt[i].user.profile_image_url + '" />'
            }

            that.find('ul').append('<li><div class="col-inner">' + templating(temp_data) + '</div></li>')
          } else {
            break
          }
        }
      })
    })
  }
})(jQuery)

// initialization of twitter feed plugin
// http://stackoverflow.com/a/920322
$.fn.exists = function () {
  return this.length !== 0
}
if ($('.twitter-feed').exists()) {
  $('.twitter-feed').twittie({
    dateFormat: '%b %d',
    template: '<div class="date">{{date}}</div> {{tweet}} ',
    count: 4
  })
}
*/

/*
setTimeout(function () {
  $('.instagram-feed .everyday-item:nth-child(1)').contents().appendTo('.media-box-2 .media-box-inner')
  $('.instagram-feed .everyday-item:nth-child(2)').contents().appendTo('.media-box-4 .media-box-inner')
  $('.instagram-feed .everyday-item:nth-child(3)').contents().appendTo('.media-box-5 .media-box-inner')
  $('.instagram-feed .everyday-item:nth-child(4)').contents().appendTo('.media-box-7 .media-box-inner')

  $('.media-block .twitter-feed li:nth-child(1) .col-inner').contents().appendTo('.media-box-1 .media-box-inner')
  $('.media-block .twitter-feed li:nth-child(2) .col-inner').contents().appendTo('.media-box-3 .media-box-inner')
  $('.media-block .twitter-feed li:nth-child(3) .col-inner').contents().appendTo('.media-box-6 .media-box-inner')
  $('.media-block .twitter-feed li:nth-child(4) .col-inner').contents().appendTo('.media-box-8 .media-box-inner')
}, 3000)
*/

/**
 * jquery-match-height master by @liabru
 * http://brm.io/jquery-match-height/
 * License: MIT
 */

;(function (factory) { // eslint-disable-line no-extra-semi
  'use strict'
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], factory)
  } else if (typeof module !== 'undefined' && module.exports) {
    // CommonJS
    module.exports = factory(require('jquery'))
  } else {
    // Global
    factory(jQuery)
  }
})(function ($) {
  /*
     *  internal
     */

  var _previousResizeWidth = -1
  var _updateTimeout = -1

  /*
     *  _parse
     *  value parse utility function
     */

  var _parse = function (value) {
    // parse value and convert NaN to 0
    return parseFloat(value) || 0
  }

  /*
     *  _rows
     *  utility function returns array of jQuery selections representing each row
     *  (as displayed after float wrapping applied by browser)
     */

  var _rows = function (elements) {
    var tolerance = 1
    var $elements = $(elements)
    var lastTop = null
    var rows = []

    // group elements by their top position
    $elements.each(function () {
      var $that = $(this)
      var top = $that.offset().top - _parse($that.css('margin-top'))
      var lastRow = rows.length > 0 ? rows[rows.length - 1] : null

      if (lastRow === null) {
        // first item on the row, so just push it
        rows.push($that)
      } else {
        // if the row top is the same, add to the row group
        if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
          rows[rows.length - 1] = lastRow.add($that)
        } else {
          // otherwise start a new row group
          rows.push($that)
        }
      }

      // keep track of the last row top
      lastTop = top
    })

    return rows
  }

  /*
     *  _parseOptions
     *  handle plugin options
     */

  var _parseOptions = function (options) {
    var opts = {
      byRow: true,
      property: 'height',
      target: null,
      remove: false
    }

    if (typeof options === 'object') {
      return $.extend(opts, options)
    }

    if (typeof options === 'boolean') {
      opts.byRow = options
    } else if (options === 'remove') {
      opts.remove = true
    }

    return opts
  }

  /*
     *  matchHeight
     *  plugin definition
     */

  var matchHeight = $.fn.matchHeight = function (options) {
    var opts = _parseOptions(options)

    // handle remove
    if (opts.remove) {
      var that = this

      // remove fixed height from all selected elements
      this.css(opts.property, '')

      // remove selected elements from all groups
      $.each(matchHeight._groups, function (key, group) {
        group.elements = group.elements.not(that)
      })

      // TODO: cleanup empty groups

      return this
    }

    if (this.length <= 1 && !opts.target) {
      return this
    }

    // keep track of this group so we can re-apply later on load and resize events
    matchHeight._groups.push({
      elements: this,
      options: opts
    })

    // match each element's height to the tallest element in the selection
    matchHeight._apply(this, opts)

    return this
  }

  /*
     *  plugin global options
     */

  matchHeight.version = 'master'
  matchHeight._groups = []
  matchHeight._throttle = 80
  matchHeight._maintainScroll = false
  matchHeight._beforeUpdate = null
  matchHeight._afterUpdate = null
  matchHeight._rows = _rows
  matchHeight._parse = _parse
  matchHeight._parseOptions = _parseOptions

  /*
     *  matchHeight._apply
     *  apply matchHeight to given elements
     */

  matchHeight._apply = function (elements, options) {
    var opts = _parseOptions(options)
    var $elements = $(elements)
    var rows = [$elements]

    // take note of scroll position
    var scrollTop = $(window).scrollTop()
    var htmlHeight = $('html').outerHeight(true)

    // get hidden parents
    var $hiddenParents = $elements.parents().filter(':hidden')

    // cache the original inline style
    $hiddenParents.each(function () {
      var $that = $(this)
      $that.data('style-cache', $that.attr('style'))
    })

    // temporarily must force hidden parents visible
    $hiddenParents.css('display', 'block')

    // get rows if using byRow, otherwise assume one row
    if (opts.byRow && !opts.target) {
      // must first force an arbitrary equal height so floating elements break evenly
      $elements.each(function () {
        var $that = $(this)
        var display = $that.css('display')

        // temporarily force a usable display value
        if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
          display = 'block'
        }

        // cache the original inline style
        $that.data('style-cache', $that.attr('style'))

        $that.css({
          display: display,
          'padding-top': '0',
          'padding-bottom': '0',
          'margin-top': '0',
          'margin-bottom': '0',
          'border-top-width': '0',
          'border-bottom-width': '0',
          height: '100px',
          overflow: 'hidden'
        })
      })

      // get the array of rows (based on element top position)
      rows = _rows($elements)

      // revert original inline styles
      $elements.each(function () {
        var $that = $(this)
        $that.attr('style', $that.data('style-cache') || '')
      })
    }

    $.each(rows, function (key, row) {
      var $row = $(row)
      var targetHeight = 0

      if (!opts.target) {
        // skip apply to rows with only one item
        if (opts.byRow && $row.length <= 1) {
          $row.css(opts.property, '')
          return
        }

        // iterate the row and find the max height
        $row.each(function () {
          var $that = $(this)
          var style = $that.attr('style')
          var display = $that.css('display')

          // temporarily force a usable display value
          if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
            display = 'block'
          }

          // ensure we get the correct actual height (and not a previously set height value)
          var css = { display: display }
          css[opts.property] = ''
          $that.css(css)

          // find the max height (including padding, but not margin)
          if ($that.outerHeight(false) > targetHeight) {
            targetHeight = $that.outerHeight(false)
          }

          // revert styles
          if (style) {
            $that.attr('style', style)
          } else {
            $that.css('display', '')
          }
        })
      } else {
        // if target set, use the height of the target element
        targetHeight = opts.target.outerHeight(false)
      }

      // iterate the row and apply the height to all elements
      $row.each(function () {
        var $that = $(this)
        var verticalPadding = 0

        // don't apply to a target
        if (opts.target && $that.is(opts.target)) {
          return
        }

        // handle padding and border correctly (required when not using border-box)
        if ($that.css('box-sizing') !== 'border-box') {
          verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'))
          verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'))
        }

        // set the height (accounting for padding and border)
        $that.css(opts.property, (targetHeight - verticalPadding) + 'px')
      })
    })

    // revert hidden parents
    $hiddenParents.each(function () {
      var $that = $(this)
      $that.attr('style', $that.data('style-cache') || null)
    })

    // restore scroll position if enabled
    if (matchHeight._maintainScroll) {
      $(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true))
    }

    return this
  }

  /*
     *  matchHeight._applyDataApi
     *  applies matchHeight to all elements with a data-match-height attribute
     */

  matchHeight._applyDataApi = function () {
    var groups = {}

    // generate groups by their groupId set by elements using data-match-height
    $('[data-match-height], [data-mh]').each(function () {
      var $this = $(this)
      var groupId = $this.attr('data-mh') || $this.attr('data-match-height')

      if (groupId in groups) {
        groups[groupId] = groups[groupId].add($this)
      } else {
        groups[groupId] = $this
      }
    })

    // apply matchHeight to each group
    $.each(groups, function () {
      this.matchHeight(true)
    })
  }

  /*
     *  matchHeight._update
     *  updates matchHeight on all current groups with their correct options
     */

  var _update = function (event) {
    if (matchHeight._beforeUpdate) {
      matchHeight._beforeUpdate(event, matchHeight._groups)
    }

    $.each(matchHeight._groups, function () {
      matchHeight._apply(this.elements, this.options)
    })

    if (matchHeight._afterUpdate) {
      matchHeight._afterUpdate(event, matchHeight._groups)
    }
  }

  matchHeight._update = function (throttle, event) {
    // prevent update if fired from a resize event
    // where the viewport width hasn't actually changed
    // fixes an event looping bug in IE8
    if (event && event.type === 'resize') {
      var windowWidth = $(window).width()
      if (windowWidth === _previousResizeWidth) {
        return
      }
      _previousResizeWidth = windowWidth
    }

    // throttle updates
    if (!throttle) {
      _update(event)
    } else if (_updateTimeout === -1) {
      _updateTimeout = setTimeout(function () {
        _update(event)
        _updateTimeout = -1
      }, matchHeight._throttle)
    }
  }

  /*
     *  bind events
     */

  // apply on DOM ready event
  $(matchHeight._applyDataApi)

  // update heights on load and resize events
  $(window).on('load', function (event) {
    matchHeight._update(false, event)
  })

  // throttled update heights on resize events
  $(window).on('resize orientationchange', function (event) {
    matchHeight._update(true, event)
  })
})

// matches height of twocolumns divs
$('.twocolumns .news-block, .twocolumns .events-list').matchHeight()

// matches height of text grid blocks (display type on Admissions page)
$('.text-grid li').matchHeight()

$('.captioned-structured-block-grid .align').matchHeight()

setTimeout(function () {
  $('.switcher > li > a').matchHeight()
}, 1000)

// removes margin from intro block if a gray block follows it
if ($('.intro-block + .light-gray-block').length) {
  $('.intro-block').addClass('no-margin-bottom')
}

function contactPopUp () {
  setTimeout(function () {
    var el = $('.email-block')
    var elOffset = el.offset().top
    var elHeight = el.height()
    var windowHeight = $(window).height()
    var offset
    var headerHeight = $('header').height()

    if (elHeight < windowHeight) {
      offset = elOffset - ((windowHeight / 2) - (elHeight / 2))
    } else {
      offset = elOffset
    }
    var speed = 700
    $('html, body').animate({ scrollTop: offset - headerHeight }, speed)
  }, 500)

  setTimeout(function () {
    $('.questions-block .row:first-of-type .text-input:first-of-type').find('input').focus()
  }, 1300)
}

$('.questions-block .email-1').bind('click keydown', handleClickAndPress(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $('.email-block-overlay').removeClass('on')
  $('#email-1').addClass('on')
  contactPopUp()
  submitForm('email-1', 'Admissions', 'Contact from Admissions Page')
}))

$('.questions-block .email-2').bind('click keydown', handleClickAndPress(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $('.email-block-overlay').removeClass('on')
  $('#email-2').addClass('on')
  contactPopUp()
  submitForm('email-2', 'Financial Aid', 'Contact from Admissions Page')
}))

$('.email-3').bind('click keydown', handleClickAndPress(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $('.email-block-overlay').removeClass('on')
  $('#email-3').addClass('on')
  contactPopUp()
}))

$('.contact-crm').bind('click keydown', handleClickAndPress(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $('.email-block-overlay').removeClass('on')
  $('#contact-crm').addClass('on')
  contactPopUp()
}))

$('.contact-crm-1').bind('click keydown', handleClickAndPress(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $('.email-block-overlay').removeClass('on')
  $('#contact-crm-1').addClass('on')
  contactPopUp()
}))

$('.contact-crm-2').bind('click keydown', handleClickAndPress(function (e) {
  e.preventDefault()
  e.stopPropagation()
  $('.email-block-overlay').removeClass('on')
  $('#contact-crm-2').addClass('on')
  contactPopUp()
}))

$('.email-link-block .close').bind('click keydown', handleClickAndPress(function (e) {
  e.preventDefault()
  $('.email-block-overlay').removeClass('on')
}))

$('.questions-block .close').bind('click keydown', handleClickAndPress(function (e) {
  e.preventDefault()
  $('.email-block-overlay').removeClass('on')
}))

$(window).bind('click keydown', handleClickAndEscape(function () {
  $('.email-block-overlay').removeClass('on')
}))

$('.email-block').bind('click keydown', handleClickAndPress(function (e) {
  e.stopPropagation()
}))

function handleClickAndPress (myfunc) {
  return function (e) {
    if (e.type !== 'keydown' || e.keyCode === 13 || e.code === 'Enter') {
      myfunc(e)
    }
  }
}

function handleClickAndEscape (myfunc) {
  return function (e) {
    if (e.type !== 'keydown' || e.keyCode === 27 || e.code === 'Escape') {
      myfunc(e)
    }
  }
}

var submitForm = function (emailBlockOverlayId, recipient, subject) {
  // Get the form.
  var form = $('#' + emailBlockOverlayId + ' form')[0]

  addFormElement('input', 'recipient', recipient, form)
  addFormElement('input', 'subject', subject, form)

  // Get the messages div.
  var formMessages = $('#' + emailBlockOverlayId + ' .form-messages')

  // Set up an event listener for the contact form.
  $(form).submit(function (event) {
    if ($(form).attr('action')) {
      // Stop the browser from submitting the form.
      event.preventDefault()

      // Serialize the form data.
      var formData = $(form).serialize()

      // Submit the form using AJAX.
      $.ajax({
        type: 'POST',
        url: $(form).attr('action'),
        data: formData
      })
        .done(function (response) {
          // Make sure that the formMessages div has the 'success' class.
          $(formMessages).removeClass('alert-danger')
          $(formMessages).addClass('alert-success')

          // Set the message text.
          $(formMessages).text(response)

          // Clear the form.
          form.querySelectorAll('.form-control').forEach(function (node) {
            node.value = ''
          })
        })
        .fail(function (data) {
          // Make sure that the formMessages div has the 'error' class.
          $(formMessages).removeClass('success')
          $(formMessages).addClass('error')

          // Set the message text.
          if (data.responseText !== '') {
            $(formMessages).text(data.responseText)
          } else {
            $(formMessages).text('Oops! An error occurred and your message could not be sent.')
          }
        })
    }
  })
}

function addFormElement (type, name, value, target) {
  var element = document.createElement(type)
  element.setAttribute('type', 'hidden')
  element.setAttribute('id', name)
  element.setAttribute('name', name)
  element.setAttribute('value', value)
  target.appendChild(element)
}

// CDC found 20180613 at https://css-tricks.com/smooth-scrolling-accessibility/
// URL updates and the element focus is maintained
// originally found via in Update 3 on http://www.learningjquery.com/2007/10/improved-animated-scrolling-script-for-same-page-links

// filter handling for a /dir/ OR /indexordefault.page
function filterPath (string) {
  return string
    .replace(/^\//, '')
    .replace(/(index|default).[a-zA-Z]{3,4}$/, '')
    .replace(/\/$/, '')
}

var locationPath = filterPath(location.pathname)
$('a[href^="#"]:not([href="#"]).smooth').each(function () {
  var thisPath = filterPath(this.pathname) || locationPath
  var hash = this.hash
  if ($('#' + hash.replace(/#/, '')).length) {
    if (locationPath == thisPath && (location.hostname == this.hostname || !this.hostname) && this.hash.replace(/#/, '')) {
      var $target = $(hash)
      var target = this.hash
      if (target) {
        $(this).click(function (event) {
          event.preventDefault()
          $('html,body').animate({ scrollTop: $target.offset().top }, 1000, function () {
            location.hash = target
            $target.focus()
            if ($target.is(':focus')) { // checking if the target was focused
              return false
            } else {
              $target.attr('tabindex', '-1') // Adding tabindex for elements not focusable
              $target.focus() // Setting focus
            }
          })
        })
      }
    }
  }
})

// page init
jQuery(function () {
  $('.mainMenu').addClass('list-unstyled')
  // $('.mainMenu .item').addClass('sub-open-close');
  // $('.mainMenu > .item > ul').addClass('sub-slide js-slide-hidden');
  // $('.mainMenu > .item > a:not(:only-child)').addClass('sub-opener');
  // $('.mainMenu > .item > a:only-child').addClass('no-opener');
  // $('.mainMenu .sub-opener').prepend("<span class='plus-minus'></span>");

  /**
   * Fix for iOS double-tap to follow links
   *
   * References:
   * http://cssmenumaker.com/blog/solving-the-double-tap-issue-on-ios-devices
   * https://css-tricks.com/annoying-mobile-double-tap-link-issue/
   */
  $('#nav').find('a').on('click touchend', function (e) {
    var el = $(this)
    var link = el.attr('href')
    window.location = link
  })

  // initCustomForms()
  // initFixedScrollBlock()
  initInVieport()
  initTouchNav()
  initCycleCarousel()
  initPartnershipCarousel()
  initSlideShow()
  initAccordion()
  initLightbox()
  initMobileNav()
  initRetinaCover()
  initDropDownClasses()
  initCustomHover()
  // initVideoStretch()
  loadVideo()
  // if an alternative header does not exist on the page, do not implement the scroll nav functionality
  // if (!$('.alt-header').length) {
  //   initScrollLayout()
  // }
  initOpenClose()
  initScrollOpacity()
  initAnimTopBar()
  initMegaMenu()
  initSkipNavigation()
  // headerResize();
  addDataSubmenu()
  addBreadcrumbSchema()
  setCaptions()
  setCarouselActive()
  setInfoBlockImageHeight()
})

// if an alternative header exists on the page, clone section nav and add to breadcrumb bar
/* if ($(".alt-header").length) {
    $(".open-close").clone().appendTo(".open-close-wrapper");
} */

/* $(window).resize(function () {
    delay(function () {
        headerResize();
    }, 100)
}); */

$('.search-for-location').click(function (e) {
  e.preventDefault()
  $('.locations-options').slideUp()
  $('.locations-search-field').slideDown()

  setTimeout(function () {
    $('.locations-search-field .text-input:nth-child(1)').find('input').focus()
  }, 500)
})

if ($(window).width() <= 941) {
  $('.add-nav a').click(function (e) {
    e.preventDefault()
    $(this).next('ul').slideToggle()
    $(this).toggleClass('on')
  })
}

$(window).on('load resize', function () {
  initToggleMenu()

  const windowHeight = $(window).height() - 260
  if ($(window).height() <= windowHeight + 260) {
    $('.open-close .slide').css('max-height', windowHeight)
  }

  delay(function () {
    headerResize()
  }, 100)
})
